'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.SlamJam = window.SlamJam || {};
// Essenziale per calcolare bene il 100vh https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
var currentWidth = window.innerWidth;
var vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', vh + 'px');

window.addEventListener('resize', function () {
    if (currentWidth == window.innerWidth) {
        //window width is not changed
        return;
    }
    currentWidth = window.innerWidth;
});

window.addEventListener('resize', function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
});

SlamJam.isSafariBrowser = function () {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
};

// prevent the default iphone zoom
if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    window.document.addEventListener('touchmove', function (e) {
        if (e.scale !== 1) {
            e.preventDefault();
        }
    }, { passive: false });
}
//identifica se è crawel di google
SlamJam.UserCrawelGoogle = function () {
    var botPattern = "(googlebot\/|Googlebot-Image)";
    var re = new RegExp(botPattern, 'i');
    var userAgent = navigator.userAgent;

    if (re.test(userAgent)) {
        return true;
    } else {
        return false;
    }
};

/**
 * Check Elememtn visible in Viewport
 */
$.fn.isInViewport = function () {
    var offsetTopElementTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    var elementTop = $(this).offset().top + offsetTopElementTop;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

SlamJam.generateString = function () {
    var lenghth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    var charactersLength = characters.length;

    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
};

SlamJam.validateEmail = function (email) {
    if (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()\.,;\s@\"]+\.{0,1})+([^<>()\.,;:\s@\"]{2,}|[\d\.]+))$/.test(email)) {
        return true;
    }

    return false;
};

SlamJam.isAdmin = function () {
    var isCustomizing = false;

    if (window.location !== window.parent.location) {
        isCustomizing = true;
    }

    return isCustomizing;
};

SlamJam.getUrlVars = function () {
    var vars = [],
        hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');

    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }

    return vars;
};

/**
 * Verifica se sono in un dispositivo mobile
 * * Se "useUseAgent" == false controllo solo la width della finestra
 * @param {number} width
 * @param {boolean} useUseAgent
 */
SlamJam.isMobile = function (width) {
    var useUseAgent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var isMobile = false;

    if (useUseAgent == true) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || $(window).width() <= width) {
            isMobile = true;
        }
    } else if ($(window).width() <= width) {
        isMobile = true;
    }

    return isMobile;
};

/**
 * Verifica se la finestra è minore del valore "width"
 * @param {number} width
 */
SlamJam.widthMinusFrom = function (width) {
    return $(window).width() <= width;
};

/**
 * Imposto i settings di default per i la funzione HoverIntent
 */
SlamJam.getHoverIntentDefaultConfig = function () {
    var config = {
        sensitivity: 6, // number = sensitivity threshold (must be 1 or higher)
        interval: 14, // number = milliseconds for onMouseOver polling interval
        over: function over() {}, // function = onMouseOver callback (REQUIRED)
        timeout: 190, // number = milliseconds delay before onMouseOut
        out: function out() {}
    };

    return config;
};

/**
 * In base alla stringa strType determina se il prodotto è di tipo preorder, utile nella PDP nel carrello etc...
 * @param {*} strType
 */
SlamJam.isProductPreorder = function (strType) {
    return strType == 'preorder';
};

// Show error form ajax request
SlamJam.showPopUpErrorFromAjaxRequest = function (XMLHttpRequest) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
        if (data.status == 422 || data.status == "bad_request") {
            SlamJam.showPopUpError(data.description);
        }
    }
};

// Show popup general error
SlamJam.showPopUpError = function (message) {
    $("#errors").find('.popup-content').html(message);
    $("#errors").addClass('active');
    SlamJam.closeModal();
};

/**
 * Detect str is Json
 */
SlamJam.isJson = function (str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        console.warn('NOT JSON', e);
        return false;
    }
};

SlamJam.pageRedirect = function (section) {
    window.location.href = "https://" + Shopify.shop + section;
};

/****************************
 *  BEGIN LOADING GENERICO
 ****************************/
/**
 * Visualizza il General Loading
 *
 * @param {*} e evento da cui è stata richiamata la funzione
 * @param {string} pars Handle del loading desiderato
 */
SlamJam.onShowloading = function (e, pars) {
    if (pars.handle in SlamJam.loading) {
        SlamJam.loading[pars.handle].show();
    }
};
/**
 * Nasconde il loading generico
 *
 * @param {*} e evento da cui è stata richiamata la funzione
 * @param {string} pars Handle del loading desiderato
 */
SlamJam.onHideloading = function (e, pars) {
    if (pars.handle in SlamJam.loading) {
        SlamJam.loading[pars.handle].hide();
    }
};
/*** END LOADING GENERICO ***/

/**
 * Chiude la modal, se esistono più modal nella stessa pagina, applica le regole a tutte.
 */
SlamJam.closeModal = function (reload, preventClose) {
    var $menu = $('.modal__content');
    var $parentModal = $('.modal');
    var $divSelectTwoText = 'select2-search__field';
    var $divSelectTwoScroll = 'select2-results__options';

    if (preventClose) {
        $(document).mouseup(function (e) {
            if (!$menu.is(e.target) && $menu.has(e.target).length === 0 && !$(e.target).hasClass($divSelectTwoText) && !$(e.target).hasClass($divSelectTwoScroll)) {
                if ($parentModal.hasClass('active')) {
                    $parentModal.removeClass('active');
                    $('body').trigger('enableBodyScroll', ['#PageContainer']);
                }
                if (reload) {
                    location.reload();
                }
            }
        });
    }

    $('.js-modal-close').on('click', function (e) {
        $('.modal').removeClass('active');
        if (!$('.shop-by-look-products').hasClass('visible')) {
            $('body').trigger('enableBodyScroll', ['#PageContainer']);
        }if (reload) {
            location.reload();
        }
    });
};

/**
 * Sort delle taglie a frontend, secondo le schiere indicate nel customize
 */
SlamJam.sortSize = function (item, wrapper, productSelector) {
    var sizesRangeClothing = SlamJam.settings.sortingUtilities.clothingSizeSeparator ? SlamJam.settings.sortingUtilities.clothingSizeSeparator : '';
    var sizesRangeShoe = SlamJam.settings.sortingUtilities.shoeSizeSeparator ? SlamJam.settings.sortingUtilities.shoeSizeSeparator : '';
    var sizesRangeAccessory = SlamJam.settings.sortingUtilities.accessorySizeSeparator ? SlamJam.settings.sortingUtilities.accessorySizeSeparator : '';

    var rangeClothing = sizesRangeClothing.split('|');
    var rangeShoe = sizesRangeShoe.split('|');
    var rangeAccessory = sizesRangeAccessory.split('|');

    var clothingSizesFormatted = [];
    var shoeSizesFormatted = [];
    var accessorySizesFormatted = [];

    $.each(rangeClothing, function (index, value) {
        var limits = value.split(',');

        clothingSizesFormatted.push(limits);
    });

    $.each(rangeShoe, function (index, value) {
        var rangesSizeSplitted = value.split('=');
        var limits = rangesSizeSplitted[1].split(',');

        shoeSizesFormatted.push(limits);
    });

    $.each(rangeAccessory, function (index, value) {
        var limits = value.split(',');

        accessorySizesFormatted.push(limits);
    });

    $(productSelector).each(function () {
        var product = $(this);
        var isNumeric = true;

        // let department = product.data('category');
        var department = product.data('category') ? product.data('category').toLowerCase() : null;

        // Controllo tutte le taglie per verificare che non siano valori numerici ma con scale taglie ad-hoc come 00 o 0
        product.find(item).each(function () {
            if (!$.isNumeric($(this).data('size')) && $(this).data('size') != '0' && $(this).data('size') != '00') {
                isNumeric = false;
            }
        });

        // Se tutte le taglie sono di tipo numerico, posso ordinarle numericamente
        if (isNumeric) {
            product.find(item).sort(function (a, b) {
                var sizeA = parseFloat($(a).attr('data-size'));
                var sizeB = parseFloat($(b).attr('data-size'));

                return sizeA - sizeB;
            }).appendTo(product.find(wrapper));
        } else {
            // Altrimenti analizzo il department del prodotto, prendo la prima taglia e la ricerco nelle scale taglie inserite nel customize
            var firstVariant = product.find(item).first().data('size') + '';
            var sortArray = false;

            if (department == 'clothing') {
                clothingSizesFormatted.forEach(function (clothingSizeFormatted) {
                    if (clothingSizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = clothingSizeFormatted;
                    }
                });
            } else if (department == 'footwear') {
                shoeSizesFormatted.forEach(function (shoeSizeFormatted) {
                    if (shoeSizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = shoeSizeFormatted;
                    }
                });
            } else if (department == 'accessories') {
                accessorySizesFormatted.forEach(function (accessorySizeFormatted) {
                    if (accessorySizeFormatted.indexOf(firstVariant) > -1) {
                        sortArray = accessorySizeFormatted;
                    }
                });
            }

            if (sortArray) {
                // Ordino le varianti a seconda della scala taglia selezionata
                product.find(item).sort(function (a, b) {
                    var sizeA = $(a).data('size') + '';
                    var sizeB = $(b).data('size') + '';

                    return sortArray.indexOf(sizeA) - sortArray.indexOf(sizeB);
                }).appendTo(product.find(wrapper));
            }
        }
    });
};

SlamJam.KlarnaUpdate = function () {}
// console.log("klarnaChanged");
// window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
// window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });


/**
 * Inizializzazione generale del progetto SlamJam
 */
;SlamJam.init = function () {
    //Init Hello Bar
    SlamJam.checkMotivatorBar = new CheckMotivatorBar();
    SlamJam.helloBarTop = new HelloBar('#helloBarTop');

    SlamJam.helloBarBottom = new HelloBar('#helloBarBottom');
    //Scheda prodotto della PDP no QuickView
    if (typeof ProductTemplate == "function") {
        /**
         * IMPORTANT the third parameter must always indicate the product type, to make the add to cart button work correctly based on the product type
         */
        SlamJam.ProductTemplate = new ProductTemplate($('#PDPContainer'), $('#product-related-container'), $('#PDPContainer').data('product-type'));
        SlamJam.ProductTemplate = new ProductTemplate($('.af-1'), $('#product-related-container'), $('#PDPContainer').data('product-type'));
    }

    //Menu
    SlamJam.topMenu = new TopMenu();
    SlamJam.mobileMenu = new MobileMenu();
    SlamJam.footerMenu = new FooterMenu();
    SlamJam.searchbtn = new Search();
    SlamJam.quickview = new QuickView();
    SlamJam.productCard = new ProductCard();
    SlamJam.storefrontApi = new StoreFrontApi();
    SlamJam.countdown = new Countdown();
    SlamJam.rafflemodal = new RaffleModal();
    SlamJam.rafflemanagement = new RaffleManagement();
    SlamJam.raffleMilan = new RaffleMilan();
    SlamJam.brands = new Brands();
    SlamJam.cart = new Cart();
    SlamJam.shogun = new Shogun();
    SlamJam.blog = new Blog();
    SlamJam.collection = new Collection();
    SlamJam.minicart.init();
    SlamJam.newsletter = new Newsletter();
    SlamJam.returnPageManagement = new ReturnPageManagement();
    SlamJam.shippingMessagePDP = new ShippingMessagePDP();
    SlamJam.comingSoon = new comingSoon();

    //se ho submittato form newsletter
    if (document.querySelector('.newsletter-successfully') && window.location.href.indexOf("customer_posted=true") > -1) {
        SlamJam.postNewsletterSubmit = new PostNewsletterSubmit();
    }

    if (template == 'product.af1-black') {
        SlamJam.af1PageBlack = new Af1PageBlack();
    }

    if (template == 'product.af1') {
        SlamJam.af1Page = new Af1Page();
    }

    if (SlamJam.strings.dropInstance == false) {
        SlamJam.antavo = new Antavo();
    }

    if (SlamJam.strings.dropInstance == false) {
        if (template == "product") {
            SlamJam.shopByLook = new ShopByLook();
        }
    }

    // verifico se sono nella pagina di optin newsletter e se NON sono in customize.
    if (window.location.href.indexOf("/account/subscribe?token=") > -1 && window.Shopify.designMode != true) {
        SlamJam.customOptinNewsletterPage = new customOptinNewsletterPage();
    }

    if (template == 'cart') {
        SlamJam.cartCheckShipLocation = new CartCheckShipLocation();
    }

    // Set the same rule on theme.liquid for inclusion scripts
    if (template && template != 'page.shogun.default' && (template.search('collection') !== -1 || template.search('search') !== -1)) {
        SlamJam.filters = new Filters();
    }

    // se sono in drop vado a caricare i filtri nella homepage perchè essa stessa è una collection
    if (template == "index" && SlamJam.strings.dropInstance == true) {
        SlamJam.filters = new Filters();
    }

    // Block Scroll On Event
    $('body').on('disableBodyScroll', function (e, targetElement) {
        scrollLock.disablePageScroll(document.querySelector(targetElement));
    });

    $('body').on('enableBodyScroll', function (e, targetElement) {
        scrollLock.enablePageScroll(document.querySelector(targetElement));
    });

    //Inizializzazione oggetti Accordion presenti nella pagina prodotto
    if ($('.btn-accordion.with-content', '#product-details-accordion').length > 0) {
        //Creo l'accodion con il primo tab aperto, e con l'opzione canCollapseActivePanel a false per non far si che non si possa chiudere il tab aperto
        if (template == "product") {
            SlamJam.productDetailsAccordion = new AccordionController(1, { canCollapseActivePanel: true });
        }

        //Aggiunge all'AccordionController tutte le voci
        $('.btn-accordion.with-content', '#product-details-accordion').each(function (index, item) {
            if (template == "product") {
                SlamJam.productDetailsAccordion.add($(item));
            }
        });

        //Ricalcolo lo sticky del box informazioni, con il contenuto dell'accordion per far in modo che il contenuto non vada a finire sopra al footer
        $('body').on('product-template-accordion-open-after', function () {
            SlamJam.ProductTemplate.stickyRecalc();
        });
    }

    /**
     * Inizializzazione dei loading presenti nel sistema
     * * Posso avere più loading  Es. tutto schermo, load minicart
     * * Ogni loading corrisponde ad un elemento dell'array, la cui chiave viene prelevata dall'attributo data-handle che deve essere univoco in tutto il sito.
     */
    SlamJam.loading = [];

    if ($('.loading-wrapper ').length > 0) {
        $('.loading-wrapper ').each(function (index, item) {
            SlamJam.loading[$(item).data('handle')] = new Loading($(item));
        });
    }

    //Init dei componenti se non sono in Admin
    if (!SlamJam.isAdmin()) {

        if (window.location.host == 'www.slamjam.com') {
            location.host = "slamjam.com";
        }

        var _popupRedirect = new PopupRedirect();
    }

    //Intercettazione eventi del body relativi al Loading generico a tutto schermo
    $('body').on('show-loading', SlamJam.onShowloading);
    $('body').on('hide-loading', SlamJam.onHideloading);

    if (typeof Customer == 'function') {
        SlamJam.customer = new Customer();
    }

    // Detect is account page
    if ($('#PageContainer').length == 1) {

        if ($('.site-header__mainmenu.submenu').hasClass("hide")) {
            if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                $('.sorting--mobile').addClass("hide-submenu");
            } else {
                $('#PageContainer').addClass("hide-submenu");
            }
        }
        if ($('#PageContainer').hasClass('page-type-customers-login')) {
            SlamJam.CustomerLoginFormForgotPassword = new FormForgotPassword($('#forgotPassword'));
            SlamJam.CustomerLoginFormLogin = new FormLoginUser($('#CustomerLoginForm'));
        }

        if ($('#PageContainer').hasClass('page-type-customers-register')) {
            SlamJam.CustomerLoginFormRegister = new FormCreateUser($('#customer__register-form'));
        }

        if (window.location.href.indexOf("/pages/register-milano") > -1 || window.location.href.indexOf("/pages/register-ferrara") > -1) {
            SlamJam.CustomerLoginFormRegister = new FormCreateUser($('#customer__register-form'));
        }

        if ($('#PageContainer').hasClass('page-type-customers-activate_account')) {
            SlamJam.CustomerActivateAccount = new FormCreateUser($('#customer__active-form'));
            // $('.activate_form').validate();
        }

        if ($('#PageContainer').hasClass('page-type-customers-reset_password')) {
            SlamJam.CustomerResetPassword = new FormResetPassword($('#customer__reset-password-form'));
        }
    }

    SlamJam.JsSelect = {};

    $('.js-select').each(function (e) {
        SlamJam.JsSelect[$(this).attr('name')] = new JsSelect($(this));
    });
};

/**
 * Avvia l'obsever per gestire i messaggi che dovranno comparire nelle Hello Bar
 *
 * Verifica le injection dei banner inseriti dall'app Gestione banner
 *
 * * Intercetta injecting nel DOM
 * * Preleva il testo e lo ignetta nella Hello Bar
 */

var CheckMotivatorBar = function () {
    function CheckMotivatorBar() {
        var initOnCreate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        _classCallCheck(this, CheckMotivatorBar);

        this.initHelloBarExecuted = false;

        if (initOnCreate === true) {
            this.init();
        }
    }

    _createClass(CheckMotivatorBar, [{
        key: 'init',
        value: function init() {
            //Se l'observer esiste già lo disconnetto
            if (this.observer) {
                this.observer.disconnect();
            }

            this.observer = new MutationObserver(this.mutationCallBack.bind(this));
            //Imposta i settings del'observer
            var config = {
                attributes: false,
                childList: true,
                subtree: false,
                characterData: false
            };

            this.observer.observe(document.body, config);
        }

        /**
        * APP Geo Targeting - Notify pop-ups
        * Verifica se il banner è di tipo "top of page"
        */

    }, {
        key: 'isBannerTopOfPage',
        value: function isBannerTopOfPage(node) {

            if ($(node).attr('id')) {
                if ($(node).find('.yeps-text') && $(node).find('.yeps-text').html()) {
                    return true;
                }
            }

            return false;
        }

        //Aggiunge il messaggio alle HelloBar

    }, {
        key: 'addMessaggeToHelloBars',
        value: function addMessaggeToHelloBars(message) {
            if (SlamJam.helloBarTop.exists) {
                SlamJam.helloBarTop.addMessageHtml(message);
            }

            if (SlamJam.helloBarBottom.exists) {
                SlamJam.helloBarBottom.addMessageHtml(message);
            }
        }
    }, {
        key: 'addCountdownToHelloBars',
        value: function addCountdownToHelloBars(htmlButton) {
            if (SlamJam.helloBarTop.exists) {
                SlamJam.helloBarTop.addCountdownToMessageHtml(htmlButton);
            }

            if (SlamJam.helloBarBottom.exists) {
                SlamJam.helloBarBottom.addCountdownToMessageHtml(htmlButton);
            }
        }

        /*
        addButtonToHelloBars(htmlButton) {
            if (SlamJam.helloBarTop.exists) {
                SlamJam.helloBarTop.addButtonToMessageHtml(htmlButton)
            }
             if (SlamJam.helloBarBottom.exists) {
                SlamJam.helloBarBottom.addButtonToMessageHtml(htmlButton)
            }
        }
        */

        /**
         * Inizializza gli oggetti HelloBar
         */

    }, {
        key: 'initHelloBars',
        value: function initHelloBars() {
            if (!this.initHelloBarExecuted) {
                this.initHelloBarExecuted = true;
                SlamJam.helloBarTop.init();
                SlamJam.helloBarBottom.init();
            }
        }
    }, {
        key: 'mutationCallBack',
        value: function mutationCallBack(mutations) {
            var disconnect = false;
            var exitsHelloBar = false;
            var self = this;

            mutations.forEach(function (mutation) {
                if (mutation.type == 'childList') {
                    mutation.addedNodes.forEach(function (node) {
                        // Se il messaggio è Top of Page, crea le helloBar e rimuove il nodo dal dom
                        if (self.isBannerTopOfPage(node)) {
                            var geoText = '';
                            var geoButton = '';
                            var countDown = '';

                            if ($(node).find('.yeps-bar').length == 1) {
                                $($(node).find('.yeps-content')).each(function (message) {
                                    // controllo tipo messaggio, se countdown
                                    if ($('.yeps-bar').find('.yeps-countdown-block').length) {
                                        countDown = $('.yeps-bar').find('.yeps-countdown-block').html();
                                        //self.addCountdownToHelloBars(countDown);
                                        setInterval(function () {
                                            self.addCountdownToHelloBars(countDown);
                                        }, 1000);
                                    } else {
                                        geoText = $(this).html();
                                        self.addMessaggeToHelloBars(geoText);
                                    }
                                });
                            }

                            // Rimuove il nodo dal dom
                            $(node).hide();

                            disconnect = true;
                            exitsHelloBar = true;
                        }
                    });
                }

                if (exitsHelloBar) {
                    self.initHelloBars();
                }

                //Disabilito l'observer solo se una o più regole sono vere
                if (disconnect) {
                    self.observer.disconnect();
                }
            });
        }
    }]);

    return CheckMotivatorBar;
}();

/**
 * Check KiwiSizeChart added into (_dom)
 *
 * event triggered EVENT_KIWI_SIZE_CHART_ADDED after added
 */


var CheckKiwiSizeChart = function () {
    /**
     *
     * @param {*} _dom
     * @param {*} initOnCreate
     */
    function CheckKiwiSizeChart(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, CheckKiwiSizeChart);

        this.dom = _dom;
        this.EVENT_KIWI_SIZE_CHART_ADDED = 'kiwi-size-chart-added';
        this.exists = this.dom.length == 1;
        this.observer = null;

        if (initOnCreate === true) {
            this.init();
        }
    }

    _createClass(CheckKiwiSizeChart, [{
        key: 'init',
        value: function init() {
            if (!this.exists) return;

            //Se l'observer esiste già lo disconnetto
            if (this.observer) {
                this.observer.disconnect();
            }

            this.observer = new MutationObserver(this.mutationCallBack.bind(this));

            //Imposta i settings del'observer
            var config = {
                attributes: false,
                childList: true,
                subtree: false,
                characterData: false
            };

            this.observer.observe(this.dom[0], config);
        }
    }, {
        key: 'mutationCallBack',
        value: function mutationCallBack(mutations) {
            var elementAdded = false;
            var self = this;

            for (var i = 0; i < mutations.length; i++) {
                var mutation = mutations[i];

                if (mutation.type == "childList") {
                    elementAdded = true;
                    break;
                }
            };

            //Disabilito l'observer solo se una o più regole sono vere
            if (elementAdded) {
                $(self).trigger(self.EVENT_KIWI_SIZE_CHART_ADDED);
                self.disconnect();
            }
        }

        // Disconnect observer

    }, {
        key: 'disconnect',
        value: function disconnect() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }
    }]);

    return CheckKiwiSizeChart;
}();

/**
 * Classe Base per i Menu
 */


var Menu = function () {
    /**
     *
     * @param {*} class_menu_container
     * @param {*} class_menu_item_level1
     * @param {*} class_menu_item_level2
     * @param {*} class_megamenu_container
     */
    function Menu(class_menu_container, class_menu_item_level1, class_menu_item_level2, class_megamenu_container) {
        _classCallCheck(this, Menu);

        //
        this.classMenuContainer = class_menu_container;
        this.classMegaMenuContainer = class_megamenu_container;
        this.classMenuContainerLevel1 = "level1";
        this.classMenuContainerLevel2 = "level2";
        this.classMenuItemLevel1 = class_menu_item_level1;
        this.classMenuItemLevel2 = class_menu_item_level2;
        this.classMenuActive = "is-active";
        this.classSubMenuActive = "is-active";
        this.classMegaMenuActive = "is-active";
        this.classMegaMenuOpen = "is-open";

        this.menuOpen = false;
        this.menuContainer = $(this.getClassMenuContainerLevel(1));
        this.menuItems = this.menuContainer.find(this.getClassMenuItem());

        this.subMenuWrapper = $(".site-header__mainmenu.submenu");
        this.megaMenuWrapper = $(".site-header__mainmenu.megamenu");
        this.subMenuContainer = $(this.getClassMenuContainerLevel(2));
        this.megaMenuContainer = $(this.getClassMegaMenuContainer());
        this.subMenuItems = this.subMenuContainer.find(this.getClassSubMenuItem());

        this.sectionMenuActive = this.menuContainer.find(this.getClassMenuActive());
        this.currentMenuActive = this.sectionMenuActive;

        this.currentSubMenuActive = null; //SubMenu attualmente visualizzato
        this.subMenuFoceToClose = null; //Viene salvato il Menu attivo da chiudere quando esco dal div contenitore del megamenu

        //
        this.addEventHandler();
    }

    _createClass(Menu, [{
        key: 'isOpen',
        value: function isOpen() {
            return this.menuOpen;
        }

        /**
         * Estrae la classe CSS per il contanier degli elementi del menu di primo e secondo livello
         * @param {integer} level
         */

    }, {
        key: 'getClassMenuContainerLevel',
        value: function getClassMenuContainerLevel(level) {
            var strClass = "";
            switch (level) {
                case 1:
                    strClass = this.classMenuContainer + ' .' + this.classMenuContainerLevel1;
                    break;

                case 2:
                    strClass = this.classMenuContainer + ' .' + this.classMenuContainerLevel2;
                    break;

                default:
                    console.error('Menu -> getClassMenuContainerLevel () -> level not managed');
                    strClass = "";
                    break;
            }

            return strClass;
        }
    }, {
        key: 'getClassMenuItem',
        value: function getClassMenuItem() {
            return this.classMenuItemLevel1;
        }
    }, {
        key: 'getClassSubMenuItem',
        value: function getClassSubMenuItem() {
            return this.classMenuItemLevel2;
        }
    }, {
        key: 'getClassMenuActive',
        value: function getClassMenuActive() {
            return '.' + this.classMenuActive;
        }
    }, {
        key: 'getClassMegaMenuContainer',
        value: function getClassMegaMenuContainer() {
            return this.classMegaMenuContainer;
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            this.menuContainer.on('mouseenter', function (e) {
                $(this).addClass('mouseover');
            });

            this.menuContainer.on('mouseleave', function (evt1) {
                $(this).addClass('mouseover');
            });
        }
    }]);

    return Menu;
}();

/**
 * Top Menu Object
 */


var TopMenu = function (_Menu) {
    _inherits(TopMenu, _Menu);

    function TopMenu() {
        _classCallCheck(this, TopMenu);

        /**
         * Il menu Top è sempre aperto di default alla prima voce
         */

        var _this = _possibleConstructorReturn(this, (TopMenu.__proto__ || Object.getPrototypeOf(TopMenu)).call(this, ".site-header__mainmenu", ".menu-items__item.opensubmenu", ".menu-items__item", '.site-header__mainmenu.megamenu'));

        _this.menuOpen = true;
        _this.menuIdPrefix = "parent_menu_";
        _this.megaMmenuIdPrefix = "parent_menu_level2_";
        _this.self = _this;
        return _this;
    }

    /**
     * Estrae dal DOM il SubMenu desiderato
     * @param {integer} id
     */


    _createClass(TopMenu, [{
        key: 'getSubmenuById',
        value: function getSubmenuById(id) {
            return $('#' + this.menuIdPrefix + id).length > 0 ? $('#' + this.menuIdPrefix + id) : null;
        }

        /**
         * Estrae dal DOM Il megaMenuDesiderato
         * @param {integer} id
         */

    }, {
        key: 'getMegaMenuById',
        value: function getMegaMenuById(id) {
            return $("#" + this.megaMmenuIdPrefix + id);
        }

        /**
         * Nasconde il menu di secondo livello
         * @param {*} _menuItem
         */

    }, {
        key: 'hideSubMenu',
        value: function hideSubMenu(_menuItem) {
            _menuItem.removeClass(this.classSubMenuActive);
            var menuId = _menuItem.data('menu-id');

            if (menuId) {
                this.getSubmenuById(menuId).removeClass(this.classSubMenuActive);
            }
        }

        /**
         * Nasconde il MegaMenu
         * @param {*} _subMenuItem
         */

    }, {
        key: 'hideMegaMenu',
        value: function hideMegaMenu(_subMenuItem) {
            if (_subMenuItem) {
                _subMenuItem.removeClass(this.classMegaMenuOpen);
                this.megaMenuContainer.removeClass(this.classMegaMenuOpen);
                var menuId = _subMenuItem.data('menu-id');

                if (menuId) {
                    this.getMegaMenuById(menuId).removeClass(this.classMegaMenuOpen);
                }

                //_subMenuItem.removeClass(this.classMegaMenuActive);
            }
        }

        /**
         * Visualizza il menu desiderto
         *
         * @param {jQuery} _menuItem  Item di Livello 1 del menu
         */

    }, {
        key: 'showSubMenu',
        value: function showSubMenu(_menuItem) {
            //Nasconte il MegaMenu visualizato realtivo al submenu visualizzato
            this.hideMegaMenu(this.currentSubMenuActive);

            //Visualizza il submenuRichiesto
            _menuItem.addClass(this.classSubMenuActive);
            var menuId = _menuItem.data('menu-id');

            if (menuId) {
                var subMenu = this.getSubmenuById(menuId);

                if (subMenu) {
                    subMenu.addClass(this.classSubMenuActive);
                }
            }

            this.currentMenuActive = _menuItem;
        }

        /**
         * Visualizza il subMenu desiderato
         *
         * @param {jQuery} _menuItem  Item di Livello 1 del menu
         */

    }, {
        key: 'showMegaMenu',
        value: function showMegaMenu(_subMenuItem) {
            var menuId = _subMenuItem.data('menu-id');

            //_subMenuItem.addClass(this.classMegaMenuActive);

            if (menuId) {
                this.getMegaMenuById(menuId).addClass(this.classMegaMenuOpen);

                if (this.getMegaMenuById(menuId).length > 0) {
                    _subMenuItem.addClass(this.classMegaMenuOpen);
                    this.megaMenuContainer.addClass(this.classMegaMenuOpen);
                }
            }

            this.currentSubMenuActive = _subMenuItem;
        }

        /**
         * Visualizza il SubMenu all'over intent del menù di Livello 1
         * @param {*} e
         */

    }, {
        key: 'showSubMenuFromIntent',
        value: function showSubMenuFromIntent(e) {
            //Nasconte il menu attualmente visualizato
            this.hideSubMenu(this.currentMenuActive);

            //Visualizza il menu desiderato
            this.showSubMenu($(e.currentTarget));
        }

        /**
         * Visualizza il MegaMenu all'over intent sul menù di Livello 2
         * @param {*} e
         */

    }, {
        key: 'showMegaMenuFromIntent',
        value: function showMegaMenuFromIntent(e) {
            if (this.subMenuFoceToClose) {
                this.currentSubMenuActive = this.subMenuFoceToClose;
                this.subMenuFoceToClose = null;
            }

            //Nasconde il MegaMenu Attualmente visualizzato
            this.hideMegaMenu(this.currentSubMenuActive);

            //Visualizza il MegaMenu desiderato
            this.showMegaMenu($(e.currentTarget));
        }

        /**
         * Rende visbili il menu di Livello 1 ed il SubMenu di Levello 2 corrispodenti alla pagina attualmente visualizzata
         * @param {*} e
         */

    }, {
        key: 'resetMenu',
        value: function resetMenu(e) {
            //Nasconte il MegaMenu attualmente visualizato
            this.hideMegaMenu(this.currentSubMenuActive);
            //Visualizzo Livello1 e Livello2 solo se il menu corrente attivo è diverso dalla sezione corrente da visualizzare
            if (this.currentMenuActive.data('menu-id') !== this.sectionMenuActive.data('menu-id')) {
                this.hideSubMenu(this.currentMenuActive);
                this.showSubMenu(this.sectionMenuActive);
            }
        }

        /**
         * Imposta tutte le varibiali utili nel addEventHandler
         */

    }, {
        key: 'presetVariabile',
        value: function presetVariabile() {
            this.siteHeader = $(".site-header.desktop");
        }
    }, {
        key: 'addEventHandlerHeader',
        value: function addEventHandlerHeader() {
            var config = SlamJam.getHoverIntentDefaultConfig();
            config.interval = 30;
            config.out = this.resetMenu.bind(this);
            this.siteHeader.hoverIntent(config);
        }
    }, {
        key: 'addEventHandlerMenu',
        value: function addEventHandlerMenu() {
            var config = SlamJam.getHoverIntentDefaultConfig();
            config.interval = 30;
            config.sensitivity = 2;
            config.over = this.showSubMenuFromIntent.bind(this);
            this.menuItems.hoverIntent(config);
        }
    }, {
        key: 'addEventHandlerSubMenu',
        value: function addEventHandlerSubMenu() {
            var config = SlamJam.getHoverIntentDefaultConfig();
            config.interval = 30;
            config.sensitivity = 2;
            config.over = this.showMegaMenuFromIntent.bind(this);
            this.subMenuItems.hoverIntent(config);
        }

        /**
         * Add All handler
        */

    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            _get(TopMenu.prototype.__proto__ || Object.getPrototypeOf(TopMenu.prototype), 'addEventHandler', this).call(this);
            //
            this.presetVariabile();
            this.addEventHandlerHeader();
            this.addEventHandlerMenu();
            this.addEventHandlerSubMenu();
        }
    }]);

    return TopMenu;
}(Menu);

/**
 * Mobile Menu Object
 */

var MobileMenu = function () {
    function MobileMenu() {
        _classCallCheck(this, MobileMenu);

        this.self = this;
        this.menuOpen = false;
        this.btnOpenMenu = $('#menu-mobile-btn');
        this.menuMobileContainer = $('.menu-mobile-container'); // General container, menu panels
        this.navBackWrapper = $('#nav-back-wrapper'); // Container   this.btnNavBack
        this.btnNavBack = $('#btn-nav-back'); // Btn to nav Back on menu panels
        this.linkOpenSubMenu = $('.site-header__item.open-submenu'); // only menu items that have a submenu
        this.closeMobileMenu = $('.menu-mobile-container .nav-close');
        /**
         * Livello di visualizzazione 0,1,2 in base al pannello aperto
         */
        this.level = 0;

        /**
         * Contiene i riferimenti ai pannelli aperti dei menu
         */
        this.currentPanelShow = [];
        this.previousPanel = [];

        this.addEventHandler();
    }

    /**
     * Add All handler
    */

    _createClass(MobileMenu, [{
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            // CLick on Link Open Menu
            this.btnOpenMenu.on('click', function (e) {
                e.preventDefault();
                self.showMegaMenu(!self.menuOpen);
            });

            // Click on item, open specific panel
            this.linkOpenSubMenu.on('click', function (e) {
                e.preventDefault();
                self.showPanel($(this).data('panel-id'), $(this).html());
            });

            // back to previous Panel menu
            this.btnNavBack.on('click', function (e) {
                e.preventDefault();
                self.back();
            });
            //close megamenu icon
            this.closeMobileMenu.on('click', function (e) {
                e.preventDefault();
                self.showMegaMenu(!self.menuOpen);
            });
        }

        /**
         * Visualizzazione pannello con il menu specifico obj
         * @param {string} idPanel
         */

    }, {
        key: 'showPanel',
        value: function showPanel(idPanel, value) {
            // Panel to show
            var panelShow = this.menuMobileContainer.find('#' + idPanel);

            panelShow.addClass('is-open');
            this.currentPanelShow.push(panelShow); // Add Panel
            this.previousPanel.push(value.trim());

            this.setLevel(this.currentPanelShow.length);
            this.disaplyNavBack(value.trim());

            scrollLock.addScrollableTarget(panelShow[0]);
        }

        /**
         * Chiude l'attuale menu visibile
         */

    }, {
        key: 'back',
        value: function back() {
            //console.log(this.previousPanel);
            this.previousPanel.pop();
            //console.log(this.previousPanel);
            this.hidePanel(this.currentPanelShow.pop());
            this.setLevel(this.currentPanelShow.length);
            this.disaplyNavBack(this.previousPanel.pop());
        }

        /**
         * Imposta il livello di menu visualizzato in bae 0
         * @param {integer} _level
         */

    }, {
        key: 'setLevel',
        value: function setLevel(_level) {
            this.level = _level;
        }

        /**
         * Visualizza o Nasconde il tasto BACK del menu in base alla variabile level
         */

    }, {
        key: 'disaplyNavBack',
        value: function disaplyNavBack(value) {
            if (this.level < 1) {
                this.navBackWrapper.removeClass('show');
            } else {
                this.btnNavBack.html(value);
                this.navBackWrapper.addClass('show');
            }
        }
    }, {
        key: 'hidePanel',
        value: function hidePanel(panel) {
            panel.removeClass('is-open');
        }

        /**
         * Visualizza / Nasconde il container del menu mobile contentente tutti i pannelli dei SubMenu
         * @param {*} show
         */

    }, {
        key: 'showMegaMenu',
        value: function showMegaMenu(show) {
            if (show) {
                this.menuMobileContainer.addClass('is-open');
                scrollLock.disablePageScroll(document.querySelector('.menu-mobile-container .menu-items'));
                $('.main-content').addClass("menu-mobile--open");
            } else {
                this.menuMobileContainer.removeClass('is-open');
                $('.main-content').removeClass("menu-mobile--open");
                scrollLock.enablePageScroll(document.querySelector('.menu-mobile-container .menu-items'));
            }

            this.menuOpen = show;
        }
    }]);

    return MobileMenu;
}();

/**
 * Menu del footer della pagina
 */


var FooterMenu = function () {
    function FooterMenu() {
        _classCallCheck(this, FooterMenu);

        this.windowWidth = $(window).width();
        this.init();
    }

    _createClass(FooterMenu, [{
        key: 'init',
        value: function init() {
            this.menuHeader = $('.site-footer__menu-title'); //Utilizzata in mobile per accordion voci di menu
            this.backToTop = $('.site-footer__back-to-top');
            this.backToTopWrapper = $('.back-to-top-wrapper'); // Contenitore del link Back To Top
            this.backToTopLink = $('#back-to-top'); // Link Back To Top
            this.panelMenuOpened = null;

            this.toggleBackToTop();
            this.addEventHandler();
        }

        /**
         * Add All handler
        */

    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            this.backToTopLink.on('click', function (e) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });

            this.menuHeader.on('click', function (e) {
                self.handlePanelMenu($(this).next());
            });

            $(window).on('resize', function (e) {
                if (self.windowWidth !== $(window).width()) {
                    // Se ho ruotato lo schermo faccio il reset animation altrimenti no.
                    self.windowWidth = $(window).width();
                    self.toggleBackToTop();
                }
            });
        }
    }, {
        key: 'accordionActive',
        value: function accordionActive() {
            return SlamJam.isMobile(SlamJam.costants.grid_medium, false);
        }
    }, {
        key: 'handlePanelMenu',
        value: function handlePanelMenu(panel) {
            if (this.accordionActive()) {
                $('.site-footer__menu .column ul').not(panel).removeClass('is-open');

                if (panel.hasClass('is-open')) {
                    panel.removeClass('is-open');
                } else {
                    panel.addClass('is-open');
                }
            }
        }

        /**
         * Il Link Back to top si nasconde solo dui desktop se i contenuti non scrollano nella pagina, e lascia sempre visibile la HelloBarBottom
         */

    }, {
        key: 'toggleBackToTop',
        value: function toggleBackToTop() {
            var _this2 = this;

            // Se Il testo del copyright on rienstra nell'altezza della finesta devo gestire la Visualzizazione del BACK TO TOP
            // if ($(".site-footer__copyright").offset()["top"] + $(".site-footer__copyright").height() <= $(window).height() - $('.site-header.mobile').offset()["top"]) {
            //     //Se la risulizione è inferiore a 1200px la riga back to top deve essere vibile per le icone di pagamento e nascondo le Hello Bar
            //     if (SlamJam.widthMinusFrom(SlamJam.costants.grid_large)) {
            //         this.backToTop.show();
            //         this.backToTopLink.hide();
            //         this.backToTopWrapper.hide();
            //     } else {
            //         //Se non ci sono messaggi nascondiamo tutta la barra?
            //         //this.backToTop.hide();
            //         this.backToTop.show();
            //         this.backToTopLink.hide();
            //         this.backToTopWrapper.hide();
            //     }
            // } else {
            //     this.backToTop.show();
            //     this.backToTopWrapper.show();
            //     this.backToTopLink.show();
            // }

            //create an Observer instance
            var resizeObserver = new ResizeObserver(function (entries) {
                if ($(window).height() + 40 >= $(document).height()) {
                    _this2.backToTopLink.hide();
                    _this2.backToTopWrapper.hide();
                } else {
                    _this2.backToTopWrapper.show();
                    _this2.backToTopLink.show();
                }
            });
            // start observing a DOM node
            resizeObserver.observe(document.body);
        }
    }]);

    return FooterMenu;
}();

/**
 * Oggetto Hello Bar
 *
 * * Desktop | all Message(s) scrollDown form Top
 * * Mobile | all Message(s) Scroll Right to Left
 * *
 */


var HelloBar = function () {
    /**
     * @param {*} _idDom // ID - HelloBar Container for all Messages(s).
     */
    function HelloBar(_idDom) {
        _classCallCheck(this, HelloBar);

        this.windowWidth = $(window).width(); // Server per gestire il resize di IOS in vertivale quando si fa lo scroll, ovvero se cambia WIDHT o cambiato l'orientamento altrimenti no
        //Costants for animation
        this.ANIMATION_SCROLL_UPDOWN = "scrollUpDown";
        this.ANIMATION_SCROLL_RTL = "rightToLeft";
        //
        this.exists = false;
        this.idDom = _idDom;
        this.dom = $(_idDom);
        if (this.dom.length == 0) return;

        this.exists = true;
        this.messageWrapper = this.dom.find('.helloBar__text-wrapper');
        //Gestione dom
        this.helloBarTextContainer = this.dom.find('.helloBar__text');

        // Single Message container, populated on INIT function
        this.helloBarMessages = null;
        this.messages = []; // Array of messages set by user
        this.messageCurrentIndex = -1; // Current message visible
        this.animationCurrentType = null; // Current animation Type, used on resize condition

        this.animationInterval = 6500; // Delay start animation in milliseconds
        this.animationIntervalFirstLaunch = 500; // Delay start animation in milliseconds
        this.animationIntervalHandle = null; // Handle for setInterval funciont
        this.animationRTLtResumelHandle = null; // Handle setTimeOut resume RTL
        this.windowResizedHandle = null; // Handle for setTimeOut window resize, used to reset animation on resolution change
        // Classe che visualizza nasconde la helloBar
        this.classShow = 'helloBar__show';

        this.clearMessage();
    }

    /**
     * Init component
     * @param {boolean} startAnimation  if == true Start Animation immediatelly
     */


    _createClass(HelloBar, [{
        key: 'init',
        value: function init() {
            var startAnimation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            var self = this;

            if (!this.isExists() || this.messages.length <= 0) return false;

            this.helloBarTextContainer.empty();
            var messagesNumber = this.messages.length;
            var duplicateMessage = '';

            //Accoda i messaggi alla HelloBar
            if (messagesNumber > 1) {
                this.messages.forEach(function (e, i) {
                    // Remove "scrollUp" class to have Scroll Down effect
                    // Add "scrollUp" class to have SCroll Up Effect
                    $('<div class="helloBar__text__message scrollUp">' + e + '</div>').appendTo(self.helloBarTextContainer);
                    if (i > 0 && duplicateMessage !== '') {
                        $('<div class="helloBar__text__message scrollUp">' + duplicateMessage + '</div>').appendTo(self.helloBarTextContainer);
                    }

                    if (messagesNumber < 3) {
                        duplicateMessage = e;
                    }
                });
                if (duplicateMessage !== '') {
                    for (var i = messagesNumber; i < 3; i++) {
                        $('<div class="helloBar__text__message scrollUp">' + duplicateMessage + '</div>').appendTo(self.helloBarTextContainer);
                    }
                }
                // Set all Message(s) from DOM
                this.helloBarMessages = this.dom.find('.helloBar__text__message');
                this.addEventHandler();

                if (startAnimation) {
                    this.startAnimation();
                }
            } else {
                // Remove animation if only one message on Desktop
                $(self.helloBarTextContainer).addClass('static');
                $('<div class="helloBar__text__message">' + self.messages[0] + '</div>').appendTo(self.helloBarTextContainer);
            }
        }

        // Eventi generici

    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;
            //Pause/Play  on Hover / Out

            var enabled = false;

            if (enabled) {
                this.messageWrapper.on('mouseenter', function (e) {
                    setTimeout(function () {
                        self.pauseAnimation();
                    }, 2000);
                }).on('mouseleave', function (e) {
                    setTimeout(function () {
                        self.playAnimation();
                    }, 2000);
                });

                this.messageWrapper.on('touchstart', function (e) {
                    e.preventDefault();
                    var $target = $(e.target);

                    if ($target.closest('a').length > 0) {
                        self.pauseAnimation();
                        window.location.href = $target.closest('a').attr('href');
                    } else {
                        self.pauseAnimation();
                    }
                });

                this.messageWrapper.on('touchend', function (e) {
                    e.preventDefault();
                    self.playAnimation();
                });
            }
        }

        // Event managed if it has at least one message present

    }, {
        key: 'addEventHandlerOnWindowResize',
        value: function addEventHandlerOnWindowResize() {
            /*
            var self = this;
             //On resize reset animation
             $(window).resize(function() {
                 if (this.windowWidth !== $(window).width()) {
                    //Se ho ruotato lo schermo faccio il reset animation altrimenti no.
                    this.windowWidth = $(window).width();
                    self.resetAnimation();
                 }
            });
            */
        }
    }, {
        key: 'resetAnimation',
        value: function resetAnimation() {

            if (!this.isExists() || !this.messagesExists()) return;

            // Remove Class for prevent Blink object
            this.helloBarTextContainer.removeClass('in-animation');

            if (this.animationCurrentType !== this.getAnimationType()) {
                clearInterval(this.animationIntervalHandle);
                this.animationIntervalHandle = null;
                this.helloBarTextContainer.css('animation', 'none');

                $(this.helloBarMessages[this.messageCurrentIndex]).removeClass('is-visible').removeClass('is-ended');

                this.startAnimation();
            } else {
                // Reactive animation on container
                this.helloBarTextContainer.addClass('in-animation');
            }
        }

        /**
         * Check object exists
         */

    }, {
        key: 'isExists',
        value: function isExists() {
            return this.exists;
        }

        /**
         * Check Message exists in object
         */

    }, {
        key: 'messagesExists',
        value: function messagesExists() {
            if (this.helloBarMessages == null) {
                return false;
            }

            return this.helloBarMessages.length > 0;
        }

        /**
         * Get Animation Type for Text
         */

    }, {
        key: 'getAnimationType',
        value: function getAnimationType() {
            return this.ANIMATION_SCROLL_UPDOWN;
        }

        /**
         * Get Duration Time for , Text Animation "Calculation based on screen resolution and text Lenght".
         *
         * Calc based on time and space
         *
         * Time different for Desktop, Tablet and Mobile Resolutions
         */

    }, {
        key: 'getTime',
        value: function getTime() {
            var time = SlamJam.settings.helloBar.duration_animation_mobile;

            /*
            if ($(window).width() > SlamJam.costants.grid_large) {
                time = SlamJam.settings.helloBar.duration_animation_desktop;
            } else if ($(window).width() > SlamJam.costants.grid_medium) {
                time = SlamJam.settings.helloBar.duration_animation_tablet;
            }
            */

            return this.messageWrapper.width() * time / window.outerWidth;
        }

        /**
         * Set Animation Value(s) and Play It
         */

    }, {
        key: 'startAnimation',
        value: function startAnimation() {
            if (!this.isExists() || !this.messagesExists()) return false;

            // Prevent multiple assoc.
            this.addEventHandlerOnWindowResize();

            // Reset message animationindex
            this.messageCurrentIndex = -1;
            this.animationCurrentType = this.getAnimationType();
            this.helloBarTextContainer.addClass('in-animation');

            var self = this;
            this.animationIntervalHandle = setTimeout(function () {
                self.animationScrollUpDown();
            }, this.animationIntervalFirstLaunch);
        }

        // Animation Scroll Down

    }, {
        key: 'animationScrollUpDown',
        value: function animationScrollUpDown() {
            var self = this;

            if (this.helloBarMessages == null) return true;

            if (this.messageCurrentIndex == -1) {
                // First launch
                this.messageCurrentIndex = 0;
                $(this.helloBarMessages[this.messageCurrentIndex]).addClass('is-first').addClass('is-visible').siblings().removeClass('is-ended').removeClass('is-visible');

                // Call me on  this.animationInterval for animate all text message(s)
                this.animationScrollUpDownPlayResume();
            } else {
                // Not First launch,
                $(this.helloBarMessages[this.messageCurrentIndex]).removeClass('is-first').toggleClass('is-visible').toggleClass('is-ended').siblings().removeClass('is-ended');
                if (++this.messageCurrentIndex >= this.helloBarMessages.length) {
                    this.messageCurrentIndex = 0;
                }

                $(this.helloBarMessages[this.messageCurrentIndex]).toggleClass('is-visible');
            }
        }

        // Pause animation scroll down

    }, {
        key: 'animationScrollUpDownPause',
        value: function animationScrollUpDownPause() {
            clearInterval(this.animationIntervalHandle);
        }

        // resume animation scroll down

    }, {
        key: 'animationScrollUpDownPlayResume',
        value: function animationScrollUpDownPlayResume() {
            var afterPause = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var self = this;

            if (afterPause) {
                setTimeout(function () {
                    self.animationScrollUpDown();
                }, 500);
            }

            this.animationIntervalHandle = setInterval(function () {
                self.animationScrollUpDown();
            }, this.animationInterval);
        }

        /** GENERAL EVENT PLAY PAUSE on mouse hover*/

    }, {
        key: 'playAnimation',
        value: function playAnimation() {
            this.animationScrollUpDownPlayResume(true);
        }
    }, {
        key: 'pauseAnimation',
        value: function pauseAnimation() {
            this.animationScrollUpDownPause();
        }
    }, {
        key: 'clearMessage',
        value: function clearMessage() {
            this.messages = [];
        }

        /**
         * Crea un array di stringhe splittando il valore per spacer
         *
         * @param {string} message Stringa senza HTML jquery.text()
         * @param {string} spacer Delimintatore di testo per cui fare lo split della stringa message
         */

    }, {
        key: 'addMessageString',
        value: function addMessageString(message) {
            var spacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '<!--spacer-->';

            var self = this;
            var _messageArr = message.split(spacer);

            $(_messageArr).each(function (index, _message) {
                self.messages.push(_message);
            });
        }

        /**
         * Estrae tutti i paragrafi nel messaggio
         *
         * @param {string} message Stringa in formato HTML dentro <p></p> jquery.html()
         */

    }, {
        key: 'addMessageHtml',
        value: function addMessageHtml(_messageArr) {
            var self = this;
            // console.log(_messageArr);
            if ($(_messageArr).length > 0) {
                $(_messageArr).each(function (index, _message) {
                    self.messages.push($(_message).html());
                });
            } else {
                self.messages.push(_messageArr);
            }
        }
    }, {
        key: 'addButtonToMessageHtml',
        value: function addButtonToMessageHtml(_btn) {
            for (var j = 0; j < this.messages.length; j++) {
                this.messages[j] = this.messages[j] + " " + _btn;
            }
        }
    }, {
        key: 'addCountdownToMessageHtml',
        value: function addCountdownToMessageHtml(_btn) {
            $('.helloBar__text-wrapper .helloBar__text').each(function () {
                $(this).addClass("is-countdown").html($('.yeps-bar').html());
            });
        }
    }]);

    return HelloBar;
}();

/**
 * Singola voce dell'accordion Controller
 */


var Accordion = function () {
    function Accordion(dom) {
        var _settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Accordion);

        this.$parent = null;
        this.self = this;
        this.$dom = dom;
        this.$id = this.$dom.data("section-id");
        this.$panel = null;

        //Override dei settings standard con quelli passati dall'utente
        this.settings = $.extend(this.getDefaultSettings(), _settings);
    }

    _createClass(Accordion, [{
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                canCollapseActivePanel: true,
                class: {
                    active: 'active'
                }
            };
        }
    }, {
        key: 'getPanel',
        value: function getPanel() {
            return this.$panel;
        }
    }, {
        key: 'getDom',
        value: function getDom() {
            return this.$dom;
        }
    }, {
        key: 'getId',
        value: function getId() {
            return this.$id;
        }
    }, {
        key: 'addHandler',
        value: function addHandler() {
            var self = this;
            this.$dom.on("click", function (e) {
                self.toggle();
            });
        }
    }, {
        key: 'toggle',


        //Apre / chiude il pannello della voce
        value: function toggle() {
            if (this.$panel.css("maxHeight") !== '0px') {
                //Verifico se l'utente ha deciso di poter collassare il pannello attivo
                if (this.settings.canCollapseActivePanel) {
                    this.close();
                }
            } else {
                this.open();
            }
        }
    }, {
        key: 'close',


        //Chiude il pannello
        value: function close() {
            this.$dom.removeClass(this.settings.class.active);
            this.$parent.trigger("accordion-close-before", [this]);
            this.$panel.css("maxHeight", "0px");
            this.$parent.trigger("accordion-close-after", [this]);
        }
    }, {
        key: 'open',
        value: function open() {
            this.$dom.addClass(this.settings.class.active);

            // Trigger eventi Before
            this.$parent.trigger("accordion-open-before", [this]);
            $("body").trigger("product-template-accordion-open-before", [this]);

            this.$panel.css("maxHeight", this.$panel.prop('scrollHeight') + "px");
            this.$parent.trigger("accordion-open-after", [this]);

            // Trigger eventi After
            $("body").trigger("product-template-accordion-open-after", [this]);
        }
    }, {
        key: 'init',


        //Init
        value: function init($_parent, options) {
            this.$parent = $_parent;
            // Override defaults with arguments
            this.settings = $.extend(this.settings, options);
            this.$panel = this.$dom.next();

            this.addHandler();
        }
    }]);

    return Accordion;
}();

/**
 * Oggetto Accordion
 * Di default tutti i pannelli sono chiusi, diveramente _openPanelIndex viene settato con un  valore intero positivo, all'init verrà aperto tale pannello
 */


var AccordionController = function () {

    /**
     * @param {*} _openPanelIndex indica il pannello paerto di default indice su base 1
     * @param {*} _settings settins JSON aggiuntivi per i controller, vedi getDefaultSettings
     */
    function AccordionController() {
        var _openPanelIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var _settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, AccordionController);

        this.$accordionItems = [];
        this.totalPanel = 0;
        this.$currentItem = null;
        this.openPanelIndex = _openPanelIndex;
        self = this;

        this.settings = $.extend(this.getDefaultSettings(), _settings);

        $(this).on('accordion-open-before', function (evt, itm) {
            if (self.$currentItem && self.$currentItem !== itm) {
                self.$currentItem.close();
            }
        });

        $(this).on('accordion-open-after', function (evt, itm) {
            self.$currentItem = itm;
        });
    }

    _createClass(AccordionController, [{
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                canCollapseActivePanel: true //TRUE è possibile chiudere il pannello aperto cliccando sulla sua intestazione, altrimenti rimane aperto, utile se si vuole sempre avere un pannello aperto
            };
        }

        //Add item on accordion

    }, {
        key: 'add',
        value: function add(dom) {
            //Crea un nuovo oggetto Accordion Item
            var acc = new Accordion(dom, this.settings);
            acc.init($(this));

            //Aggiunge il nuovo oggetto al controller
            this.$accordionItems[acc.getId()] = acc;
            this.totalPanel++;

            if (this.openPanelIndex && this.totalPanel == this.openPanelIndex) {
                //Apro il pannello di default specificato in fase di creazione del Controller
                this.$accordionItems[acc.getId()].open();
            }
        }
    }]);

    return AccordionController;
}();

/**
 * Gestione DropDown Selezione varianti scheda prodotto
 */


var ProductSelectVariantShopByLook = function () {
    /**
     *
     * @param {*} parentDiv  // Contenitore padre in cui è presente la select Custom e le select del tema di default
     * @param {*} options
     */
    function ProductSelectVariantShopByLook(parentDiv, options) {
        _classCallCheck(this, ProductSelectVariantShopByLook);

        //Settings di default
        this.settings = {};
        // Override defaults with arguments
        $.extend(this.settings, options);
        // Private plugin variables
        this.self = this;
        this.parentDiv = parentDiv;
        this.dropdownContainer = this.parentDiv.find('.product-select-variant');
        this.dropdownTitle = this.dropdownContainer.find('.product-select-variant__title');
        this.dropdownItemOpenClose = this.dropdownTitle;
        this.dropdownItemOpenCloseTitle = this.dropdownItemOpenClose.find('span');
        this.dropdownContent = this.dropdownContainer.find('.product-select-variant__content');
        this.dropdownItems = this.dropdownContent.find('.product-select-variant__value');
        this.heightDropdownContainer = this.dropdownContainer.height();
        // La product select viene creata in JS e potrebbe non esserci all'inizio
        this.dropdownItemActive = null; // Elemento corrente selezionato nella dropdown
        this.defaultText = this.dropdownTitle.find('span').data('default-text'); // Di solito sarebbe 'Select size'
        this.isOpened = false; // indica se la dropdown è aperta
        // Handler degli eventi
        this.initEventHandlers();
        // Preseleziona una variante nella dropdown
        this.setActiveItem();
        // Ordinamento delle taglie
        SlamJam.sortSize('.product-select-variant__value', '.product-select-variant__list', '.product-select-variant.standard');
        SlamJam.sortSize('.product-select-variant__value', '.product-select-variant__list', '.product-select-variant.sticky');
    }

    _createClass(ProductSelectVariantShopByLook, [{
        key: 'initEventHandlers',
        value: function initEventHandlers() {
            var self = this;
            // Gestisce apertura/chiusura della dropdown
            this.dropdownItemOpenClose.on('click', function () {
                if (self.isOpened) {
                    if (self.dropdownItemActive.length > 0) {
                        self.dropdownItemActive.click();
                    } else {
                        self.closeDropdown();
                    }
                } else {
                    self.openDropdown(self.isMobile);
                }
            });
            // Gestisce click su varianti
            this.dropdownItems.on('click', function (e) {
                if ($(this).hasClass("disabled")) {
                    self.closeDropdown();
                    $(this).closest('.shop-by-look__cta').find('.add-to-cart-shop-by-look button').addClass("btn--disabled");
                    return false;
                } else {
                    $(this).siblings().removeClass('active');
                    self.dropdownItemActive = $(this);
                    if (!this.productSelect) {
                        self.productSelect = self.parentDiv.find('#' + self.dropdownContainer.data('product-select-id'));
                    }
                    self.productSelect.change();
                    self.dropdownItemOpenCloseTitle.html($(this).html());
                    self.closeDropdown();
                    $(this).closest('.shop-by-look__cta').find('.add-to-cart-shop-by-look button').removeClass("btn--disabled");
                    $(this).closest('.shop-by-look__cta').find('.add-to-cart-shop-by-look button').attr("variant-id", $(this).data('variant-id'));
                }
            });
            // Chiude i div relativi al back in stock e alle dropdown delle varianti
            $('body, #PageContainer').on('click scroll', function (e) {
                if (self.isOpened) {
                    if (!SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                        self.dropdownItemOpenClose.click();
                    } else {
                        self.closeDropdown();
                    }
                }
            });
            $(this.dropdownContainer).on('click', function (e) {
                e.stopPropagation();
            });
        }
    }, {
        key: 'openDropdown',
        value: function openDropdown(mobile) {
            this.isMobile = mobile;
            this.isOpened = true;
            this.dropdownItemOpenCloseTitle.html(this.defaultText);
            this.dropdownContent.removeClass('hide');
            this.dropdownTitle.addClass('opened');
            $(this).trigger('select-variant-dropdown-opened', [this]);
        }
    }, {
        key: 'closeDropdown',
        value: function closeDropdown() {
            this.isOpened = false;
            this.dropdownTitle.removeClass('opened');
            this.dropdownContent.addClass('hide');
            $(this).trigger('select-variant-dropdown-closed', [this]);
        }
    }, {
        key: 'setActiveItem',

        // Preseleziona una variante se trova la classe active
        value: function setActiveItem() {
            if (this.dropdownContent.find('.product-select-variant__value.active') || this.dropdownItems.length == 1) {
                this.dropdownItemActive = this.dropdownContent.find('.product-select-variant__value.active') ? this.dropdownContent.find('.product-select-variant__value.active') : this.dropdownContent.find('.product-select-variant__value');
                this.dropdownItemActive.trigger('click');
            }
        }
    }, {
        key: 'getItemsCount',
        value: function getItemsCount() {
            return this.dropdownItems.length;
        }
    }]);

    return ProductSelectVariantShopByLook;
}();

/**
 * Gestione DropDown Selezione varianti scheda prodotto
 */


var ProductSelectVariant = function () {
    /**
     *
     * @param {*} parentDiv  // Contenitore padre in cui è presente la select Custom e le select del tema di default
     * @param {*} options
     */

    function ProductSelectVariant(parentDiv, options) {
        _classCallCheck(this, ProductSelectVariant);

        //Settings di default
        this.settings = {};

        // Override defaults with arguments
        $.extend(this.settings, options);

        // Private plugin variables
        this.self = this;
        this.parentDiv = parentDiv;
        this.dropdownContainer = this.parentDiv.find('.product-select-variant');

        this.dropdownTitle = this.dropdownContainer.find('.product-select-variant__title');
        this.dropdownItemOpenClose = this.dropdownTitle;
        this.dropdownItemOpenCloseTitle = this.dropdownItemOpenClose.find('span');
        this.dropdownContent = this.dropdownContainer.find('.product-select-variant__content');
        this.dropdownItems = this.dropdownContent.find('.product-select-variant__value');

        this.heightDropdownContainer = this.dropdownContainer.height();

        // La product select viene creata in JS e potrebbe non esserci all'inizio
        this.productSelect = this.parentDiv.find('#' + this.dropdownContainer.data('product-select-id')) ? this.parentDiv.find('#' + this.dropdownContainer.data('product-select-id')) : null;

        this.dropdownItemActive = null; // Elemento corrente selezionato nella dropdown
        this.defaultText = this.dropdownTitle.find('span').data('default-text'); // Di solito sarebbe 'Select size'

        this.isOpened = false; // indica se la dropdown è aperta
        this.isMobile = false; // TODO: capire

        // Indica i div e le funzionalità da nascondere se si seleziona il back in stock o la variante non è disponibile
        this.itemsToDisable = $('body').find('.disabled-variant-not-available');

        // Handler degli eventi
        this.initEventHandlers();

        // Preseleziona una variante nella dropdown
        this.setActiveItem();

        // Ordinamento delle taglie
        SlamJam.sortSize('.product-select-variant__value', '.product-select-variant__list', '.product-select-variant.standard');
        SlamJam.sortSize('.product-select-variant__value', '.product-select-variant__list', '.product-select-variant.sticky');

        if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
            // $('.product-alerts__item--store-availability').remove();
        }
    }

    _createClass(ProductSelectVariant, [{
        key: 'initEventHandlers',
        value: function initEventHandlers() {
            var self = this;

            // Gestisce apertura/chiusura della dropdown
            this.dropdownItemOpenClose.on('click', function () {
                if (self.isOpened) {
                    if (self.dropdownItemActive.length > 0) {
                        self.dropdownItemActive.click();
                    } else {
                        self.closeDropdown();
                    }
                } else {
                    self.openDropdown(self.isMobile);
                }
            });

            if ($(window).width() <= SlamJam.costants.grid_large) {
                if ($('body').hasClass('template-product')) {
                    if ($('#avaible-product').hasClass("one-size")) {
                        var variantID = $('.product-select-variant__value').data('variant-id');
                        $.ajax({
                            url: '/variants/' + variantID + '/?section_id=store-availability',
                            type: 'GET',
                            success: function success(response) {
                                var pickupAvailabilityHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                                $('#avaible-product').remove();
                                if (pickupAvailabilityHTML != '') {
                                    $('[data-store-availability-placeholder]').after(pickupAvailabilityHTML);
                                }
                            }
                        });
                    }
                }
            }

            // Gestisce click su varianti
            this.dropdownItems.on('click', function (e) {
                $('#avaible-product').hide();
                $(this).siblings().removeClass('active');
                SlamJam.KlarnaUpdate();
                /* se è raffle ma ancora non open */
                if (!$('#AddToCart-product-template').hasClass('raffle-btn-disabled')) {
                    $(this).addClass('active');
                } else {
                    self.closeDropdown();
                    return false;
                }

                if ($('body').hasClass("add-to-cart-disabled")) {
                    self.closeDropdown();
                    $('.raffle').removeClass("show-block");
                    $('.raffle-pdp.multi .raffle-pdp__container .add-to-cart-btn-wrapper').removeClass("show-cta");
                    return false;
                }

                self.dropdownItemActive = $(this);

                if (!this.productSelect) {
                    self.productSelect = self.parentDiv.find('#' + self.dropdownContainer.data('product-select-id'));
                }

                self.productSelect.val($(this).data('value'));
                self.productSelect.change();

                if ($("html").hasClass("product-af1")) {
                    $('.product-template__af1 .add-to-cart-wrapper .product-select-variant-wrapper > .selector-wrapper select[data-option="option1"]').val($(this).data('value')).change();
                }

                self.dropdownItemOpenCloseTitle.html($(this).html());
                self.closeDropdown();

                // Gestione back in stock
                if ($(this).data('show-back-in-stock') === true) {
                    self.disableItemsIfVariantNotAvailable();
                } else {
                    self.enableItemsIfVariantNotAvailable();
                }

                // Gestione availability
                if ($(this).data('variant-id')) {
                    $.ajax({
                        url: '/variants/' + $(this).data('variant-id') + '/?section_id=store-availability',
                        type: 'GET',
                        success: function success(response) {
                            var pickupAvailabilityHTML = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                            $('.product-alerts__item--store-availability').remove();

                            if (pickupAvailabilityHTML != '') {
                                $('[data-store-availability-placeholder]').after(pickupAvailabilityHTML);
                            }
                        }
                    });
                }

                $(self).trigger('selected-variant', [this, $(this).data('variant-id')]);
            });

            // Chiude i div relativi al back in stock e alle dropdown delle varianti
            $('body, #PageContainer').on('click scroll', function (e) {
                if (self.isOpened) {
                    if (!SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                        self.dropdownItemOpenClose.click();
                    } else {
                        self.closeDropdown();
                    }
                }

                if (!self.dropdownContainer.is(e.target) && self.dropdownContainer.has(e.target).length === 0 && !self.parentDiv.is(e.target) && self.parentDiv.has(e.target).length === 0 && SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                    self.enableItemsIfVariantNotAvailable();
                }
            });

            $(this.dropdownContainer).on('click', function (e) {
                e.stopPropagation();
            });

            // Gestione success back in stock
            if (this.settings.backInStock) {
                $(this.settings.backInStock).on('BIS_response_success', function () {
                    $(self).trigger('BIS_response_success');
                });
            }

            // Gestisce check privacy back in stock
            this.parentDiv.find('.notify_privacy').on('click', function (e) {
                self.disableItemsIfVariantNotAvailable();
            });
        }
    }, {
        key: 'openDropdown',
        value: function openDropdown(mobile) {

            this.isMobile = mobile;

            this.isOpened = true;
            this.dropdownItemOpenCloseTitle.html(this.defaultText);

            this.dropdownContent.removeClass('hide');

            /*
            if (SlamJam.isMobile(SlamJam.costants.grid_medium, false)) {
                $('body').addClass('overflow-hidden');
            }
            */

            this.dropdownTitle.addClass('opened');

            $(this).trigger('select-variant-dropdown-opened', [this]);
        }
    }, {
        key: 'closeDropdown',
        value: function closeDropdown() {
            this.isOpened = false;
            if (SlamJam.isMobile(SlamJam.costants.grid_medium, false)) {
                $('body').removeClass('overflow-hidden');
            }
            this.dropdownTitle.removeClass('opened');
            this.dropdownContent.addClass('hide');

            $(this).trigger('select-variant-dropdown-closed', [this]);
        }
    }, {
        key: 'setActiveItem',


        // Preseleziona una variante se trova la classe active
        value: function setActiveItem() {
            if (this.dropdownContent.find('.product-select-variant__value.active') || this.dropdownItems.length == 1) {
                this.dropdownItemActive = this.dropdownContent.find('.product-select-variant__value.active') ? this.dropdownContent.find('.product-select-variant__value.active') : this.dropdownContent.find('.product-select-variant__value');
                this.dropdownItemActive.trigger('click');
            }
        }
    }, {
        key: 'disableItemsIfVariantNotAvailable',
        value: function disableItemsIfVariantNotAvailable() {
            this.itemsToDisable.addClass('btn--disabled').prop('disabled', true);

            if (this.settings.backInStock) {
                if (this.dropdownItemActive.val() != undefined) {
                    if (this.parentDiv.find('.notify_privacy').is(':checked')) {
                        this.settings.backInStock.show(this.dropdownItemActive.data('product-id'), this.dropdownItemActive.data('variant-id'));
                        this.settings.backInStock.btnSubmitEnabled();
                    } else {
                        this.settings.backInStock.show(this.dropdownItemActive.data('product-id'), this.dropdownItemActive.data('variant-id'));
                        this.settings.backInStock.btnSubmitDisable();
                    }
                }

                this.itemsToDisable.hide();
            }
        }
    }, {
        key: 'enableItemsIfVariantNotAvailable',
        value: function enableItemsIfVariantNotAvailable() {

            var comingSoon = this.settings.backInStock.parentDom[0].classList.contains('coming-soon');

            //se è coming soon prima del endtime NON può essere acquistato quindi deve rimanere inibito.
            if (comingSoon !== true) {
                this.itemsToDisable.removeClass('btn--disabled').prop('disabled', false);
            }

            if (this.settings.backInStock) {
                this.settings.backInStock.hide();
                this.settings.backInStock.btnSubmitDisable();
                this.itemsToDisable.show();
            }
        }
    }, {
        key: 'getItemsCount',
        value: function getItemsCount() {
            return this.dropdownItems.length;
        }
    }]);

    return ProductSelectVariant;
}();

/**
 * Gestione dei dots dello slider SLick
 */


var SlickSliderDots = function () {
    function SlickSliderDots(_slick) {
        var _classCosSlickDots = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

        var _curSlide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

        _classCallCheck(this, SlickSliderDots);

        this.slick = _slick;
        this.classCosSlickDots = _classCosSlickDots;
        this.curSlide = _curSlide;
        this.slickDots = this.getSlidkDots();
        this.setSlide(this.curSlide);
    }

    _createClass(SlickSliderDots, [{
        key: 'getSlidkDots',
        value: function getSlidkDots() {
            return this.slick.find('.' + this.classCosSlickDots);
        }

        /**
         * Estrae l'indice della slide visualizzata
         *
         * @param {boolean} zeroBased  = true ritorna l'indice in base 0
         */

    }, {
        key: 'getCurSlide',
        value: function getCurSlide() {
            var zeroBased = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (zeroBased == true) {
                return this.curSlide;
            }
            return this.curSlide + 1;
        }
    }, {
        key: 'setSlide',
        value: function setSlide(slide) {
            this.curSlide = slide;
            if (this.slickDots) {
                for (var i = 0; i < this.slickDots.length; i++) {
                    if (i <= slide) {
                        $(this.slickDots[i]).addClass('colored');
                    } else {
                        $(this.slickDots[i]).removeClass('colored');
                    }
                }
            }
        }
    }]);

    return SlickSliderDots;
}();

/**
 * Gestione del form back in stock
 *
 * * Viene visualizzato un messaggio con il risultato della chiamata in coda
 * * Viene nascosto il form se la richeista è andata a buon fine lasciando solo il messaggio in coda
 * * Viene aggiunta la classe this.cssClassError al messaggio in coda se la richiesta non è stata creata
 *
 * * Quando viene avviata la chiamata verso BIS si visualizza il loading generico
 */


var BackInStock = function () {
    /**
     *
     * @param {*} parentDom Contenitore padre del back in stock, continene poltre al form anche il contenitore BIS_response_succces per
     * @param {*} initOnCreate
     */
    function BackInStock(parentDom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, BackInStock);

        // Contenitore del Back In Stock
        this.parentDom = parentDom;
        // Contenitore del form
        this.dom = this.parentDom.find('.notify_form');

        //Imposta se l'oggetto esiste altrimenti esce
        this.exists = this.dom.length == 1;

        //Oggetti DOM
        this.form = null;
        this.formObject = {
            email: null,
            checkPrivacy: null
        };

        this.submitButton = null;
        this.bisResponseError = null;
        this.bisResponseSuccess = null;

        this.cssClassError = 'fld-error'; // CSS Class for error message
        this.cssInputClassError = 'fld-error'; // CSS Class for error message
        this.cssHideClass = "hide"; // CSS Class for error message

        if (initOnCreate == true) {
            this.init();
        }
    }

    _createClass(BackInStock, [{
        key: 'init',
        value: function init() {
            var _settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (!this.isExists()) return;

            // Get DOM elements
            this.form = this.dom.find('form');
            this.submitButton = this.dom.find('button[type="submit"]');
            this.acceptsMarketing = this.dom.find('.newsletter.notify_form__checkbox'); // Checkbox Iscrizione alla newsletter
            this.bisResponseError = this.dom.find('.BIS_response_error');
            this.bisResponseSuccess = this.parentDom.find('.BIS_response_success');

            // IDs per cui richiedere il Back In Stock
            this.idProduct = null; // ID univico del prodotto
            this.idVariant = null; // ID univoco della variante
            this.formObject.email = this.form.find('input[name="contact[email]"]');
            this.formObject.checkPrivacy = SlamJam.isMobile(SlamJam.costants.grid_large, false) ? $('input.mobile[name="contact[checkPrivacy]"]') : $('input[name="contact[checkPrivacy]"]');

            this.addEventHandler();
        }

        /**
         * Veririca se esiste il dom richiesto
         */

    }, {
        key: 'isExists',
        value: function isExists() {
            return this.exists;
        }

        /**
         * Verifica se esiste l'oggetto globale BIS dell'app
         */

    }, {
        key: 'isBISExists',
        value: function isBISExists() {
            return (typeof BIS === 'undefined' ? 'undefined' : _typeof(BIS)) !== undefined;
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            if (this.form) {
                var _self = this;

                this.formObject.checkPrivacy.on('click', function (e) {
                    _self.validateCheckbox($(e.currentTarget), SlamJam.strings.customer.register.label.privacy_field);
                });

                this.formObject.email.on('change', function () {
                    _self.validateEmail();
                });

                // Gestione submit del form
                this.form.off('submit');
                this.form.on('submit', function (e) {
                    e.preventDefault();

                    $('body').trigger('show-loading', {
                        handle: 'generic-loading'
                    });

                    if (_self.checkFormFields()) {
                        _self.createBIS();
                        return true;
                    }

                    $('body').trigger('hide-loading', {
                        handle: 'generic-loading'
                    });

                    return false;
                });
            }
        }

        /**
        * Verifica se la checkbox iscrizione newsletter è stata inserita
        */

    }, {
        key: 'checkAcceptMarketing',
        value: function checkAcceptMarketing() {
            return this.acceptsMarketing.length == 1 && this.acceptsMarketing.is(':checked');
        }

        /**
         * Crea la richiesta Back In Stock
         * * Svuota il messaggio in coda
         * * é Avvia la promise al BIS
         * * Se la chiamata ajax va in errore, nasconde il loading generico e crea un waring nella console
         */

    }, {
        key: 'createBIS',
        value: function createBIS() {
            this.setBisMessageError('');
            this.setBisMessageSuccess('');

            // Crea gli attributi extra per il BIS
            var attributes = {
                accepts_marketing: this.checkAcceptMarketing()
            };

            var bisPromise = BIS.create(this.getEmail(), this.idVariant, this.idProduct, attributes);

            bisPromise.then(this.crateBISCallBack.bind(this), function (data) {
                console.warn('Error BIS Create', data);

                $('body').trigger('hide-loading', {
                    handle: 'generic-loading'
                });
            });
        }

        /**
         * Verifica se abbiamo gestito la traduzione per il messaggio restituito dal BIS, nel caso non esiste stampiamo la stringa ricevuta
         *
         * @param {*} key Chiave relativa al messaggio (Per una chiave possiamo avere più messaggi)
         * @param {*} msg Messaggio da ricercare nella chaive Key
         */

    }, {
        key: 'matchMessageTranslation',
        value: function matchMessageTranslation(key, msg) {
            var retString = msg;

            /**
             * Veririca la chiave inviata dal BIS
             */
            if (key == "product_id") {
                if (msg === "The product_id parameter must contain the selected product id.") {
                    retString = SlamJam.strings.notify_form.message_errors.product_id.select_variant;
                }
            }

            return retString;
        }

        /**
         * Call Back richiamata dalla pronmise che invia i dati al BIS
         * @param {*} data
         */

    }, {
        key: 'crateBISCallBack',
        value: function crateBISCallBack(data) {
            var statusError = false; // Stato della risposta
            var msg = ''; // Messaggio da inserire in coda

            if (data.status == 'OK') {
                msg = data.message;
                this.setBisMessageError('');
                this.setBisMessageSuccess(SlamJam.strings.notify_form.messagge_added_success);
                this.clearFields();
            } else {
                // it was an error
                statusError = true;
                var composedMessage = '';
                for (var k in data.errors) {
                    // collect all the error messages into a string
                    if (msg.trim() != "") msg = msg + ", ";
                    /**
                     * Per i messaggi noti utilizziamo le traduzioni
                     */
                    if (k === "product_id") {
                        /** Estrate le traduzioni per tutti i messaggi ritornati dal BIS */
                        for (var im = 0; im < data.errors[k].length; im++) {
                            composedMessage += this.matchMessageTranslation(k, data.errors[k][im]);
                        }
                    } else {
                        composedMessage = data.errors[k].join() + "<br>"; // Join di tutti i  messaggi presenti nella chiave
                    }

                    msg += composedMessage;
                }

                this.setBisMessageError(msg);
                this.setBisMessageSuccess('');
            }

            // Nasconde il blocco form se la chiamata è andata a buon fine
            if (!statusError) {
                this.form.hide();
                $(this).trigger('BIS_response_success');
            }

            //Nasconde il loading generico
            $('body').trigger('hide-loading', {
                handle: 'generic-loading'
            });
        }
    }, {
        key: 'clearFields',
        value: function clearFields() {
            this.parentDom.find('input[type=email]').val('');
            this.parentDom.find('input[type=text]').val('');
            this.parentDom.find('input:checkbox').prop('checked', false);
        }

        /**
         * @param {string} msg
         */

    }, {
        key: 'setBisMessageError',
        value: function setBisMessageError(msg) {
            if (this.bisResponseError && this.bisResponseError.length == 0) return;

            this.bisResponseError.html(msg);

            if (msg.trim() !== '') {
                this.bisResponseError.show();
            } else {
                this.bisResponseError.hide();
            }
        }

        /**
         *
         * @param {*} msg
         */

    }, {
        key: 'setBisMessageSuccess',
        value: function setBisMessageSuccess(msg) {
            if (this.bisResponseSuccess && this.bisResponseSuccess.length == 0) return;
            this.bisResponseSuccess.html(msg);

            if (msg.trim() !== '') {
                this.bisResponseSuccess.show();
            } else {
                this.bisResponseSuccess.hide();
            }
        }

        /**
         * Estrae la mail inserita dall'utente nell'input
         */

    }, {
        key: 'getEmail',
        value: function getEmail() {
            if (this.formObject.email.length == 1) {
                return this.formObject.email.val();
            }

            return null;
        }

        //#region Validate Email(s)

    }, {
        key: 'validateEmail',
        value: function validateEmail() {
            var errors = false;

            var domObject = this.formObject.email;
            var email = this.formObject.email.val();

            if (email.trim() === '') {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.compile_field);
                errors = true;
            } else if (!SlamJam.validateEmail(email)) {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.email_error);
                errors = true;
            } else {
                this.errorHide(domObject);
            }

            return !errors;
        }
        //#endregion

    }, {
        key: 'validateCheckbox',
        value: function validateCheckbox(objCheckbox, text) {

            for (var i = 0; objCheckbox.length; i++) {
                if (objCheckbox.prop('checked') === true) {
                    this.errorHide(objCheckbox);
                    $(objCheckbox[i]).prop("checked");

                    return true;
                }

                this.errorShow(objCheckbox, text);

                return false;
            }
        }

        /**
        * Aggiunge la classe errore all'oggetto obj
        * @param {*} obj
        */

    }, {
        key: 'errorShow',
        value: function errorShow(obj) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            obj.addClass(this.cssInputClassError);

            if (text) {
                obj.parent().find('.form-fld-error').html(text);
            }

            obj.parent().find('.form-fld-error').removeClass(this.cssHideClass);
        }

        /**
         * Nasconde l'errore
         */

    }, {
        key: 'errorHide',
        value: function errorHide(obj) {
            obj.removeClass(this.cssInputClassError);
            obj.parent().find('.form-fld-error').addClass(this.cssHideClass);
        }

        /**
         * Avvia un check preventivo prima dell'invio del form
         */

    }, {
        key: 'checkFormFields',
        value: function checkFormFields() {
            var checkEmail = this.validateEmail();
            var checkPrivacy = this.validateCheckbox(this.formObject.checkPrivacy, SlamJam.strings.customer.register.label.privacy_field);

            return checkEmail && checkPrivacy;
        }

        /**
         * Visualizza il form Back In Stock
         * * I valori in ingresso serviranno per inviare la chiamata al BIS
         *
         * @param {*} _idProduct // ID univico del prodotto
         * @param {*} _idVariant // ID univoco della variante
         */

    }, {
        key: 'show',
        value: function show(_idProduct, _idVariant) {
            if (!this.isExists() || !this.isBISExists()) return;

            // Set Global Vars
            this.idProduct = _idProduct;
            this.idVariant = _idVariant;

            // Svuota il messaggio in coda
            this.setBisMessageError('');
            this.setBisMessageSuccess('');

            // Visualizza i controlli
            this.form.show();
            this.dom.show();
        }

        /**
         * nasconde il form Back In Stock
         */

    }, {
        key: 'hide',
        value: function hide() {
            if (!this.isExists()) return;
            this.dom.hide();
        }
    }, {
        key: 'btnSubmitDisable',
        value: function btnSubmitDisable() {
            if (this.submitButton) {
                this.submitButton.addClass('btn--disabled').prop('disabled', true);
            }
        }
    }, {
        key: 'btnSubmitEnabled',
        value: function btnSubmitEnabled() {
            if (this.submitButton) {
                this.submitButton.removeClass('btn--disabled').prop('disabled', false);
            }
        }
    }]);

    return BackInStock;
}();

/**
 * Bottone Add To Cart
 * Gestisce il testo presente al suo interno
 */


var AddToCartBtn = function () {

    /**
     * Inviare i dati dei settings per sovrascrivere quelli di default
     *
     * @param {*} _dom  // Contenitore bottone
     * @param {boolean} initOnCreate
     * @param {json | null} settings
     */
    function AddToCartBtn(_dom) {
        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, AddToCartBtn);

        this.dom = _dom;
        this.exists = this.dom.length === 1;

        this.btnAddToCart = this.dom.find('.btn--add-to-cart'); // Selettore bottone Aggiungi al carrello
        this.btnAddToCartMilan = this.dom.find('#AddToCart-product-template-milan');
        this.status = settings.defaultAction ? settings.defaultAction : 'addToCart';

        this.btnAddToCartText = this.dom.find('.btn__text');
        this.btnAddToCartResetText = this.btnAddToCartText.html();
        this.viewCartText = SlamJam.strings.viewCart ? SlamJam.strings.viewCart : 'View cart';

        this.addedClass = 'item-added'; // Classe che identifica che l'elemento è stato aggiunto al carrello

        this.form = this.dom.find('.product__form--add-to-cart');
        this.formId = this.dom.find('select[name="id"]');

        // Costanti EVENTI CLICK
        this.EVENT_BTN_ADD_TO_CART_CLICK = 'add-to-cart-click';
        this.EVENT_BTN_SELECT_SIZE_CLICK = 'select-size-click';
        this.EVENT_BTN_VIEW_CART_CLICK = 'view-cart-click';
        this.EVENT_BTN_BACKINSTOCK_CLICK = 'back-in-stock-click';

        this.init();
    }

    _createClass(AddToCartBtn, [{
        key: 'init',
        value: function init() {
            this.addEventHandler();
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            this.btnAddToCart.on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                // Triggero l'evento corretto in base allo stato del bottone
                if (self.status == 'addToCart') {

                    $(self).trigger(self.EVENT_BTN_ADD_TO_CART_CLICK);
                } else if (self.status == 'selectSize') {
                    $(self).trigger(self.EVENT_BTN_SELECT_SIZE_CLICK);
                } else if (self.status == 'viewCart') {
                    $(self).trigger(self.EVENT_BTN_VIEW_CART_CLICK);
                } else if (self.status == 'backInStock') {
                    $(self).trigger(self.EVENT_BTN_BACKINSTOCK_CLICK);
                } else {
                    // Nessun evento da triggerare
                }
            });

            this.btnAddToCartMilan.on('click', function (e) {
                if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                    e.preventDefault();
                    e.stopPropagation();
                    $(self).trigger(self.EVENT_BTN_SELECT_SIZE_CLICK);
                }
            });

            $('body').on('click', '.product-select-variant__value', function (e) {
                e.stopPropagation();
            });
        }

        // Gestisce il bottone dell'add to cart dopo l'aggiunta al carrello

    }, {
        key: 'handleAddedToCart',
        value: function handleAddedToCart() {
            var self = this;

            this.status = 'viewCart';
            this.btnAddToCart.addClass(this.addedClass);

            setTimeout(function () {
                self.btnAddToCart.removeClass(self.addedClass);
                if (SlamJam.strings.dropInstance) {
                    self.btnAddToCartText.html('Review');
                } else {
                    self.btnAddToCartText.html(self.viewCartText);
                }
                // [PIM-1771]
                SlamJam.minicart.openMinicart();
            }, 1000);
        }
    }, {
        key: 'resetButton',
        value: function resetButton() {
            this.status = 'addToCart';
            this.btnAddToCartText.html(this.btnAddToCartResetText);
        }

        /**
         * Avvia il form per l'add to cart
         */

    }, {
        key: 'addToCart',
        value: function addToCart() {
            this.form.submit();
        }
    }, {
        key: 'stickyAddToCart',
        value: function stickyAddToCart(variantId) {
            this.formId.val(variantId);
            this.form.submit();
        }
    }]);

    return AddToCartBtn;
}();

var Search = function () {
    function Search() {
        _classCallCheck(this, Search);

        this.btnOpenSearch = $('.site-header__search');
        this.btnSearchClose = $('.close');
        this.searchInput = $('.search-terms');
        this.resetInputValue = $('.search__reset svg'); // Immagine close X
        this.tagsSearchanise = SlamJam.settings.searchanise.tags; // mi prendo dal settings i dati inseriti dal cliente
        this.bodyScrollLockTarget = '.snize-ac-results-content';
        var self = this;
        this.openSearch();
        this.resetInputField(); // al click della X cancella contenuto search
        this.customSearchanise(); // questa funzione va a personalizzare tramite JS l'app Searchanise
        this.enableSearchAnise();
    }

    _createClass(Search, [{
        key: 'enableSearchAnise',
        value: function enableSearchAnise() {
            var self = this;

            function waitFor(variable, callback) {
                var interval = setInterval(function () {
                    if (window[variable]) {
                        clearInterval(interval);
                        callback();
                    }
                }, 1000);
            }

            waitFor('SearchaniseIncluded', function () {

                var highlightedItems = document.querySelectorAll(".search-block");

                highlightedItems.forEach(function (userItem) {
                    userItem.classList.remove("is-loading");
                });
            });
        }

        /**
         * Open search solo desktop
         */

    }, {
        key: 'openSearch',
        value: function openSearch() {
            var self = this;

            // Bottone Menu TOP SEARCH
            this.btnOpenSearch.on('click', function (e) {
                e.preventDefault(); /* blocco reload pagina */

                $('.site-header__search-bar').addClass('visible');
                $('.site-header__mainmenu__items.level2.is-active').hide();
                $('.hide-by-search').hide();
                $('.search-terms').focus();
                $('.search-terms').addClass('visible');
            });

            // Bottone CLOSE nella search (Testuale non X)
            this.btnSearchClose.on('click', function (e) {
                e.preventDefault();

                $('.site-header__search-bar').removeClass('visible');
                $('.site-header__mainmenu__items.level2.is-active').show();
                $('.hide-by-search').show();
                $('.search-terms').removeClass('visible');

                scrollLock.enablePageScroll(document.querySelector(self.bodyScrollLockTarget));
            });
        }
    }, {
        key: 'resetInputField',
        value: function resetInputField() {
            var self = this;

            // Click sul tasto chiudo X (nativo della ricerca)
            this.resetInputValue.on('click', function () {
                scrollLock.enablePageScroll(document.querySelector(self.bodyScrollLockTarget));

                if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                    $('.search-terms').val('');
                } else {
                    $('.site-header__search-bar.visible .search_form .search-terms').val("");
                }

                $('.search__reset').hide();
            });
        }
    }, {
        key: 'customSearchanise',
        value: function customSearchanise() {
            /*******************************************************
                preorder_yes        PRE-ORDER
                sale                SALE
                new Text            NEW
                sold-out            SOLD OUT
                promo_no            PALLINO
                raffle_yes          RAFFLE ON
                in-store-only_yes   IN-STORE ONLY
            ********************************************************/

            var tagsArray = []; // genero un array vuoto
            var singleTag = this.tagsSearchanise.split(','); // vado a splittare contenuto settings con il carattere ","

            var self = this;

            $.each(singleTag, function (i) {
                tagsArray.push(singleTag[i]); // tutti i valori splittati andranno nell'array dichiarato sopra
            });

            // set up the mutation observer
            var observer = new MutationObserver(function (mutations, me) {
                // `mutations` is an array of mutations that occurred
                // `me` is the MutationObserver instance
                var searchContentDiv = document.querySelector('.snize-ac-results .snize-ac-results-content');
                if (searchContentDiv) {

                    searchContentDiv.addEventListener('scroll', function () {
                        document.querySelector('.search-terms').blur();
                    });

                    me.disconnect(); // stop observing
                    return;
                }
            });

            // start observing
            observer.observe(document, {
                childList: true,
                subtree: true
            });

            $(document).on('keyup', this.searchInput, function () {
                console.log($(this).val());

                var haveText = $(this).val().length > 0;
                scrollLock.disablePageScroll(document.querySelector(self.bodyScrollLockTarget));

                if (haveText) {
                    $('.search__reset').show();
                } else {
                    $('.search__reset').hide();
                }

                // Elimina tutti link a DX per poi spostarli a SX con moveAllLinkBtn()
                $('.snize-ac-results-content > div.snize-ac-results-columns > div:nth-child(1) > li').remove();

                // max time to wait (in seconds)
                var maxSeconds = 10;
                // time spend (in seconds)
                var timer = 1;

                // quando arriva il div di searchinise
                var showedSearchanise = setInterval(function () {
                    // check if dom exists
                    if (document.querySelector(self.bodyScrollLockTarget)) {
                        // clear interval
                        clearInterval(showedSearchanise);

                        createLayout();
                        scrollLock.disablePageScroll(document.querySelector(self.bodyScrollLockTarget));
                    }
                    // check if timeout
                    if (timer++ >= maxSeconds) {
                        clearInterval(showedSearchanise);
                    }
                }, 500);

                // quando viene nascosto il div di searchinise
                var hidedSearchanise = setInterval(function () {
                    // check if dom exists
                    if (!document.querySelector(self.bodyScrollLockTarget) || !$(self.bodyScrollLockTarget).is(':visible')) {
                        // clear interval
                        clearInterval(hidedSearchanise);
                        scrollLock.clearQueueScrollLocks();
                        scrollLock.enablePageScroll(document.querySelector(self.bodyScrollLockTarget));
                    }
                }, 500);

                /**
                 * Crea il layout dei risultati di ricerca
                 * * Eliminata i link VIEW ALL ...
                 * //TODO Terminare il commento -AlessandroAchilli
                 */
                function createLayout() {
                    var moveAllLinkBtn = function moveAllLinkBtn() {
                        if (!SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                            $('.snize-view-all-link').addClass('visible').appendTo('.snize-ac-results-columns > div:nth-child(1)');
                        }
                    };

                    var manageTags = function manageTags() {
                        var title = $('.snize-product-tag-label');

                        tagsArray.forEach(function (item) {
                            $.each(title, function () {
                                var currentTitle = $(this).text();

                                if (currentTitle.includes(item)) {
                                    $(this).parent().parent().addClass(item.toLowerCase().replace(' ', ''));
                                }
                            });
                        });
                    };

                    var hideEmptyColumn = function hideEmptyColumn() {
                        var column = $('.snize-ac-results-list');

                        $.each(column, function () {
                            if ($(this).has('.snize-no-pages-found, .snize-no-categories-found').length) {
                                $(this).hide();
                            } else {
                                $(this).show();
                            }
                        });
                    };

                    var addNewColumn = function addNewColumn() {
                        var parent = $('.snize-ac-results-columns');

                        if (parent.children('.right-column').length > 0) {} else {
                            $('<div class="right-column">').appendTo(parent);
                        }
                    };

                    moveAllLinkBtn(); // mette la scritta "vedi tutti i prodotti nella colonna a sx"
                    manageTags(); // va a gestire i tag per mostrarli come nel listing"
                    hideEmptyColumn(); // vado a rimuovere le colonne che non hanno un risultato
                    addNewColumn();

                    $('.snize-product-tag-label').addClass('checked');

                    var showSuggestionsEvent = new CustomEvent('showSuggestionsEvent');
                    window.dispatchEvent(showSuggestionsEvent);
                }
            });
        }
    }]);

    return Search;
}();

var ProductCard = function () {
    function ProductCard() {
        _classCallCheck(this, ProductCard);

        this.productCardSelector = '.product-card';
        // se GTM non è abilitato non vado a passare i parametri
        if (gtmEnabled != false) {
            this.sendGTMInformation();
        }
    }

    _createClass(ProductCard, [{
        key: 'sendGTMInformation',
        value: function sendGTMInformation() {
            $('body').on('click', '.product-card', function (e) {
                if ($(this).hasClass("product-card--recently-viewed")) {
                    //gestisco in funzione diversa perchè recently view è generato in JS
                    trackGtmInfoClickRecentlyView(e, $(this));
                } else {
                    trackGtmInfoClick(e, $(this));
                }
            });
        }
    }]);

    return ProductCard;
}();

/**
 * Gestione Loading div
 */


var Loading = function () {

    /**
     * @param {*} _dom  Elemento del dom che contiene i loading
     * @param {*} _settings
     */
    function Loading(_dom) {
        var _settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, Loading);

        this.dom = _dom;
        //
        this.classWrapper = "loading-wrapper";
        this.classBG = "loading-wrapper__bg";
        this.classBar = "loading-wrapper__bar";
        this.classBarCursor = "loading-wrapper__bar__cursor";

        //
        this.classShow = "show-loading";
        //
        this.bg = $(this.dom.find("." + this.classBG));
        this.bar = $(this.dom.find("." + this.classBar));
        this.barCursor = $(this.dom.find("." + this.classBarCursor));

        //Numero di volte che viene invocata la show, se > 1 non devo chiudere la loading nell'evento hide, ma devo decrementare la variabile
        this.openNumber = 0;

        //
        this.init(_settings);
    }

    _createClass(Loading, [{
        key: 'init',
        value: function init(_settings) {
            var _show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this.openNumber = 0;
            this.settings = $.extend(this.getDefaultSettings(), _settings);

            //
            this.bg.css('background-color', this.settings.bg.backgroundColor);
            this.bg.css('opacity', this.settings.bg.opacity);

            //
            this.bar.css('background-color', this.settings.bar.backgroundColor);
            this.barCursor.css('background-color', this.settings.bar.cursorColor);

            if (_show) {
                this.show();
            } else {
                this.hide();
            }
        }
    }, {
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                dom: {
                    position: "fixed"
                },
                bg: {
                    backgroundColor: "#FFFFFF",
                    opacity: 0.5
                },
                bar: {
                    backgroundColor: "#FFFFFF",
                    cursorColor: "#000000"
                }

            };
        }
    }, {
        key: 'show',
        value: function show() {
            this.openNumber++;
            this.dom.addClass(this.classShow);
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (this.openNumber <= 1) {
                this.dom.removeClass(this.classShow);
            }

            this.openNumber--;
        }
    }]);

    return Loading;
}();

var PopupRedirect = function () {
    function PopupRedirect(_dom) {
        _classCallCheck(this, PopupRedirect);

        this.dom = _dom;

        this.popupRedirectSelector = '.banner-redirect';
        this.popupRedirectCloseSelector = '.banner-redirect__close';
        this.popupRedirectComponents = '.banner-redirect__components';
        this.popupRedirectAlertSelector1 = '.banner-redirect__alert--1';
        this.popupRedirectAlertTextSelector1 = '.banner-redirect__alert--1 .banner-redirect__alert-text'; // testo per messaggio country != country di default
        this.popupRedirectAlertSelector2 = '.banner-redirect__alert--2';
        this.popupRedirectAlertTextSelector2 = '.banner-redirect__alert--2 .banner-redirect__alert-text'; // testo per messaggio country del cliente non mappato tra quelli disponibili in Shopify
        this.popupRedirectAlertButtonSubmit = '.banner-redirect__submit';
        this.popupRedirectAlertButtonContinue = '.banner-redirect__button--continue';
        this.popupRedirectAlertButtonBack = '.banner-redirect__button--back';
        this.userCountry = '';

        this.countrySelectSelector = '.banner-redirect__countries';
        this.currentCountryText = '.js-country';
        this.changeCountrySelector = '.js-change-country';
        this.excludedShippingZones = SlamJam.settings.popupRedirect.availableCountries.find(function (country) {
            return country.isocode;
        });
        this.init();
        this.addEventHandler();
    }

    _createClass(PopupRedirect, [{
        key: 'init',
        value: function init() {
            //Se l'observer esiste già lo disconnetto
            if (this.observer) {
                this.observer.disconnect();
            }

            //ottengo tutte le configurazioni dei markets
            for (var singleMarket in SlamJamMarkets.settings.markets) {

                var currentMarketIsoCode = SlamJamMarkets.settings.markets[singleMarket].shop_marketIsoCode;

                var currentMarketName = SlamJamMarkets.settings.markets[singleMarket].shop_countries_name;

                var allCountriesOfaMarketIsocodes = SlamJamMarkets.settings.markets[singleMarket].shop_countries_iso_codes.split(";");

                for (var i = 0; i < allCountriesOfaMarketIsocodes.length; i++) {

                    if (allCountriesOfaMarketIsocodes[i] == Shopify.country) {
                        SlamJamMarkets.settings.currentMarket = currentMarketIsoCode;
                        SlamJamMarkets.settings.currentMarketName = currentMarketName;
                    }
                }
            }

            //aggiorno country nel footer
            if (window.Shopify.country) {
                if (!Cookies.get('forceLocalization')) {
                    $(this.countrySelectSelector).val($(this.countrySelectSelector).find('option[value="' + window.Shopify.country + '"]').val());
                    $(this.currentCountryText).html($(this.countrySelectSelector).find('option[value="' + window.Shopify.country + '"]').html());
                } else {
                    $(this.countrySelectSelector).val($(this.countrySelectSelector).find('option[value="' + Cookies.get('forceLocalization') + '"]').val());
                    $(this.currentCountryText).html($(this.countrySelectSelector).find('option[value="' + Cookies.get('forceLocalization') + '"]').html());
                }
            }

            //inizializzo la select con select2
            this.countrySelect = $(this.countrySelectSelector).select2({
                closeOnSelect: false,
                width: '100%',

                // aggiungo una classe css all'ultimo elemento della lista degli isocode principali
                templateResult: function templateResult(data, container) {
                    if (data.element && data.element.dataset.last == 'true') {
                        $(container).addClass('last');
                    }

                    return data.text;
                },

                // sort delle option a seconda di data-position
                sorter: function sorter(data) {
                    return data.sort(function (a, b) {
                        a = a.element.dataset.position || 0;
                        b = b.element.dataset.position || 0;
                        a = '' + a;
                        b = '' + b;

                        if (a < b) {
                            return 1;
                        } else if (a > b) {
                            return -1;
                        }

                        return 0;
                    });
                }
            });

            this.startRedirectFlow();
        }
    }, {
        key: 'startRedirectFlow',
        value: function startRedirectFlow() {
            var self = this;

            if (!Cookies.get('newShippingCookie')) {
                $.ajax({
                    url: '/browsing_context_suggestions.json',
                    type: 'GET',
                    success: function success(response) {
                        self.userCountry = response.detected_values.country.handle;
                        var userCountry = SlamJam.settings.popupRedirect.availableCountries.find(function (country) {
                            return country.isocode == self.userCountry;
                        });

                        if (!userCountry) {

                            /*
                            //aggiornamento stringhe
                            let alertText = $(self.popupRedirectAlertTextSelector2).html().replace(/\$right_nation/gi, response.detected_values.country_name);
                             $(self.popupRedirectAlertTextSelector2).html(alertText);
                             $(self.popupRedirectComponents).addClass('active');
                            $(self.popupRedirectAlertSelector2).addClass('active');
                            $(self.popupRedirectSelector).addClass('active');
                            */

                            if (!Cookies.get('forceLocalization')) {
                                Cookies.set('newShippingCookie', 'true');
                                Cookies.set('countrySJ', self.userCountry);
                                Cookies.set('forceLocalization', self.userCountry);

                                if (window.location.href.indexOf("#__") > -1) {
                                    var referalLink = window.location.href.substring(window.location.href.indexOf("#__"));
                                    window.history.replaceState(null, null, window.location.pathname);

                                    //se non è crawel di google può procedere tranquillamente con redirect
                                    if (SlamJam.UserCrawelGoogle() == false) {
                                        window.location = location.href += "?currency=EUR&shippingCountry=" + self.userCountry + referalLink;
                                    }
                                } else {
                                    window.history.replaceState(null, null, window.location.pathname);
                                    //se non è crawel di google può procedere tranquillamente con redirect

                                    if (SlamJam.UserCrawelGoogle() == false) {
                                        window.location = location.href += "?currency=EUR&shippingCountry=" + self.userCountry;
                                    }
                                }
                            }
                        } else if (response.detected_values.country.handle != window.Shopify.country) {

                            Cookies.set('newShippingCookie', 'true');
                            var marketGetByGeoService = "";
                            var correctMarket = false;
                            var currentUserIsoCode = userCountry.isocode;
                            var backStringName = "";

                            for (var singleMarket in SlamJamMarkets.settings.markets) {

                                //setto la scritta per il back nel popup
                                if (currentUserIsoCode == SlamJamMarkets.settings.markets[singleMarket].shop_marketIsoCode.toUpperCase()) {
                                    backStringName = SlamJamMarkets.settings.markets[singleMarket].shop_countries_name;
                                    marketGetByGeoService = SlamJamMarkets.settings.markets[singleMarket].shop_marketIsoCode;
                                }
                            }
                            console.log(marketGetByGeoService);
                            console.log(SlamJamMarkets.settings.currentMarket);
                            if (marketGetByGeoService == SlamJamMarkets.settings.currentMarket) {
                                correctMarket = true;
                                Cookies.remove('forceLocalization');
                                Cookies.set('newShippingCookie', 'true');
                            }

                            var shippingZones = SlamJam.settings.shippingZones.split(";");
                            var shippingZonesIsocodes = [];

                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;

                            try {
                                for (var _iterator = shippingZones[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    var singleRow = _step.value;

                                    shippingZonesIsocodes.push(singleRow.split(",")[1]);
                                }
                                //se non è crawel di google può procedere tranquillamente con redirect
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally {
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return) {
                                        _iterator.return();
                                    }
                                } finally {
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }

                            if (SlamJam.UserCrawelGoogle() == false) {
                                var defaultCountry = SlamJam.settings.popupRedirect.availableCountries.find(function (country) {
                                    return country.isocode == window.Shopify.country;
                                });
                                //const defaultCountry = shippingZonesIsocodes.find(function (country) { return country ==  window.Shopify.country});
                                //aggiornamento stringhe e bottoni con nome del paese ricavato dall'IP e istanza corrente
                                var alertText = $(self.popupRedirectAlertTextSelector1).html().replace(/\$right_nation/gi, backStringName).replace(/\$wrong_nation/gi, SlamJamMarkets.settings.currentMarketName);

                                if (SlamJam.strings.af1Instance == false) {

                                    if (correctMarket == false) {
                                        $(self.popupRedirectAlertTextSelector1).html(alertText);
                                        $(self.popupRedirectAlertButtonBack).html($(self.popupRedirectAlertButtonBack).html().replace(/\$right_nation/gi, backStringName));
                                        $(self.popupRedirectAlertButtonContinue).html($(self.popupRedirectAlertButtonContinue).html().replace(/\$wrong_nation/gi, SlamJamMarkets.settings.currentMarketName));
                                        $(self.popupRedirectComponents).removeClass('active');
                                        $(self.popupRedirectAlertSelector1).addClass('active');
                                        $(self.popupRedirectSelector).addClass('active');
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            //se clicco sul country selector nel footer
            $(self.changeCountrySelector).on('click', function (e) {
                $(self.popupRedirectAlertSelector1).removeClass('active');
                $(self.popupRedirectAlertSelector2).removeClass('active');
                $(self.popupRedirectComponents).addClass('active');
                $(self.popupRedirectSelector).addClass('active');
                $(self.countrySelect).select2('open');
                $(self.countrySelect).select2('focus');
                SlamJam.closeModal();
                $('body').addClass('overflow-hidden');
                Cookies.remove('geo_ip_value');
            });

            //se cambio paese dalla select
            this.countrySelect.on('select2:select', function (e) {
                var select_val = $(e.currentTarget).val();
                e.preventDefault();
                Cookies.set('countrySJ', window.Shopify.country);
                Cookies.set('newShippingCookie', 'true');

                if (template == "search") {
                    $('#localization_form input[name="return_to"]').val(window.location.pathname + window.location.search);
                }

                var notExcluded = SlamJam.settings.popupRedirect.availableCountries.find(function (country) {
                    return country.isocode == select_val;
                });

                if (notExcluded) {
                    Cookies.remove('forceLocalization');
                    $(self.popupRedirectAlertButtonSubmit).trigger('click');
                } else {
                    Cookies.set('forceLocalization', select_val);
                    if (window.location.href.indexOf("#__") > -1) {
                        var referalLink = window.location.href.substring(window.location.href.indexOf("#__"));
                        window.history.replaceState(null, null, window.location.pathname);
                        window.location = location.href += "?currency=EUR&shippingCountry=" + select_val + referalLink;
                    } else {
                        window.history.replaceState(null, null, window.location.pathname);
                        window.location = location.href += "?currency=EUR&shippingCountry=" + select_val;
                    }
                }

                $(self.countrySelect).select2('close');
            });

            //se chiudo il popup cliccando su close, setto l'isocode di default impostato nel customize per lo store corrente o già impostato non faccio nulla
            $('body').on('click', this.popupRedirectCloseSelector, function () {
                Cookies.set('countrySJ', window.Shopify.country);
                self.closePopup();
            });

            //se chiudo il popup cliccando fuori dalla sua box, setto l'isocode di default impostato nel customize per lo store corrente o già impostato non faccio nulla
            $('body').on('click', this.popupRedirectSelector, function () {
                Cookies.set('countrySJ', window.Shopify.country);
                Cookies.set('newShippingCookie', 'true');

                self.closePopup();
            });

            //se chiudo il popup cliccando su continue, setto l'isocode di default impostato nel customize per lo store corrente o già impostato non faccio nulla
            $('body').on('click', this.popupRedirectAlertButtonContinue, function () {
                Cookies.set('countrySJ', window.Shopify.country);
                Cookies.set('newShippingCookie', 'true');
                self.closePopup();
                console.log("deploy");
            });

            //se clicco sul bottone del back, cambio store e vado allo store corretto considerando l'IP
            $('body').on('click', this.popupRedirectAlertButtonBack, function () {
                $(self.countrySelectSelector).val(self.userCountry).trigger('change');
                Cookies.set('countrySJ', window.Shopify.country);
                $(self.currentCountryText).html($(self.countrySelectSelector).find('option[value="' + self.userCountry + '"]').html());
                $(self.popupRedirectAlertButtonSubmit).trigger('click');
                self.closePopup();
            });

            //se chiudo il popup cliccando su close, setto l'isocode di default impostato nel customize per lo store corrente o già impostato non faccio nulla
            $('body').on('click', this.popupRedirectCloseSelector, function () {
                self.closePopup();
            });
        }
    }, {
        key: 'closePopup',
        value: function closePopup() {
            $(this.popupRedirectSelector).removeClass('active');
            $('body, html').removeClass('overflow-hidden');
        }
    }]);

    return PopupRedirect;
}();

var Countdown = function () {
    function Countdown() {
        _classCallCheck(this, Countdown);

        this.countdownSelector = '.countdown';
        this.countdownStartSelector = '.countdown-start';
        this.countdownSelectorMilan = '.milan-countdown-end';
        this.countdownStartSelectorMilan = '.milan-countdown-start';
        this.parentElement = '.product-card';

        this.init();
    }

    _createClass(Countdown, [{
        key: 'pad',
        value: function pad(e) {
            for (var t = e + ""; t.length < 2;) {
                t = "0" + t;
            }return t;
        }
    }, {
        key: 'checkRaffleStatusInPdP',
        value: function checkRaffleStatusInPdP(now) {
            /* div contenitori dei countdown */
            var countDownStartDiv = '.template-product .product-details__dx .countdown-start';
            var countDownEnd = '.template-product .product-details__dx .countdown';
            var countDownStartMilanDiv = '.template-product .product-details__dx .milan-countdown-start';
            var countDownEndMilanDiv = '.template-product .product-details__dx .milan-countdown-end';

            /* cta che si aggiornano in base stato raffle */
            var ctaAddToCart = document.querySelector('[data-section-id="product-template-raffle"] #AddToCart-product-template, [data-section-id="product-template"] #AddToCart-product-template');
            var ctaAddToCartMilan = document.querySelector('[data-section-id="product-template-raffle"] #AddToCart-product-template-milan');
            var ctaRedirectToStaging = document.querySelector('.product-raffle-closed');

            /* valori dei countdown delle raffle */

            var countDownEndWeb = new Date($('.template-product .product-details__dx .countdown[data-available-from-utc]').attr('data-available-from-utc'));
            var countDownStartWeb = new Date($('.template-product .product-details__dx .countdown-start[data-start-from-utc]').attr('data-start-from-utc'));
            var countDownEndMilan = new Date($('.template-product .product-details__dx .milan-countdown-end[data-available-from-utc]').attr('data-available-from-utc'));
            var countDownStartMilan = new Date($('.template-product .product-details__dx .milan-countdown-start[data-start-from-utc]').attr('data-start-from-utc'));

            //raffle già apera, quindi possibilità di acquisto!
            function raffleOpened(raffleType) {
                var ctaCart = document.querySelector('.add-to-cart-wrapper');
                if (SlamJam.strings.dropInstance == true) {
                    //dopo aver verificato se sono in drop
                    if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {

                        if (raffleType == "web") {
                            $('#AddToCart-product-template').addClass("open");
                        }

                        if (raffleType == "milan") {
                            $('#AddToCart-product-template-milan').addClass("open");
                        }

                        document.querySelector('.raffle-pdp').classList.add("active");
                    } else {
                        //verifico se sono in desktop
                        ctaCart.classList.remove("product-raffle");
                    }
                    if (raffleType == "milan") {
                        ctaCart.classList.remove("milan-hide-true");
                    }
                } else {

                    if (ctaRedirectToStaging != undefined) {
                        ctaRedirectToStaging.classList.add("active");
                    }
                }

                if (raffleType == "web") {
                    showCountDown(countDownEnd);
                } else {
                    showCountDown(countDownEndMilanDiv);
                }
            }

            //raffle con countdown di apertura e quindi senza possibilità di acquisto
            function raffleOpening(raffleType, ctaAddToCart) {
                var ctaCart = document.querySelector('.add-to-cart-wrapper');

                if (SlamJam.strings.dropInstance == true) {
                    // metto classe select principale x nn fdare aggiungere proodtto al cart
                    ctaAddToCart.classList.add("raffle-btn-disabled");
                    ctaCart.classList.remove("product-raffle");

                    if ($('.add-to-cart-wrapper').hasClass("multi-raffle")) {
                        if (raffleType == "web") {
                            $('.raffle__container .panel__container [data-cta="raffle-open"]').addClass("pending");
                        }

                        if (raffleType == "milan") {
                            $('.raffle__container .panel__container [data-cta="raffle-open-milan"]').addClass("pending");
                        }
                    }

                    if ($(window).width() < SlamJam.costants.grid_large) {

                        if (raffleType == "web" && raffleType == "milan") {
                            multiRaffle = true;
                        }

                        if ($('.add-to-cart-wrapper').hasClass("multi-raffle")) {
                            if (raffleType == "web") {
                                $('.raffle__container .panel__container .right').addClass("pending");
                            }

                            if (raffleType == "milan") {
                                $('.raffle__container .panel__container .left').addClass("pending");
                            }
                        } else {
                            if (raffleType == "web") {
                                $('#add-to-cart-sticky-wrapper').addClass("single-web-pending");
                            }

                            if (raffleType == "milan") {
                                $('#add-to-cart-sticky-wrapper').addClass("single-milan-pending");
                            }
                        }
                    }
                } else {
                    if (ctaRedirectToStaging != undefined) {
                        ctaRedirectToStaging.classList.add("active");
                    }
                }

                if (raffleType == "web") {
                    showCountDown(countDownStartDiv);
                } else {
                    showCountDown(countDownStartMilanDiv);
                }
            }

            function raffleClosed(raffleType) {
                var endDate = "";
                var raffleEnd = "";
                var raffleIdentifier = '';

                var raffleEndNoTags = document.querySelector('.product-details__raffle-block');
                var ctaCart = document.querySelector('.add-to-cart-wrapper');

                if (raffleType == "web") {
                    endDate = $('.template-product .product-details__dx .countdown[data-available-from-utc]').attr('data-available-from-utc');
                    var dateWithoutHours = endDate.substr(0, endDate.indexOf(' '));

                    if (SlamJam.strings.current_ship_language == 'IT') {
                        raffleIdentifier = 'Web ';
                    }
                    raffleEnd = '<span class="product-card__label product-card__label--raffle-close">' + raffleIdentifier + 'Draw closed on ' + dateWithoutHours + '</span>';
                } else {
                    endDate = $('.template-product .product-details__dx .milan-countdown-end[data-available-from-utc]').attr('data-available-from-utc');
                    var _dateWithoutHours = endDate.substr(0, endDate.indexOf(' '));
                    if (SlamJam.strings.current_ship_language == 'IT') {
                        raffleIdentifier = 'Milan ';
                    }
                    raffleEnd = '<span class="product-card__label product-card__label--raffle-close">' + raffleIdentifier + 'Draw closed on ' + _dateWithoutHours + '</span>';
                }

                $(raffleEndNoTags).removeClass('hide');
                // $(raffleEndNoTags).append(raffleEnd);

                if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                    if (SlamJam.strings.dropInstance == false) {}
                    // $('.add-to-cart-btn-wrapper').hide();
                    $('#add-to-cart-sticky-wrapper').append($('.product-raffle-closed'));
                } else {
                    if (SlamJam.strings.dropInstance == false) {
                        if (ctaCart.classList.contains("redirect")) {
                            // fa redirect
                            ctaCart.classList.remove("product-raffle");
                        } else {
                            if (ctaRedirectToStaging != undefined) {
                                ctaRedirectToStaging.classList.add("active");
                            }
                        }
                    } else {
                        if (SlamJam.strings.dropInstance == false) {
                            ctaRedirectToStaging.classList.add("active");
                        }
                    }
                }
                if (raffleType == "web") {
                    showCountDown(countDownEnd);
                } else {
                    showCountDown(countDownEndMilan);
                }
            }

            /* la raffle è web */
            if (countDownEndWeb && countDownStartWeb) {
                var raffleType = 'web';
                /* se la raffle è gia partita */
                if (now < countDownEndWeb && now > countDownStartWeb) {
                    raffleOpened(raffleType);
                    /* se la raffle deve partire */
                } else if (now < countDownStartWeb && now < countDownEndWeb) {
                    raffleOpening(raffleType, ctaAddToCart);
                    /* se la raffle è chiusa */
                } else if (now > countDownStartWeb && now > countDownEndWeb) {
                    raffleClosed(raffleType);
                }
            }

            /* la raffle è milano */
            if (countDownEndMilan && countDownStartMilan) {
                var _raffleType = 'milan';
                /* se la raffle è gia partita */
                if (now < countDownEndMilan && now > countDownStartMilan) {
                    raffleOpened(_raffleType);
                    /* se la raffle deve partire */
                } else if (now < countDownStartMilan && now < countDownEndMilan) {
                    raffleOpening(_raffleType, ctaAddToCartMilan);
                    /* se la raffle è finita */
                } else if (now > countDownStartMilan && now > countDownEndMilan) {
                    //raffleMilanClosed(raffleType);
                    raffleClosed(_raffleType);
                }
            }

            //se raffle è multipla (web + milan)
            if ($('.add-to-cart-wrapper').hasClass("multi-raffle")) {

                if (SlamJam.strings.dropInstance == false) {
                    if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                        $('#add-to-cart-sticky-wrapper .add-to-cart-btn-wrapper.mobile').hide();
                        $('.product-raffle-closed').appendTo(".raffle-cta");
                    }
                } else {
                    if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
                        $('.raffle-pdp').removeClass("active");
                        $('.raffle').appendTo("#add-to-cart-sticky-wrapper");
                        $('.raffle-pdp').addClass("multi");
                    }
                }

                if ($('.add-to-cart-wrapper').hasClass("multiraffle")) {
                    if (SlamJam.strings.dropInstance == true) {
                        //   $('.raffle').hide();
                        $(ctaRedirectToStaging).addClass("active");
                    }
                } else {
                    $('.product-raffle-closed').removeClass("active");
                }
            }

            $('.raffle-cta .panel__container div').click(function (e) {

                var cta = $(this).attr("data-cta");
                if (cta == "raffle-open-milan") {
                    $('.raffle-cta #AddToCart-product-template-milan').prev().hide();
                    $('.raffle-cta #AddToCart-product-template-milan').show();

                    $('.raffle-cta #AddToCart-sticky').prev().show();
                    $('.raffle-cta #AddToCart-sticky').addClass("hide");
                } else {
                    $('.raffle-cta #AddToCart-product-template-milan').prev().hide();
                    $('.raffle-cta #AddToCart-product-template-milan').show();
                    $('.raffle-cta #AddToCart-sticky').prev().hide();
                    $('.raffle-cta #AddToCart-sticky').removeClass("hide");
                }
            });

            //mostra countdown con un secondo di ritardo per non far vedere gli "scattini"
            function showCountDown(typeCountdown) {
                setInterval(function () {
                    $(typeCountdown).show();
                    $('.raffle-dates').show();
                }, 1000);
            }
        }
    }, {
        key: 'execute',
        value: function execute(countdownEnd, countdownDiv, currentUtc, countDownStartWeb) {
            var valueUtc = countdownEnd;
            var endDate = new Date(valueUtc);
            var listingItem = countdownDiv.closest(this.parentElement);
            var startDateWeb = new Date(countDownStartWeb);
            var raffleIdentifier = '';

            if (endDate > currentUtc && startDateWeb < currentUtc) {
                listingItem.find('.countdown').show();
                listingItem.find('.countdown-start').remove();
            } else if (endDate > currentUtc && startDateWeb > currentUtc) {
                listingItem.find('.countdown').remove();
                listingItem.find('.countdown-start').show();
            }

            if (endDate < currentUtc) {
                countdownDiv.remove();

                if ($('body').hasClass('product') && countdownDiv.data('product-countdown') == true) {
                    // Se non è raffle faccio apparire i dati per l'acquisto
                    if (typeof raffleOpen !== 'undefined' && raffleClose !== 'undefined' && typeof formContent !== 'undefined') {
                        if (!raffleOpen && !raffleClose) {} else if ($('.raffle-close').length == 0) {
                            // Se è raffle faccio apparire raffle close perchè è scaduto il timeout
                            $('.product-item__price').after(raffleClose);
                        }

                        // Resetto le variabili
                        gender_icon = undefined;
                        price_content = undefined;
                        form_content = undefined;
                        size_value = undefined;
                        raffle_close = undefined;
                        alerts = undefined;
                    }
                } else if (listingItem.data('product-raffle') == true && listingItem.find('.label-raffle-close').length == 0) {
                    if (SlamJam.strings.current_ship_language == 'IT') {
                        raffleIdentifier = 'Web ';
                    }
                    listingItem.find('.product-card__info .product-alerts').append('<span class="product-card__label product-card__label--raffle-close">' + raffleIdentifier + 'Draw Closed' + '</span>');
                } else {
                    var productInfo = window['product_' + listingItem.data('product-id')];
                    listingItem.find('.product-card__info .product-alerts').html(productInfo);
                }

                return;
            }

            countdownDiv.parent().find('.product-card__over').remove();
            var remainingTime = endDate - currentUtc;

            var _days = Math.max(0, parseInt(remainingTime / 864e5)); //days
            remainingTime -= 864e5 * _days;
            var _hours = Math.max(0, parseInt(remainingTime / 36e5)); //hours
            remainingTime -= 36e5 * _hours;
            var _minutes = Math.max(0, parseInt(remainingTime / 6e4)); //minutes
            remainingTime -= 6e4 * _minutes;
            var _seconds = Math.max(0, parseInt(remainingTime / 1e3)); //seconds
            remainingTime -= 1e3 * _seconds;

            if (0 == _days && 0 == _hours && 0 == _minutes && 0 == _seconds) {
                window.location.reload();
            } else {
                var days = this.pad(_days),
                    hours = this.pad(_hours),
                    minutes = this.pad(_minutes),
                    seconds = this.pad(_seconds);

                if (days > 0) {
                    countdownDiv.find(".countdown__days span").html(days);
                } else {
                    countdownDiv.find(".countdown__days").hide();
                }

                countdownDiv.find(".countdown__hours .first span").html(hours.substring(0, 1));
                countdownDiv.find(".countdown__hours .second span").html(hours.substring(1, 2));
                countdownDiv.find(".countdown__minutes .first span").html(minutes.substring(0, 1));
                countdownDiv.find(".countdown__minutes .second span").html(minutes.substring(1, 2));
                countdownDiv.find(".countdown__seconds .first span").html(seconds.substring(0, 1));
                countdownDiv.find(".countdown__seconds .second span").html(seconds.substring(1, 2));
            }
        }
    }, {
        key: 'executeStartCountDown',
        value: function executeStartCountDown(countdownStart, countdownDiv, currentUtc) {

            var startDate = new Date(countdownStart);
            var listingItem = countdownDiv.closest(this.parentElement);

            countdownDiv.parent().find('.product-card__over').remove();
            var remainingTime = startDate - currentUtc;

            var _days = Math.max(0, parseInt(remainingTime / 864e5)); //days
            remainingTime -= 864e5 * _days;
            var _hours = Math.max(0, parseInt(remainingTime / 36e5)); //hours
            remainingTime -= 36e5 * _hours;
            var _minutes = Math.max(0, parseInt(remainingTime / 6e4)); //minutes
            remainingTime -= 6e4 * _minutes;
            var _seconds = Math.max(0, parseInt(remainingTime / 1e3)); //seconds
            remainingTime -= 1e3 * _seconds;

            if (0 == _days && 0 == _hours && 0 == _minutes && 0 == _seconds) {

                //window.location.reload();

            } else {
                var days = this.pad(_days),
                    hours = this.pad(_hours),
                    minutes = this.pad(_minutes),
                    seconds = this.pad(_seconds);
                //  countdownDiv.show();


                if (days > 0) {
                    countdownDiv.find(".countdown__days span").html(days);
                } else {
                    countdownDiv.find(".countdown__days").hide();
                }

                // nascondo il contdown da inizio a fine raffle
                countdownDiv.find(".countdown__hours .first span").html(hours.substring(0, 1));
                countdownDiv.find(".countdown__hours .second span").html(hours.substring(1, 2));
                countdownDiv.find(".countdown__minutes .first span").html(minutes.substring(0, 1));
                countdownDiv.find(".countdown__minutes .second span").html(minutes.substring(1, 2));
                countdownDiv.find(".countdown__seconds .first span").html(seconds.substring(0, 1));
                countdownDiv.find(".countdown__seconds .second span").html(seconds.substring(1, 2));
            }
        }
    }, {
        key: 'executeMilan',
        value: function executeMilan(countdownEndMilan, countdownDivMilan, currentUtcMilan, countDownStartMilan) {
            var valueUtc = countdownEndMilan;
            var endDateMilan = new Date(valueUtc);
            var startDateMilan = new Date(countDownStartMilan);
            var listingItemMilan = countdownDivMilan.closest(this.parentElement);

            if (endDateMilan < currentUtcMilan) {
                countdownDivMilan.remove();

                if ($('body').hasClass('template-product')) {} else if (listingItemMilan.data('product-raffle') == true && listingItemMilan.find('.label-raffle-close').length == 0) {
                    listingItemMilan.find('.product-card__info .product-alerts').append('<span class="product-card__label product-card__label--raffle-close">' + 'Milan Draw Closed' + '</span>');
                } else {
                    var productInfo = window['product_' + listingItemMilan.data('product-id')];
                    listingItemMilan.find('.product-card__info').html(productInfo);
                    listingItemMilan.find('.product-card__info .product-alerts').append('<span class="product-card__label product-card__label--raffle-close">' + 'Milan Draw Closed' + '</span>');
                }

                return;
            }

            countdownDivMilan.parent().find('.product-card__over').remove();
            var remainingTime = endDateMilan - currentUtcMilan;

            var _days = Math.max(0, parseInt(remainingTime / 864e5)); //days
            remainingTime -= 864e5 * _days;
            var _hours = Math.max(0, parseInt(remainingTime / 36e5)); //hours
            remainingTime -= 36e5 * _hours;
            var _minutes = Math.max(0, parseInt(remainingTime / 6e4)); //minutes
            remainingTime -= 6e4 * _minutes;
            var _seconds = Math.max(0, parseInt(remainingTime / 1e3)); //seconds
            remainingTime -= 1e3 * _seconds;

            if (0 == _days && 0 == _hours && 0 == _minutes && 0 == _seconds) {
                window.location.reload();
            } else {
                var days = this.pad(_days),
                    hours = this.pad(_hours),
                    minutes = this.pad(_minutes),
                    seconds = this.pad(_seconds);

                if (endDateMilan > currentUtcMilan && startDateMilan < currentUtcMilan) {
                    listingItemMilan.find('.milan-countdown-end').show();
                    listingItemMilan.find('.milan-countdown-start').remove();
                } else if (endDateMilan > currentUtcMilan && startDateMilan > currentUtcMilan) {
                    listingItemMilan.find('.milan-countdown-end').remove();
                    listingItemMilan.find('.milan-countdown-start').show();
                }

                if (days > 0) {
                    countdownDivMilan.find(".countdown__days span").html(days);
                } else {
                    countdownDivMilan.find(".countdown__days").hide();
                }

                countdownDivMilan.find(".countdown__hours .first span").html(hours.substring(0, 1));
                countdownDivMilan.find(".countdown__hours .second span").html(hours.substring(1, 2));
                countdownDivMilan.find(".countdown__minutes .first span").html(minutes.substring(0, 1));
                countdownDivMilan.find(".countdown__minutes .second span").html(minutes.substring(1, 2));
                countdownDivMilan.find(".countdown__seconds .first span").html(seconds.substring(0, 1));
                countdownDivMilan.find(".countdown__seconds .second span").html(seconds.substring(1, 2));
            }
        }
    }, {
        key: 'executeStartCountDownMilan',
        value: function executeStartCountDownMilan(countdownStartMilan, countdownDivMilan, currentUtcMilan) {

            var startDate = new Date(countdownStartMilan);
            countdownDivMilan.parent().find('.product-card__over').remove();
            var remainingTime = startDate - currentUtcMilan;

            var _days = Math.max(0, parseInt(remainingTime / 864e5)); //days
            remainingTime -= 864e5 * _days;
            var _hours = Math.max(0, parseInt(remainingTime / 36e5)); //hours
            remainingTime -= 36e5 * _hours;
            var _minutes = Math.max(0, parseInt(remainingTime / 6e4)); //minutes
            remainingTime -= 6e4 * _minutes;
            var _seconds = Math.max(0, parseInt(remainingTime / 1e3)); //seconds
            remainingTime -= 1e3 * _seconds;

            if (0 == _days && 0 == _hours && 0 == _minutes && 0 == _seconds) {
                //window.location.reload();

            } else {
                var days = this.pad(_days),
                    hours = this.pad(_hours),
                    minutes = this.pad(_minutes),
                    seconds = this.pad(_seconds);

                if (days > 0) {
                    countdownDivMilan.find(".countdown__days span").html(days);
                } else {
                    countdownDivMilan.find(".countdown__days").hide();
                }

                countdownDivMilan.find(".countdown__hours .first span").html(hours.substring(0, 1));
                countdownDivMilan.find(".countdown__hours .second span").html(hours.substring(1, 2));
                countdownDivMilan.find(".countdown__minutes .first span").html(minutes.substring(0, 1));
                countdownDivMilan.find(".countdown__minutes .second span").html(minutes.substring(1, 2));
                countdownDivMilan.find(".countdown__seconds .first span").html(seconds.substring(0, 1));
                countdownDivMilan.find(".countdown__seconds .second span").html(seconds.substring(1, 2));
            }
        }
    }, {
        key: 'init',
        value: function init() {
            var self = this;

            if ($('body').hasClass("template-product")) {
                var now = new Date();
                var offsetHour = now.getUTCHours();
                var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), offsetHour, now.getUTCMinutes(), now.getUTCSeconds());
                self.checkRaffleStatusInPdP(nowUtc);
            }

            setInterval(function () {
                var now = new Date();
                var offsetHour = now.getUTCHours();
                var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), offsetHour, now.getUTCMinutes(), now.getUTCSeconds());

                if (template != 'customers/account.order_history_milan' || template != 'customers/account.order_history') {
                    /* raffle web */
                    //countdown che si occupera di gestire il timer riguardo raffle già partita
                    $(self.countdownSelector).each(function () {
                        self.execute($(this).attr('data-available-from-utc').replace(/\u200B/g, ''), $(this), nowUtc, $(this).attr('data-start-from-utc').replace(/\u200B/g, ''));
                    });
                    //countdown che si occupera di gestire il timer riguardo raffle che dovrà partire
                    $(self.countdownStartSelector).each(function () {
                        self.executeStartCountDown($(this).attr('data-start-from-utc').replace(/\u200B/g, ''), $(this), nowUtc);
                    });
                    /* end raffle web */

                    /* raffle milano */
                    //countdown che si occupera di gestire il timer riguardo raffle già partita
                    $(self.countdownSelectorMilan).each(function () {
                        self.executeMilan($(this).attr('data-available-from-utc').replace(/\u200B/g, ''), $(this), nowUtc, $(this).attr('data-start-from-utc').replace(/\u200B/g, ''));
                    });
                    //countdown che si occupera di gestire il timer riguardo raffle che dovrà partire
                    $(self.countdownStartSelectorMilan).each(function () {
                        self.executeStartCountDownMilan($(this).attr('data-start-from-utc').replace(/\u200B/g, ''), $(this), nowUtc);
                    });
                    /* end raffle milano */
                }
            }, 1000);
        }
    }]);

    return Countdown;
}();

var RaffleModal = function () {
    function RaffleModal() {
        _classCallCheck(this, RaffleModal);

        this.raffleWarningRegisterModal = '#raffleRegister.modal';
        this.quickBtnRaffleWarningBtn = '.product-raffle';
        this.quickBtnRaffleWarningBtnClose = '#raffleRegister .js-modal-close';
        this.init();
    }

    _createClass(RaffleModal, [{
        key: 'init',
        value: function init() {
            this.addEventHandler();
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            function captureHandleProductRaffle(productHandle) {
                Cookies.set('productRedirect', productHandle);
            }

            $(document).on('click', self.quickBtnRaffleWarningBtn, function (e) {
                // se l'istanza è drop
                var productHandle = $(this).data('product-handle');
                captureHandleProductRaffle(productHandle);

                if (SlamJam.strings.dropInstance == true) {
                    $(self.raffleWarningRegisterModal).addClass('active');
                    e.preventDefault();
                }
            });

            $(document).on('click', self.quickBtnRaffleWarningBtnClose, function (e) {
                $(self.raffleWarningRegisterModal).removeClass('active');
            });
        }
    }]);

    return RaffleModal;
}();

var RaffleManagement = function () {
    function RaffleManagement() {
        _classCallCheck(this, RaffleManagement);

        this.raffleBanner = '.raffle__container .panel__container div';
        this.init();
    }

    _createClass(RaffleManagement, [{
        key: 'init',
        value: function init() {
            this.addEventHandler();
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            /* vado a verificare se sono disabilitate delle cta */
            function disableCTA() {
                if ($('.add-to-cart-wrapper').hasClass("milan-hide-true")) {
                    $('.raffle__container .panel__container .left[data-cta*="raffle-open-milan"]').addClass("disabled");
                }
                if ($('.add-to-cart-wrapper').hasClass("web-hide-true")) {
                    $('.raffle__container .panel__container .right[data-cta*="raffle-open"]').addClass("disabled");
                }
            }

            disableCTA();

            $(document).on('click', self.raffleBanner, function (e) {

                var ctaRaffleAction = $(this).data('cta');
                var currentHandleProduct = $(this).closest('.panel__container').data('product-handle');
                writeProductHandleCookie(ctaRaffleAction, currentHandleProduct, e);

                if (ctaRaffleAction == 'raffle-open') {

                    if (template != 'product.af1-black' || template != 'product.af1') {
                        $('.personal-id').hide();
                    }
                    var typeCtaRemove = 'milan-hide-true';
                    var ctaToRemove = '#AddToCart-product-template-milan';
                    //se il prodotto è chiuso vado a nascondere tasto seleziona taglie */
                    if ($('.add-to-cart-wrapper').hasClass("web-hide-true")) {} else {
                        collapseRaffleTwoContainer(typeCtaRemove, ctaToRemove);
                    }
                }

                if (ctaRaffleAction == 'raffle-open-milan') {
                    var _typeCtaRemove = 'web-hide-true';
                    var _ctaToRemove = '#AddToCart-product-template';
                    //se il prodotto è chiuso vado a nascondere tasto seleziona taglie */
                    if ($('.add-to-cart-wrapper').hasClass("milan-hide-true")) {} else {
                        collapseRaffleTwoContainer(_typeCtaRemove, _ctaToRemove);
                    }
                }
            });

            /* va a salvare l'handle del prodotto in un cookie ( per redirect ) */
            function writeProductHandleCookie(ctaRaffleAction, currentHandleProduct, e) {
                if (ctaRaffleAction == 'register' || ctaRaffleAction == 'login') {
                    Cookies.set('productRedirect', currentHandleProduct);
                }
            }

            /* funzione che va a nascodere il blocco per le doppie raffle
            una volta che se ne clicca una delle due */
            function collapseRaffleTwoContainer(typeCtaRemove, ctaToRemove) {

                if (!SlamJam.isMobile(SlamJam.costants.grid_medium, false)) {
                    $('.raffle').hide();
                    $('.add-to-cart-wrapper').removeClass(typeCtaRemove);
                    $('.add-to-cart-wrapper').removeClass("multi-raffle");
                    $(ctaToRemove).remove(); // cosi è brutto vedere come fare meglio;
                }
            }
        }
    }]);

    return RaffleManagement;
}();

var RaffleMilan = function () {
    function RaffleMilan() {
        _classCallCheck(this, RaffleMilan);

        var isStaging = SlamJam.strings.raffle.isStageWebSite;
        var pimUrlAjaxCall = '';

        if (isStaging) {
            pimUrlAjaxCall = SlamJam.strings.raffle.raffleAjaxUrlStaging;
        } else {
            pimUrlAjaxCall = SlamJam.strings.raffle.raffleAjaxUrlProd;
        }

        this.ctaMilanBtn = '#AddToCart-product-template-milan, .raffle-pdp #AddToCart-product-template-milan';
        // chiamata che vado a fare quando premo "enter the raffle" (add to cart raffle milano)
        this.raffleOrderPhysicalCallUrl = pimUrlAjaxCall + '/api/v1/frontend/physicalraffleorders';
        // chiamata che vado a fare quando sono in account page e ricevo ordini
        this.raffleOrderPhysicalCallUrlReceive = pimUrlAjaxCall + '/api/v1/frontend/physicalraffleorders/rafflebycustomer';
        this.raffleMilanContainerToInject = '.information_container.order-history-milan .order-history__items';
        this.raffleDeleteOrdersCta = '#raffleDelete .unsubscribe';
        this.raffleModalDelete = '#raffleDelete';
        this.raffleUnsubscribeBtnItemWeb = '.delete-order'; //web cta delete
        this.raffleUnsubscribeBtnItemMilan = '.order-history__items__cancel'; //milan cta delete
        this.raffleBackToItemsView = '#raffleDelete .back';
        this.raffleCountdownMilan = '.order-history-milan .account-countdown';
        this.raffleCountdownWeb = '.order-history .account-countdown';
        this.raffleTemplate3d = '#AddToCartForm-product-template-raffle-3d';
        this.ctaMilan();
        this.milanAccountOrders();
    }

    _createClass(RaffleMilan, [{
        key: 'ctaMilan',
        value: function ctaMilan() {
            var self = this;

            function sendRaffleInformation(customerName, customerLastName, customerID, customerMail, raffleID, skuVariant, variant, currency, productTitle, vendor, productPrice, productImage, personalID, e) {

                $.ajax({
                    url: self.raffleOrderPhysicalCallUrl,
                    type: "POST",
                    data: {
                        raffle_id: raffleID,
                        sku: skuVariant,
                        first_name: customerName,
                        last_name: customerLastName,
                        email: customerMail,
                        creation_channel_customer_id: customerID,
                        variant_title: variant,
                        currency: currency,
                        product_title: productTitle,
                        vendor: vendor,
                        product_price: productPrice,
                        product_image: productImage,
                        personal_ID: personalID

                    },
                    dataType: "json",

                    success: function success() {
                        /*Se la chiamata è success vado a mostrare il messaggio: "thank you"
                        con relativa descrizione (informazioni prese tutte dai locales) */

                        if ($(self.raffleTemplate3d).length) {
                            $('#AddToCartForm-product-template-raffle-3d').hide();
                        } else {
                            $('#AddToCartForm-product-template-raffle').hide();
                        }

                        if (template == "product.af1-black" || template == "product.af1") {
                            $('#raffle-milano-success').addClass("active");
                        } else {
                            var raffleSuccessThankYou = "<div class=\"raffle-success\">" + "<div class=\"raffle-success__container\">" + "<div class=\"success-title\">" + SlamJam.strings.product.raffle.thank_you_title + "</div>" + "<div class=\"success-description\">" + SlamJam.strings.product.raffle.thank_you_message + "</div>" + "</div>\
                         </div>";
                            $(".add-to-cart-wrapper").after(raffleSuccessThankYou);
                        }
                    },

                    error: function error(request) {
                        /*Se vado in errore mostro il messaggio di errore preso dalla response
                        della chiamata AJAX */

                        if ($(self.raffleTemplate3d).length) {
                            $('#AddToCartForm-product-template-raffle-3d').hide();
                        } else {
                            $('#AddToCartForm-product-template-raffle').hide();
                        }

                        //let responseError = JSON.parse(request.responseText);
                        var errorMessage = "You have already subscribed to this Draw. If the information submitted isn't correct, please cancel your entry and subscribe again.";
                        var raffleErrorMessage = "<div class=\"raffle-messages\">" + "<div class=\"raffle-error__container\">" + errorMessage + "</div>\
                    </div>";

                        if (template == "product.af1-black" || template == "product.af1") {
                            $('#raffle-milano-error').addClass("active");
                        } else {
                            if ($(window).width() < SlamJam.costants.grid_medium) {
                                $('.raffle-cta').append(raffleErrorMessage);
                            } else {
                                $(".add-to-cart-wrapper").after(raffleErrorMessage);
                            }
                        }
                    }
                });
                e.stopImmediatePropagation(); //fix chiamata che viene ripetuta due volte
            }
            $(self.ctaMilanBtn).click(function (e) {
                var canAdd = '';

                if ($(window).width() < SlamJam.costants.grid_medium) {
                    if (template == "product.af1-black" || template == 'product.af1') {
                        canAdd = $('#add-to-cart-sticky-wrapper .personal-id .personal-id-txt').val().length;
                    } else {
                        canAdd = $('#add-to-cart-sticky-wrapper .personal-id-txt').val().length;
                    }
                } else {
                    canAdd = $('.personal-id .personal-id-txt').val().length;
                }

                console.log(canAdd);

                if (canAdd) {
                    if ($(window).width() > SlamJam.costants.grid_medium) {
                        var selectSize = $('.product-select-variant__value.active').length;
                        /*verifico se l'utente abbia selezionato una variante
                        se cosi fosse allora procedo con la chiamata */
                        if (selectSize > 0) {
                            var skuVariant = $('.product-select-variant__value.active').attr('data-variant-sku');
                            var variant = $('.product-select-variant__value.active').attr('data-value');
                            var currency = $('body').attr("currency");
                            var raffleID = $(this).attr('raffleid');
                            var customerName = $(this).attr('customer-name');
                            var customerLastName = $(this).attr('customer-last');
                            var customerID = $(this).attr('customer-id');
                            var customerMail = $(this).attr('customer-mail');
                            var productTitle = $(this).attr('nameproduct');
                            var vendor = $(this).attr('brand');
                            var productPrice = $(this).attr('productPrice');
                            var productImage = $(this).attr('productimage');
                            var personalID = $('.personal-id-txt').val();

                            sendRaffleInformation(customerName, customerLastName, customerID, customerMail, raffleID, skuVariant, variant, currency, productTitle, vendor, productPrice, productImage, personalID, e);
                        } else {
                            $('.product-select-variant__title').addClass("opened");
                            $('.product-select-variant__content').removeClass("hide");
                            e.preventDefault();
                        }
                    } else {

                        $('.product-select-variant.sticky').show(); //do la possibilità di visualizzare taglie

                        if (template != "product.af1-black" || template != "product.af1") {
                            $('.personal-id').hide(); //nascondo blocco personalID
                        }

                        if ($('.product-select-variant').hasClass("one-size")) {
                            var _skuVariant = $('.product-select-variant__value.active').attr('data-variant-sku');
                            var _variant = $('.product-select-variant__value.active').attr('data-value');
                            var _currency = $('body').attr("currency");
                            var _raffleID = $('#AddToCart-product-template-milan').attr('raffleid');
                            var _customerName = $('#AddToCart-product-template-milan').attr('customer-name');
                            var _customerLastName = $('#AddToCart-product-template-milan').attr('customer-last');
                            var _customerID = $('#AddToCart-product-template-milan').attr('customer-id');
                            var _customerMail = $('#AddToCart-product-template-milan').attr('customer-mail');
                            var _productTitle = $('#AddToCart-product-template-milan').attr('nameproduct');
                            var _vendor = $('#AddToCart-product-template-milan').attr('brand');
                            var _productPrice = $('#AddToCart-product-template-milan').attr('productPrice');
                            var _productImage = $('#AddToCart-product-template-milan').attr('productimage');
                            var _personalID = $('#add-to-cart-sticky-wrapper .personal-id .personal-id-txt').val();

                            sendRaffleInformation(_customerName, _customerLastName, _customerID, _customerMail, _raffleID, _skuVariant, _variant, _currency, _productTitle, _vendor, _productPrice, _productImage, _personalID, e);
                        }
                        $('.product-select-variant__value').click(function (e) {
                            var skuVariant = $('.product-select-variant__value.active').attr('data-variant-sku');
                            var variant = $('.product-select-variant__value.active').attr('data-value');
                            var currency = $('body').attr("currency");
                            var raffleID = $('#AddToCart-product-template-milan').attr('raffleid');
                            var customerName = $('#AddToCart-product-template-milan').attr('customer-name');
                            var customerLastName = $('#AddToCart-product-template-milan').attr('customer-last');
                            var customerID = $('#AddToCart-product-template-milan').attr('customer-id');
                            var customerMail = $('#AddToCart-product-template-milan').attr('customer-mail');
                            var productTitle = $('#AddToCart-product-template-milan').attr('nameproduct');
                            var vendor = $('#AddToCart-product-template-milan').attr('brand');
                            var productPrice = $('#AddToCart-product-template-milan').attr('productPrice');
                            var productImage = $('#AddToCart-product-template-milan').attr('productimage');
                            var personalID = $('#add-to-cart-sticky-wrapper .personal-id .personal-id-txt').val();

                            sendRaffleInformation(customerName, customerLastName, customerID, customerMail, raffleID, skuVariant, variant, currency, productTitle, vendor, productPrice, productImage, personalID, e);
                        });
                    }
                } else {
                    e.stopPropagation();
                    $('.product-select-variant.sticky').hide();
                    $('#personal-id-modal').addClass("active");
                    Cookies.set('productRedirect', SlamJam.strings.product.general.handle);
                }
            });
        }
    }, {
        key: 'milanAccountOrders',
        value: function milanAccountOrders() {
            var self = this;
            var accountMilanArea = $('.template-customers-account .order-history-milan');
            var customerID = $('#customerID').attr("value");
            var showMilanOrdersTab = false;
            var milanOrdersTab = $('#milan-orders');

            if (SlamJam.strings.dropInstance == true) {
                if (accountMilanArea.length) {
                    receiveOrdersMilan(); // faccio chiamata al pim per prendermi gli item
                } else {
                    assignCountdown(); // vado direttamente a gestire i countdown
                }

                if (window.location.href.indexOf("account?view=order_history_milan") > -1) {
                    if (Shopify.country == 'IT') {
                        checkMilanOrders(); // richiesta Giacomo: verifica presenza di ordini milano
                    }
                }
            }

            function checkMilanOrders() {
                var settings = {

                    "url": self.raffleOrderPhysicalCallUrlReceive,
                    "method": "GET",
                    "headers": {
                        "content-type": "application/x-www-form-urlencoded"
                    },
                    "data": {
                        "customer_id": customerID
                    }
                };

                $.ajax(settings).done(function (response) {

                    if (response.data.orders.length > 0) {
                        showMilanOrdersTab = true;
                        $(milanOrdersTab).removeClass("hide");
                    }
                });
            }

            //ricevo dal pim gli item da elaborare
            function receiveOrdersMilan() {
                $('.loading-wrapper').css("display", "flex");
                var customerID = $('#customerID').attr("value");
                var settings = {

                    "url": self.raffleOrderPhysicalCallUrlReceive,
                    "method": "GET",
                    "headers": {
                        "content-type": "application/x-www-form-urlencoded"
                    },
                    "data": {
                        "customer_id": customerID
                    }
                };
                printRaffleOrdersMilan(settings);
            }

            //vado a stampare tutti gli item
            function printRaffleOrdersMilan(settings) {
                $.ajax(settings).done(function (response) {
                    var count = 0;
                    var totalItems = response.data.orders.length;

                    if (totalItems > 0) {
                        $.each(response.data.orders, function (index, item) {
                            count++;
                            var itemsDrop = void 0;
                            var item_price = Shopify.formatMoney(item.product_price.replace(',', '.'), SlamJam.settings.moneyFormat);
                            itemsDrop = '\n                        <hr class="separator" />\n                        <div class="order-history__items__item">\n                            <div style="display: none;" class="order-history__items__item_row number">\n                                <div>Subscription: ' + item.internal_id + '</div>\n                            </div>\n                            <div class="order-history__items__item_row sx">\n                                <div class="order-history__items__item_row__image">\n                                    <div class="ratio-container">\n                                        <img class="transition--fade-in lazyload" src="' + item.product_image + '>">\n                                    </div>\n                                </div>\n                                <div class="order-history__items__item_row__info">\n                                    <div class="top">\n                                        <div class="order-history__items__item_row vendor">\n                                            ' + item.vendor + '\n                                        </div>\n                                        <div class="order-history__items__item_row title">\n                                            ' + item.product_title + '\n                                        </div>\n                                        <div class="order-history__items__item_row variant">\n                                            <div>\n                                                Size: ' + item.variant_title + '\n                                            </div>\n                                        </div>\n                                        <div class="order-history__items__item_row date">\n                                            <div>\n                                                Subscription Date: ' + item.created_at_front_end + '\n                                            </div>\n                                        </div>\n                                        <div class="order-history__items__item_row status">\n                                            <div>\n                                            ' + (item.win === 1 ? 'Draw Status: You won! Order Completed' : item.voided === 1 ? 'Draw Status: unsubscribed' : item.lose === 1 ? 'Draw Status: Lose' : "") + '\n\n                                            </div>\n                                        </div>\n                                        <div date-end="' + item.end_date + '" class="order-history__items__item_row account-countdown">\n                                            <div class="countdown-account">\n                                                <div>Draw closes in:</div>\n                                                <div class="countdown-account__container">\n                                                    <div class="countdown__days"></div>\n                                                    <div class="hours"></div>\n                                                    <div class="minutes"></div>\n                                                    <div class="seconds"></div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="bottom">\n                                        <div class="order-history__items__item__row__total-price">\n                                            ' + item_price + '\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            ' + (item.financial_status === 'pending' ? '<button current-id="' + item.id + '" type="milan" class="order-history__items__cancel btn"> UNSUBSCRIBE</button>' : "") + '\n                        </div>';
                            // va a fare l'append degli elementi processati dentro il div
                            $(self.raffleMilanContainerToInject).append(itemsDrop);
                        });
                        // vado ad assegnare i countdown alle relative scacchiere di items
                        assignCountdown(count, totalItems);
                    } else {
                        var message = "Not orders placed yet.";
                        $('.order-history__items').append(message);
                        $('.loading-wrapper').css("display", "none");
                    }
                });
            }

            /* gestisce i relativi countdown da visualizzare perchè la funzione
                è la stessa sia per il web che milano
            */
            function assignCountdown(count, totalItems) {
                var allItemsSelector = void 0;

                if (count != undefined && totalItems != undefined) {
                    if (count === totalItems) {
                        allItemsSelector = self.raffleCountdownMilan;
                        countDownManagement(allItemsSelector); // se sono milano
                    }
                } else {
                    allItemsSelector = self.raffleCountdownWeb;
                    countDownManagement(allItemsSelector); // se sono web
                }
            }

            function countDownManagement(allItemsSelector) {
                // controllo se gli elementi processati sono tutti
                $(allItemsSelector).each(function () {

                    var endDate = $(this).attr('date-end');
                    var currentDiv = $(this);

                    function makeTimer(endDate, currentDiv) {
                        var endTime = new Date(endDate);
                        endTime = Date.parse(endTime) / 1000;
                        var now = new Date();
                        var offsetHour = now.getUTCHours();
                        var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), offsetHour, now.getUTCMinutes(), now.getUTCSeconds());
                        now = Date.parse(nowUtc) / 1000;

                        if (endTime > now) {
                            var timeLeft = endTime - now;
                            var days = Math.floor(timeLeft / 86400);
                            var hours = Math.floor((timeLeft - days * 86400) / 3600);
                            var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
                            var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);

                            if (days < "10") {
                                days = "0" + days;
                            }
                            if (hours < "10") {
                                hours = "0" + hours;
                            }
                            if (minutes < "10") {
                                minutes = "0" + minutes;
                            }
                            if (seconds < "10") {
                                seconds = "0" + seconds;
                            }

                            // se nel mentre il timer finisce ricarico la pagina
                            if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
                                location.reload();
                            }

                            if (days) {
                                currentDiv.find(".countdown-account .countdown__days").html(days + "<span>days and </span>");
                            }
                            if (hours) {
                                currentDiv.find(".countdown-account .hours").html(hours + "<span>:</span>");
                            }
                            if (minutes) {
                                currentDiv.find(".countdown-account .minutes").html(minutes + "<span>:</span>");
                            }
                            if (seconds) {
                                currentDiv.find(".countdown-account .seconds").html(seconds);
                            }
                        } else {
                            currentDiv.find(".countdown-account").html(SlamJam.strings.product.general.raffle_close);
                            currentDiv.closest('.order-history__items__item').find(".order-history__items__cancel").hide();
                            currentDiv.closest('.order-history__items__item').find(".delete-order").hide();
                        }
                    }
                    setInterval(function () {
                        makeTimer(endDate, currentDiv);
                    }, 1000);
                });
                $('.loading-wrapper').css("display", "none");
            }

            function showModalConfirm(orderID, type) {
                $(self.raffleModalDelete).addClass("active");
                deleteOrder(orderID, type);
            }

            function hideModalConfirm() {
                $(self.raffleModalDelete).removeClass("active");
            }

            function deleteOrder(orderID, type) {
                var url = void 0;
                var isStaging = SlamJam.strings.raffle.isStageWebSite;
                var pimUrlAjaxCall = '';

                if (isStaging) {
                    pimUrlAjaxCall = SlamJam.strings.raffle.raffleAjaxUrlStaging;
                } else {
                    pimUrlAjaxCall = SlamJam.strings.raffle.raffleAjaxUrlProd;
                }
                //review call about web orders
                if (type == "web") {
                    url = pimUrlAjaxCall + '/api/v1/frontend/raffleorders/' + orderID;
                }

                if (type == "milan") {
                    url = pimUrlAjaxCall + '/api/v1/frontend/physicalraffleorders/' + orderID;
                }

                $(self.raffleDeleteOrdersCta).click(function () {
                    var reload = true;
                    $('.loading-wrapper').css("display", "flex");

                    $.ajax({
                        url: url,
                        type: 'DELETE',
                        success: function success() {
                            $('#raffleDelete .raffle-modal__content').empty();
                            var raffleDeleteSuccessfully = "<p>You have Successfully unsubscribed from this raffle. You will receive a confirmation mail.</p>";
                            $("#raffleDelete .raffle-modal__content").append(raffleDeleteSuccessfully);
                            var btnClose = "<div class=\"text-center\"><button class=\"btn js-modal-close\">CLOSE</button></div>";
                            $("#raffleDelete .raffle-modal__content").append(btnClose);
                            SlamJam.closeModal(reload);
                            $('.loading-wrapper').css("display", "none");
                        },
                        error: function error(request) {
                            /*Se vado in errore mostro il messaggio di errore preso dalla response
                            della chiamata AJAX */
                            $('#raffleDelete .raffle-modal__content').empty();
                            var responseError = JSON.parse(request.responseText);
                            var raffleErrorMessage = "<div class=\"raffle-result\">" + "<div class=\"raffle-error__container\">" + responseError.messages + "</div>\
                        </div>";
                            $("#raffleDelete .raffle-modal__content").html(raffleErrorMessage);
                            SlamJam.closeModal(reload);
                            $('.loading-wrapper').css("display", "none");
                        }
                    });
                });
            }

            $('body').on('click', self.raffleBackToItemsView, function () {
                hideModalConfirm();
            });

            $('body').on('click', self.raffleUnsubscribeBtnItemWeb, function () {
                var orderID = parseInt($(this).attr("orderid"));
                var type = "web";
                showModalConfirm(orderID, type);
            });

            $('body').on('click', self.raffleUnsubscribeBtnItemMilan, function () {
                var orderID = parseInt($(this).attr("current-id"));
                var type = $(this).attr("type");
                showModalConfirm(orderID, type);
            });
        }
    }]);

    return RaffleMilan;
}();

var Brands = function () {
    function Brands() {
        _classCallCheck(this, Brands);

        this.lettersSections = $(".all-brands .all-brands__section"); // section con tutte le lettere (anche quelle da escludere)
        this.vendorList = $(".all-brands .all-brands__vendors-list"); //lista con dentro i valori delle lettere (es n nike, a adidas)
        this.removeLetters();
    }

    _createClass(Brands, [{
        key: 'removeLetters',
        value: function removeLetters() {
            this.lettersSections.each(function () {
                var id = $(this).attr('id');
                if ($(this).find('ul').children().length == 0) {
                    $(this).closest('.all-brands__section').remove();
                    $('a[href="#' + id + '"]').closest('.all-brands__letter').remove();
                    $('.all-brands').show();
                }
            });
        }
    }]);

    return Brands;
}();

var ProductTemplateShopByLook = function () {
    /**
     * Fare attenzione al _dom da inserire
     * @param {*} _dom Contenitore Padre della scheda prodotto TOP, div principale della sezione Ex. section/product-template.liquid
     */
    function ProductTemplateShopByLook(_dom) {
        _classCallCheck(this, ProductTemplateShopByLook);

        this.dom = _dom;
        // Bloccho informazioni prodotto
        this.productDetailsDesktop = $('.shop-by-look__cta', this.dom);
        this.blockAddToCartDesktop = this.productDetailsDesktop.find('.add-to-cart-wrapper'); // BLocco nelle informazioni prodotto DX
        this.ProductSelectVariantShopByLook = null; // Select presente nel blocco DX della scheda prodotto
        this.init();
    }

    _createClass(ProductTemplateShopByLook, [{
        key: 'init',
        value: function init() {
            this.ProductSelectVariantShopByLook = new ProductSelectVariantShopByLook(this.productDetailsDesktop);
        }
    }]);

    return ProductTemplateShopByLook;
}();

var ProductTemplateQuickView = function () {
    /**
     * Fare attenzione al _dom da inserire
     * @param {*} _dom Contenitore Padre della scheda prodotto TOP, div principale della sezione Ex. section/product-template.liquid
     */
    function ProductTemplateQuickView(_dom) {
        _classCallCheck(this, ProductTemplateQuickView);

        this.dom = _dom;
        this.slickSliderDots = null;
        this.classCosSlickDots = 'cos-slick-dots';

        this.form = this.dom.find('[data-cart-form]');

        // Bloccho informazioni prodotto
        this.productDetailsDesktop = $('.product-details__dx', this.dom);
        this.blockAddToCartDesktop = this.productDetailsDesktop.find('.add-to-cart-wrapper'); // BLocco nelle informazioni prodotto DX

        // Immagini della galleria
        this.productSinglePhotoWrapper = $('.product-details__sx', this.dom).find('.product-single__photo-wrapper');

        this.productSelectVariantCollection = null; // Select presente nel blocco DX della scheda prodotto

        // Back In Stock
        this.backInStock = new BackInStock(this.blockAddToCartDesktop, false);

        this.init();
    }

    _createClass(ProductTemplateQuickView, [{
        key: 'init',
        value: function init() {
            this.setSliderImage();
            // Back in stock
            this.backInStock.init();

            this.productSelectVariantCollection = new ProductSelectVariant(this.productDetailsDesktop, {
                backInStock: this.backInStock
            });
        }

        //Crea Slick Slider per le immagini, e nasconde i dots e le frecce se è presente una sola immagine

    }, {
        key: 'setSliderImage',
        value: function setSliderImage() {
            var totalImages = this.productSinglePhotoWrapper.length;

            var settings = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true
            };

            if (totalImages > 1) {
                settings = $.extend(settings, {
                    dots: true,
                    customPaging: this.customPaging.bind(this),
                    arrows: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    prevArrow: '<button type="button" class="slick-arrow slick-arrow-prev">' + $('#caretImage').html() + '</button>',
                    nextArrow: '<button type="button" class="slick-arrow slick-arrow-next">' + $('#caretImage').html() + '</button>'
                });
            }

            $('.product-details__images', this.dom).on('init', this.onSlickInit.bind(this)).on('beforeChange', this.onBeforeChangeSlide.bind(this)).on('afterChange', this.onAfterChangeSlide.bind(this)).on('mousedown', this.onMouseDownChangeSlide.bind(this)).slick(settings);
        }

        /**
         * Gestisce i dots che si colorano in alto alla foto
         * @param {*} slider
         * @param {*} i
         */

    }, {
        key: 'customPaging',
        value: function customPaging(slider, i) {
            var totalSlide = slider.$slides.length;
            var currentSlide = i + 1;
            var numberSLide = currentSlide;
            var cssClass = this.classCosSlickDots;

            if (currentSlide < 10) {
                numberSLide = '0' + numberSLide;
            }

            if (currentSlide == 1) {
                cssClass = cssClass + ' colored';
            }

            return '<button type="button" class="' + cssClass + '" role="tab" id="slick-slide-control-' + numberSLide + '" aria-controls="slick-slide' + numberSLide + '" aria-label="' + numberSLide + ' of ' + totalSlide + '" tabindex="-1" style="width: 100%;">' + currentSlide + '</button>';
        }
    }, {
        key: 'onSlickInit',
        value: function onSlickInit() {
            $('.product-details__images', this.dom).find('.product-single__photo--flex-wrapper').css('position', 'relative');
            this.setSlickDots();
        }

        //Crea gli oggetti dei dots che hanno la loro logica esteerna alla classe dello slider

    }, {
        key: 'setSlickDots',
        value: function setSlickDots() {
            this.slickSliderDots = new SlickSliderDots($('.product-details__images', this.dom), this.classCosSlickDots);
        }
    }, {
        key: 'gotToSlide',
        value: function gotToSlide(slide) {
            this.slickSliderDots.setSlide(slide);
        }
    }, {
        key: 'onAfterChangeSlide',
        value: function onAfterChangeSlide(event, slick, currentSlide) {
            this.gotToSlide(currentSlide);
        }
    }, {
        key: 'onBeforeChangeSlide',
        value: function onBeforeChangeSlide(event, slick, currentSlide) {
            $('.product-details__image-overlay').remove();
        }
    }, {
        key: 'onMouseDownChangeSlide',
        value: function onMouseDownChangeSlide(event) {
            $('.product-details__image-overlay').remove();
            $(event.currentTarget).off('mouseup');
        }
    }]);

    return ProductTemplateQuickView;
}();

/**
 * Gestione caricamneto rodotti clicando sulle immagini swatch dei prodotti all'interno della quickview
 */


var QuickViewSwatch = function () {
    function QuickViewSwatch() {
        _classCallCheck(this, QuickViewSwatch);

        this.swatchLink = '.swatch-products__link'; // bottone quickshop sopra prodotto nel listato
        this.addEventHandler();
    }

    _createClass(QuickViewSwatch, [{
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            $(this.swatchLink).on('click', function (e) {
                e.preventDefault();
                $(this).unbind(e); //Remove current handler, because the system relaod a new product and new handle
                self.getProducts($(this).data('product-handle'));
            });
        }
    }, {
        key: 'getProducts',
        value: function getProducts(productHandle) {
            $('body').trigger('show-loading', {
                handle: 'quickview-loading'
            });

            $.ajax({
                url: '/products/' + productHandle + '?view=ajax-form',
                success: function success(result) {
                    $('#quickShop.modal .popup-content').html(result);

                    $('body').trigger('hide-loading', {
                        handle: 'quickview-loading'
                    });

                    SlamJam.quickview.reset();
                }
            });
        }
    }]);

    return QuickViewSwatch;
}();

/**
 * Classe gestione popup quickview
 */


var QuickView = function () {
    function QuickView() {
        _classCallCheck(this, QuickView);

        this.quickShopModal = '#quickShop.modal';
        this.quickBtn = '.quick-view';
        this.quickBtnClose = '#quickShop .quickview__close, .js-modal-close';
        this.modalQuickViewContent = '#quickShop.modal .popup-content';

        this.variantToAdd = null;

        this.init();
    }

    _createClass(QuickView, [{
        key: 'init',
        value: function init() {
            this.addEventHandler();
        }
    }, {
        key: 'reset',
        value: function reset() {
            SlamJam.ProductTemplateQuickView = new ProductTemplateQuickView($('#modal-popup, #QuickViewContainer'));
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;

            $(document).on('click', self.quickBtn, function () {
                var currentHandle = $(this).attr('product-handle');
                $(this).addClass("current-open");
                // SlamJam.variant = $('.quick-view.current-open').prev('.product-card__image').attr("data-index");
                window.quickShopPosition = $(this).attr("data-index");
                $('body').trigger('show-loading', {
                    handle: 'quickview-loading'
                });

                $(self.modalQuickViewContent).html('');
                $(self.quickShopModal).addClass('active');

                $.ajax({
                    url: '/products/' + currentHandle + '?view=ajax-form',
                    success: function success(result) {
                        $(self.modalQuickViewContent).html(result);

                        $('body').trigger('hide-loading', {
                            handle: 'quickview-loading'
                        });

                        // TODO: da rivedere. Se lo sposto da qui non funziona
                        $('#quickShop .product-select-variant__value').on('click', function () {
                            self.variantToAdd = $(this).attr('data-variant-id');
                        });

                        self.reset();

                        SlamJam.closeModal();
                    }
                });
            });

            $(document).on('click', self.quickBtnClose, function (e) {
                $(self.quickShopModal).removeClass('active');
                console.log("cliccato");
                $('.product-card__label--quick-shop').removeClass("current-open");
            });

            $(document).on('click', '#quickShop .btn--add-to-cart', function (e) {
                e.preventDefault();

                $('body').trigger('show-loading', {
                    handle: 'quickview-loading'
                });

                var productToAdd = { id: self.variantToAdd };

                SlamJam.Cart.addItem(SlamJam.ProductTemplateQuickView.form.data('product-id'), self.variantToAdd, 1, SlamJam.ProductTemplateQuickView.form.data('limiter'), productToAdd, SlamJam.ProductTemplateQuickView.form.data('one-pair-per-customer'), function () {
                    SlamJam.minicart.refreshMinicart();

                    $('body').trigger('hide-loading', {
                        handle: 'quickview-loading'
                    });

                    $('.modal').removeClass('active');
                }, function (XMLHttpRequest) {
                    $('body').trigger('hide-loading', {
                        handle: 'quickview-loading'
                    });

                    SlamJam.showPopUpErrorFromAjaxRequest(XMLHttpRequest);
                });
            });
        }
    }]);

    return QuickView;
}();

var Cart = function () {
    function Cart() {
        _classCallCheck(this, Cart);

        this.editBtn = $('.cart-edit');
        this.deleteItem = $('.delete-item');

        this.openModalEdit();
        this.gtmActionProductClick();
        this.gtmActionRemove();

        if ($('.randomize-handles').length > 0) {
            this.randomizeRelatedProducts();
        }

        this.modalMultiLocations();
        this.handleCouponCode();
    }

    _createClass(Cart, [{
        key: 'gtmActionProductClick',
        value: function gtmActionProductClick() {
            $('.cart-page__item__content__image a').click(function (e) {
                trackGtmInfoClick($(this));
            });
        }
    }, {
        key: 'gtmActionRemove',
        value: function gtmActionRemove() {
            function trackGtmInfoRemoveItemCart(lineItem) {

                dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
                dataLayer.push({
                    "event": "remove_from_cart",
                    "ecommerce": {

                        "currency": $('body').attr("currency"),
                        "value": lineItem.attr("item_price"),
                        "items": [{
                            "item_id": lineItem.attr("item_id"),
                            "item_name": lineItem.attr("item_name"),
                            "item_brand": lineItem.attr("item_vendor"),
                            "item_category": lineItem.attr("item_category"),
                            "item_category2": lineItem.attr("item_categoryv2"),
                            "item_category3": lineItem.attr("item_categoryv3"),
                            "affiliation": GTM.affiliation,
                            "discount": "",
                            "coupon": "",
                            "price": lineItem.attr("item_price"),
                            "quantity": 1,
                            "item_sale": lineItem.attr("item_sale"),
                            "item_gender": lineItem.attr("item_gender"),
                            "item_availability": lineItem.attr("item_availability"),
                            "item_color": lineItem.attr("item_color"),
                            "item_style_code": lineItem.attr("item_style_code"),
                            "item_variant": lineItem.attr("item_barcode"),
                            "index": lineItem.attr("item_index")
                        }]
                    },
                    "gtm.uniqueEventId": 16
                });
            }

            $('.cart-page__item__content__actions .delete-item').click(function (e) {
                trackGtmInfoRemoveItemCart($(this));
            });
        }
    }, {
        key: 'handleCouponCode',
        value: function handleCouponCode() {
            /*  nel caso in cui il disocunt code dovrà rimanere salvato.
                var updateCartAttributes = function(discountCode, callback) {
                    var params = {
                    type: 'POST',
                    url: '/cart/update.js',
                    data: "attributes[discount_code]=" + theDiscount,
                    dataType: 'json',
                    success: function(cart) {
                        if ((typeof callback) === 'function') {
                        callback(cart);
                        }
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        Shopify.api.onError(XMLHttpRequest, textStatus);
                    }
                    };
                    $.ajax(params);
                }
            */

            $('#redemDevPromo').click(function (event) {
                event.preventDefault();

                if ($('#devPromo').val().length > 0) {
                    var checkOutUrl = '/checkout?discount=';
                    var discountCode = $('#devPromo').val();
                    var redirect = checkOutUrl + discountCode;
                    //  updateCartAttributes(discountCode);
                    window.location.href = redirect;
                }
            });
        }
    }, {
        key: 'openModalEdit',
        value: function openModalEdit() {
            this.editBtn.click(function () {
                var currentHandle = $(this).attr('product-handle'); // mi vado a prendere l'handle del prodotto per la chiamata alla product page
                var oldVariant = $(this).attr('variant-id'); // mi catturo l'id della variante da eliminare in seguito
                var variantQuantity = $(this).attr('variant-quantity'); // mi catturo la quantità corrente
                var variantInventoryQuantity = $(this).attr('data-variant-inventory');

                $('body').trigger('show-loading', {
                    handle: 'generic-loading'
                });

                $('#EditCart.modal').addClass("active visibleOverflow");

                SlamJam.editItem($('#EditCart.modal'), currentHandle, oldVariant, variantQuantity);
            });
        }
    }, {
        key: 'randomizeRelatedProducts',
        value: function randomizeRelatedProducts() {
            var promises = [];
            var handlesToDisplay = $('.randomize-handles').data('handles').replace(/\s/g, '').split(',');
            handlesToDisplay = handlesToDisplay.sort(function () {
                return .5 - Math.random();
            }).slice(0, 4);
            var totalProductOk = new Array(); // Contiene le risposte delle chiamata AJAX che sono andate a buon fine
            var totalProductError = new Array(); // Contiene le risposte delle chiamate AJAX che sono andate in errore

            var all = function all(array) {
                var deferred = $.Deferred();
                var fulfilled = 0,
                    length = array.length;
                var results = [];

                if (length === 0) {
                    deferred.resolve(results);
                } else {
                    array.forEach(function (promise, i) {
                        $.when(promise()).then(function (value) {
                            results[i] = value;
                            fulfilled++;

                            if (fulfilled === length) {
                                deferred.resolve(results);
                            }
                        });
                    });
                }

                return deferred.promise();
            };

            $.each(handlesToDisplay, function (index, value) {
                if (value) {
                    promises.push(function () {
                        return $.Deferred(function (dfd) {
                            $.get('/products/' + value + '?view=related').done(function (data) {
                                $('body').find('.product-related-' + index).after(data);
                                $('body').find('.product-related-' + index).remove();

                                //Salvo la risposta nei prodotti inserito
                                totalProductOk.push({ handle: value, response: data });

                                dfd.resolve(data);
                            }).fail(function (data) {
                                //Salvo la risposta nei prodotti errati
                                totalProductError.push({ handle: value, response: data });
                                dfd.resolve(data);
                            });
                        }).promise();
                    });
                }
            });

            $.when(all(promises)).then(function (data) {
                // Se non ci sono prodotti correlati, nascondo il div
                if ($('.randomize-handles').find('.product-card').length == 0) {
                    $('.related-container').hide();
                }
            });
        }

        /**
         * Avvia la modale della spedizione su più locations
         */

    }, {
        key: 'modalMultiLocations',
        value: function modalMultiLocations() {
            //TODO: fare API per capire se si sta spedendo da più magazzini. Se la spedizione è su più location si deve vedere il popup. Simuliamo che sia su multilocations
            if (SlamJam.strings.dropInstance != true) {
                if ($('.cart-page__items').length >= 1) {
                    //   $('.modal-multi-locations').addClass('active');
                }
            }
            SlamJam.closeModal();
        }
    }]);

    return Cart;
}();

/**
 * Gestione form forgot passwors
 */


var FormForgotPassword = function () {
    /**
     *
     * @param {object} _dom  Contenitore
     * @param {boolean} initOnCreate == TRUE init with default settings
     */
    function FormForgotPassword(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, FormForgotPassword);

        this.dom = _dom;
        this.form = null;
        this.recoverPasswordCta = null;
        this.formObject = {
            email: null
        };

        this.cssInputClassError = "input--error";
        this.cssHideClass = "hide";

        if (initOnCreate === true) {
            this.init();
        }
    }

    /**
     * Init del componente
     * @param {*} _settings Override dafault settings
     */


    _createClass(FormForgotPassword, [{
        key: 'init',
        value: function init() {
            var _settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.settings = $.extend(this.getDefaultSettings(), _settings);
            this.form = this.dom.find('form');
            this.recoverPasswordCta = $(this.settings.domRecoverPasswordCta);
            if (this.isFormExists()) {
                this.formObject.email = this.form.find(this.settings.domEmail);
            }

            this.addEventHandler();
            SlamJam.closeModal();
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.dom.length == 1;
        }
    }, {
        key: 'isFormExists',
        value: function isFormExists() {
            return this.form.length == 1;
        }
    }, {
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                handleLoading: 'forgot-password',
                domRecoverPasswordCta: '#RecoverPasswordCta',
                domEmail: 'input[name="email"]'
            };
        }

        /**
        * checkForm Fields before submit
        */

    }, {
        key: 'checkFormFields',
        value: function checkFormFields() {
            var checkOk = true;

            if (!this.validateEmail()) {
                checkOk = false;
            }

            return checkOk;
        }
    }, {
        key: 'validateEmail',
        value: function validateEmail() {
            var email = this.formObject.email.val();

            if (SlamJam.validateEmail(email)) {
                this.errorHide(this.formObject.email);
                return true;
            }

            this.errorShow(this.formObject.email);
            return false;
        }

        /**
         * Aggiunge la classe errore all'oggetto obj
         * @param {*} obj
         */

    }, {
        key: 'errorShow',
        value: function errorShow(obj) {
            obj.addClass(this.cssInputClassError);
            obj.next().removeClass(this.cssHideClass);
        }

        /**
         * Nasconde l'errore
         */

    }, {
        key: 'errorHide',
        value: function errorHide(obj) {
            obj.removeClass(this.cssInputClassError);
            obj.next().addClass(this.cssHideClass);
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            var self = this;
            // check if reset password form was successfully submited.
            var formState = document.querySelector('.reset-password-success');

            if (formState) {
                var resetSuccess = document.getElementById('ResetSuccess');

                resetSuccess.classList.remove('hide');
            }

            if (this.recoverPasswordCta.length == 1) {
                this.recoverPasswordCta.on('click', function (e) {
                    e.preventDefault();
                    self.dom.addClass('active');
                });
            }

            if (this.isFormExists()) {
                // Gestione submit del form
                this.form.on('submit', function () {
                    $('body').trigger('show-loading', {
                        handle: self.settings.handleLoading
                    });

                    if (self.checkFormFields()) {
                        $('body').trigger('hide-loading', {
                            handle: self.settings.handleLoading
                        });

                        return true;
                    }

                    $('body').trigger('hide-loading', {
                        handle: self.settings.handleLoading
                    });

                    return false;
                });
            }
        }
    }]);

    return FormForgotPassword;
}();

/**
 * Gestore form Reset Password
 */

var FormResetPassword = function () {

    /**
     *
     * @param {object} _dom Contenitore
     * @param {boolean} initOnCreate == True init with default settings
     */
    function FormResetPassword(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, FormResetPassword);

        this.dom = _dom;
        this.form = null;
        this.resetPasswordCta = null;

        this.formObject = {
            password: null,
            confirm_password: null
        };

        this.showPassword = $('.show-password');
        this.showPasswordConfirm = $('.show-password--confirm');

        this.cssInputClassError = 'input--error';
        this.cssHideClass = 'hide';

        if (initOnCreate == true) {
            this.init();
        }
    }

    /**
     * Init del componente
     * @param {*} _settings Override default settings
     */


    _createClass(FormResetPassword, [{
        key: 'init',
        value: function init() {
            var _settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.settings = $.extend(this.getDefaultSettings(), _settings);

            this.form = this.dom.find('form');
            this.resetPasswordCta = $(this.settings.domResetPasswordCta);

            if (this.isFormExists()) {
                this.formObject.password = this.form.find(this.settings.domPassword);
                this.formObject.password_confirmation = this.form.find(this.settings.domConfirmPassword);
            }

            this.addEventHandler();
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.dom.length == 1;
        }
    }, {
        key: 'isFormExists',
        value: function isFormExists() {
            return this.form.length == 1;
        }
    }, {
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                domPassword: 'input[name="customer[password]"]',
                domConfirmPassword: 'input[name="customer[password_confirmation]"]'
            };
        }

        /**
         * checkForm Fields before submit
         */

    }, {
        key: 'checkFormFields',
        value: function checkFormFields() {
            var checkOk = true;

            if (!this.validatePassword()) {
                checkOk = false;
            }

            if (!this.validateConfirmPassword()) {
                checkOk = false;
            }

            return checkOk;
        }
    }, {
        key: 'validateStringRequired',
        value: function validateStringRequired(objString) {
            var strMessage = objString.val();
            strMessage = strMessage.trim();

            if (strMessage !== '') {
                this.errorHide(objString);
                return true;
            }

            this.errorShow(objString);

            return false;
        }
    }, {
        key: 'validatePassword',
        value: function validatePassword() {
            var errors = false;

            var password = this.formObject.password.val();
            var password_confirmation = this.formObject.password_confirmation.val();

            // Detect password is valid
            var passwordValid = this._validatePassword(this.formObject.password, password);

            if (!passwordValid) {
                // Lascio a video gli errori del singolo campo
                errors = true;
            }
            if (password == password_confirmation) {
                // Se cambio il campo Password e sono uguali nascondo l'errore nel campo Confirm Password
                this.errorHide(this.formObject.password_confirmation);
            } else if (!password != password_confirmation) {
                // Se cambio la password in una diversa dalla Confirm mostro errore sui due campi
                this.errorShow(this.formObject.password, SlamJam.strings.customer.register.label.password_not_equals);
                this.errorShow(this.formObject.password_confirmation, SlamJam.strings.customer.register.label.password_not_equals);
            }

            return !errors;
        }
    }, {
        key: 'validateConfirmPassword',
        value: function validateConfirmPassword() {
            var errors = false;

            var password = this.formObject.password.val();
            var password_confirmation = this.formObject.password_confirmation.val();

            // Detect confirm password is valid
            var confirmPasswordValid = this._validatePassword(this.formObject.password_confirmation, password_confirmation);

            if (!confirmPasswordValid) {
                // Lascio a video gli errori del singolo campo
                errors = true;
            } else if (password && password_confirmation !== password) {
                // Se compilo prima il campo Confirm e
                // Non ci sono errori di validazione verifico se sono identiche, se non lo sono stampo a video per tutti e due i campi il mesaggio identico Password not match
                this.errorShow(this.formObject.password, SlamJam.strings.customer.register.label.password_not_equals);
                this.errorShow(this.formObject.password_confirmation, SlamJam.strings.customer.register.label.password_not_equals);
                errors = true;
            } else if (password_confirmation == password) {
                // Se sono uguali nascondo l'errore sul campo password
                this.errorHide(this.formObject.password);
            }

            return !errors;
        }
    }, {
        key: '_validatePassword',
        value: function _validatePassword(domObject, password) {
            var errors = false;

            if (password.trim() === '') {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.compile_field);
                errors = true;
            } else if (password.length < 8) {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.password_too_short.replace('{{totalchar}}', password.length));
                errors = true;
            } else if (!/^(?=.*\d)(?=.*[^a-zA-Z0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(password)) {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.password_error);
                errors = true;
            } else {
                this.errorHide(domObject);
            }

            return !errors;
        }

        /**
         * Aggiunge la classe errore all'oggetto obj
         * @param {*} obj
         */

    }, {
        key: 'errorShow',
        value: function errorShow(obj) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            obj.addClass(this.cssInputClassError);

            if (text) {
                obj.parent().find('.form-fld-error').html(text);
            }

            obj.parent().find('.form-fld-error').removeClass(this.cssHideClass);
        }

        /**
         * Nasconde l'errore
         */

    }, {
        key: 'errorHide',
        value: function errorHide(obj) {
            obj.removeClass(this.cssInputClassError);
            obj.parent().find('.form-fld-error').addClass(this.cssHideClass);
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            if (this.resetPasswordCta.length == 1) {
                var _self2 = this;
                this.resetPasswordCta.on('click', function (e) {
                    e.preventDefault();
                    _self2.dom.addClass("active");
                });
            }

            if (this.isFormExists()) {
                var _self3 = this;

                // Validate field on change value
                this.formObject.password.on('change', function () {
                    _self3.validatePassword();
                });
                this.formObject.password_confirmation.on('change', function () {
                    _self3.validateConfirmPassword();
                });

                // Gestione submit del form
                this.form.off('submit');
                this.form.on('submit', function (e) {
                    $('body').trigger('show-loading', { handle: _self3.settings.handleLoading });
                    if (_self3.checkFormFields()) {

                        $('body').trigger('hide-loading', { handle: _self3.settings.handleLoading });
                        return true;
                    }
                    $('body').trigger('hide-loading', { handle: _self3.settings.handleLoading });
                    return false;
                });
            }

            // Permette di visualizzare il contenuto del field password
            this.showPassword.on('click', function () {
                var inputPassword = $('#ResetPassword');
                var type = inputPassword.attr('type') === 'password' ? 'text' : 'password';
                inputPassword.attr('type', type);
            });

            // Permette di visualizzare il contenuto del field Confirm password
            this.showPasswordConfirm.on('click', function () {
                var inputPasswordConfirm = $('#PasswordConfirmation');
                var type = inputPasswordConfirm.attr('type') === 'password' ? 'text' : 'password';
                inputPasswordConfirm.attr('type', type);
            });
        }
    }]);

    return FormResetPassword;
}();

/**
 * Gestione form Create User
 */


var FormCreateUser = function () {

    /**
     *
     * @param {object} _dom  Contenitore
     * @param {boolean} initOnCreate == TRUE init with default settings
     */
    function FormCreateUser(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, FormCreateUser);

        this.dom = _dom;
        this.form = null;
        this.cretateAccountCta = null;

        this.formObject = {
            customer_tag: null,
            title: null,
            first_name: null,
            last_name: null,
            email: null,
            domPersonalID: null,
            confirm_email: null,
            password: null,
            confirm_password: null,
            checkPrivacy: null,
            chk_profiling: null,
            chk_antavo: null
        };

        this.showPassword = $('.show-password');
        this.showPasswordConfirm = $('.show-password--confirm');

        this.cssInputClassError = 'input--error';
        this.cssHideClass = 'hide';

        if (initOnCreate === true) {
            this.init();
        }
    }

    /**
     * Init del componente
     * @param {*} _settings Override dafault settings
     */


    _createClass(FormCreateUser, [{
        key: 'init',
        value: function init() {
            var _settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.settings = $.extend(this.getDefaultSettings(), _settings);

            this.form = this.dom.find('form');
            //  this.cretateAccountCta = $(this.settings.domCretateAccountCta);
            this.cretateAccountCta = $('#CreateAccountCta');

            if (this.isFormExists()) {
                this.formObject.customer_tag = this.form.find(this.settings.domCustomerTag);
                //this.formObject.title = this.form.find(this.settings.domTitle);
                this.formObject.first_name = this.form.find(this.settings.domFirstName);
                this.formObject.last_name = this.form.find(this.settings.domLastName);
                this.formObject.email = this.form.find(this.settings.domEmail);
                this.formObject.confirm_email = this.form.find(this.settings.domConfirmEmail);
                this.formObject.domPersonalID = this.form.find(this.settings.domPersonalID);
                this.formObject.password = this.form.find(this.settings.domPassword);
                this.formObject.confirm_password = this.form.find(this.settings.domConfirmPassword);
                this.formObject.checkPrivacy = this.form.find(this.settings.domChkPrivacy);
                this.formObject.chk_profiling = this.form.find(this.settings.domChkProfiling);
                this.formObject.chk_antavo = this.form.find(this.settings.domChkAntavo);
            }

            this.addEventHandler();
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.dom.length == 1;
        }
    }, {
        key: 'isFormExists',
        value: function isFormExists() {
            return this.form.length == 1;
        }
    }, {
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                handleLoading: 'forgot-password',
                domRecoverPasswordCta: '#CreateAccountCta',
                domCustomerTag: 'input[name="customer[tags]"]',
                domTitle: 'select[name="customer[title]"]',
                domFirstName: 'input[name="customer[first_name]"]',
                domLastName: 'input[name="customer[last_name]"]',
                domEmail: 'input[name="customer[email]"]',
                domConfirmEmail: 'input[name="customer[confirm_email]"]',
                domPassword: 'input[name="customer[password]"]',
                domConfirmPassword: 'input[name="customer[confirm_password]"]',
                domChkPrivacy: '#checkPrivacy',
                domChkProfiling: 'input[name="customer[chk_profiling]"]',
                domChkAntavo: 'input[name="customer[chk_antavo]"]',
                domPersonalID: '#personal-id'
            };
        }

        /**
        * checkForm Fields before submit
        */

    }, {
        key: 'checkFormFields',
        value: function checkFormFields() {
            var checkOk = true;

            if (!this.validateStringRequired(this.formObject.first_name)) {
                checkOk = false;
            }
            if (!this.validateStringRequired(this.formObject.last_name)) {
                checkOk = false;
            }
            if (!this.validateEmail()) {
                checkOk = false;
            }
            if (!this.validateConfirmEmail()) {
                checkOk = true;
            }

            /*
            if (SlamJam.strings.dropInstance == true) {
                if(!this.validatePersonalID(this.formObject.domPersonalID)) {
                    checkOk = false;
                }
            }
            */

            if (!this.validatePassword()) {
                checkOk = false;
            }
            if (!this.validateConfirmPassword()) {
                checkOk = false;
            }

            if (!this.validateCheckbox(this.formObject.checkPrivacy)) {
                checkOk = false;
            }

            return checkOk;
        }
    }, {
        key: 'validateStringRequired',
        value: function validateStringRequired(objString) {
            var strMessage = objString.val();
            strMessage = strMessage.trim();

            if (strMessage !== '') {
                this.errorHide(objString);
                return true;
            }

            this.errorShow(objString);

            return false;
        }

        //#region Validate Email(s)

    }, {
        key: 'validateEmail',
        value: function validateEmail() {
            var errors = false;

            var email = this.formObject.email.val();
            var confirm_email = this.formObject.confirm_email.val();

            // Detect email is valid
            var emailValid = this._validateEmail(this.formObject.email, email);

            if (!emailValid) {
                // Lascio a video gli errori del singolo campo
                errors = true;
            }

            if (email == confirm_email) {
                // Se cambio il campo Email e sono uguali nascondo l'errore nel campo Confirm Email
                this.errorHide(this.formObject.confirm_email);
            } else if (!email != confirm_email) {
                // Se cambio la mail in una diversa dalla Confirm mostro errore sui due campi
                this.errorShow(this.formObject.email, SlamJam.strings.customer.register.label.email_not_equals);
                this.errorShow(this.formObject.confirm_email, SlamJam.strings.customer.register.label.email_not_equals);
            }

            return !errors;
        }
    }, {
        key: 'validateConfirmEmail',
        value: function validateConfirmEmail() {
            var errors = false;

            var email = this.formObject.email.val();
            var confirm_email = this.formObject.confirm_email.val();

            // Detect confirm email is valid
            var confirmEmailValid = this._validateEmail(this.formObject.confirm_email, confirm_email);

            if (!confirmEmailValid) {
                // Lascio a video gli errori del singolo campo
                errors = true;
            } else if (email && confirm_email !== email) {
                // Se compilo prima il campo Confirm e
                // Non ci sono errori di validazione verifico se sono identiche, se non lo sono stampo a video per tutti e due i campi il mesaggio identico Email not match
                this.errorShow(this.formObject.email, SlamJam.strings.customer.register.label.email_not_equals);
                this.errorShow(this.formObject.confirm_email, SlamJam.strings.customer.register.label.email_not_equals);
                errors = true;
            } else if (confirm_email == email) {
                // Se sono uguali nascondo l'errore sul campo email
                this.errorHide(this.formObject.email);
            }

            return !errors;
        }

        /*
        validatePersonalID(objString) {
            let strMessage = objString.val();
            strMessage = strMessage.trim();
             if (strMessage !== '') {
                this.errorHide(objString);
                return true;
            }
             this.errorShow(objString);
             return false;
        }
        */

    }, {
        key: '_validateEmail',
        value: function _validateEmail(domObject, email) {
            var errors = false;

            if (email.trim() === '') {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.compile_field);
                errors = true;
            } else if (!SlamJam.validateEmail(email)) {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.email_error);
                errors = true;
            } else {
                this.errorHide(domObject);
            }

            return !errors;
        }

        //#endregion

        //#region Validate Password

    }, {
        key: 'validatePassword',
        value: function validatePassword() {
            var errors = false;

            var password = this.formObject.password.val();
            var confirm_password = this.formObject.confirm_password.val();

            // Detect password is valid
            var passwordValid = this._validatePassword(this.formObject.password, password);

            if (!passwordValid) {
                // Lascio a video gli errori del singolo campo
                errors = true;
            }
            if (password == confirm_password) {
                // Se cambio il campo Password e sono uguali nascondo l'errore nel campo Confirm Password
                this.errorHide(this.formObject.confirm_password);
            } else if (!password != confirm_password) {
                // Se cambio la password in una diversa dalla Confirm mostro errore sui due campi
                this.errorShow(this.formObject.password, SlamJam.strings.customer.register.label.password_not_equals);
                this.errorShow(this.formObject.confirm_password, SlamJam.strings.customer.register.label.password_not_equals);
            }

            return !errors;
        }
    }, {
        key: 'validateConfirmPassword',
        value: function validateConfirmPassword() {
            var errors = false;

            var password = this.formObject.password.val();
            var confirm_password = this.formObject.confirm_password.val();

            // Detect confirm password is valid
            var confirmPasswordValid = this._validatePassword(this.formObject.confirm_password, confirm_password);

            if (!confirmPasswordValid) {
                // Lascio a video gli errori del singolo campo
                errors = true;
            } else if (password && confirm_password !== password) {
                // Se compilo prima il campo Confirm e
                // Non ci sono errori di validazione verifico se sono identiche, se non lo sono stampo a video per tutti e due i campi il mesaggio identico Password not match
                this.errorShow(this.formObject.password, SlamJam.strings.customer.register.label.password_not_equals);
                this.errorShow(this.formObject.confirm_password, SlamJam.strings.customer.register.label.password_not_equals);
                errors = true;
            } else if (confirm_password == password) {
                // Se sono uguali nascondo l'errore sul campo password
                this.errorHide(this.formObject.password);
            }

            return !errors;
        }
    }, {
        key: '_validatePassword',
        value: function _validatePassword(domObject, password) {
            var errors = false;

            if (password.trim() === '') {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.compile_field);
                errors = true;
            } else if (password.length < 8) {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.password_too_short.replace('{{totalchar}}', password.length));
                errors = true;
            } else if (!/^(?=.*\d)(?=.*[^a-zA-Z0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(password)) {
                this.errorShow(domObject, SlamJam.strings.customer.register.label.password_error);
                errors = true;
            } else {
                this.errorHide(domObject);
            }

            return !errors;
        }
        //#endregion

    }, {
        key: 'validateCheckbox',
        value: function validateCheckbox(objCheckbox) {
            if (objCheckbox.prop('checked') === true) {
                this.errorHide(objCheckbox);
                return true;
            }

            this.errorShow(objCheckbox);
            return false;
        }

        /**
         * Aggiunge la classe errore all'oggetto obj
         * @param {*} obj
         */

    }, {
        key: 'errorShow',
        value: function errorShow(obj) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            obj.addClass(this.cssInputClassError);

            if (text) {
                obj.parent().find('.form-fld-error').html(text);
            }

            obj.parent().find('.form-fld-error').removeClass(this.cssHideClass);
        }

        /**
         * Nasconde l'errore
         */

    }, {
        key: 'errorHide',
        value: function errorHide(obj) {
            obj.removeClass(this.cssInputClassError);
            obj.parent().find('.form-fld-error').addClass(this.cssHideClass);
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            if (this.cretateAccountCta.length == 1) {
                var _self4 = this;
                this.cretateAccountCta.on('click', function (e) {
                    e.preventDefault();
                    _self4.dom.addClass("active");

                    if (_self4.checkFormFields()) {
                        $("#create_customer").submit();
                    }
                });
            }

            if (this.isFormExists()) {
                var _self5 = this;
                var shop_url = $('body').attr('data-shop-url');

                // Valdiate field on change value
                this.formObject.first_name.on('change', function () {
                    _self5.validateStringRequired($(this));
                });
                this.formObject.last_name.on('change', function () {
                    _self5.validateStringRequired($(this));
                });
                this.formObject.email.on('change', function () {
                    _self5.validateEmail();
                });
                this.formObject.confirm_email.on('change', function () {
                    _self5.validateConfirmEmail();
                });
                this.formObject.password.on('change', function () {
                    _self5.validatePassword();
                });
                this.formObject.confirm_password.on('change', function () {
                    _self5.validateConfirmPassword();
                });
                this.formObject.checkPrivacy.on('click', function (e) {
                    _self5.validateCheckbox(_self5.formObject.checkPrivacy, SlamJam.strings.customer.register.label.privacy_field);
                });

                // Gestione submit del form
                //this.form.off('submit');
                this.form.on('submit', function (e) {
                    $('body').trigger('show-loading', { handle: _self5.settings.handleLoading });
                    if (_self5.checkFormFields()) {
                        //
                        _self5.popolateTagFields();

                        $('body').trigger('hide-loading', { handle: _self5.settings.handleLoading });
                        return true;
                    }
                    $('body').trigger('hide-loading', { handle: _self5.settings.handleLoading });
                    return false;
                });
            }

            // Permette di visualizzare il contenuto del field password
            this.showPassword.on('click', function () {
                var inputPassword = $('#CreatePassword');
                var type = inputPassword.attr('type') === 'password' ? 'text' : 'password';
                inputPassword.attr('type', type);
            });

            // Permette di visualizzare il contenuto del field Confirm password
            this.showPasswordConfirm.on('click', function () {
                var inputPasswordConfirm = $('#CreateConfirmPassword');
                var type = inputPasswordConfirm.attr('type') === 'password' ? 'text' : 'password';
                inputPasswordConfirm.attr('type', type);
            });
        }

        // Populate hidden item for save extra datas

    }, {
        key: 'popolateTagFields',
        value: function popolateTagFields() {
            var tagValues = [];

            var tagval = '';
            if (this.formObject.domPersonalID.length == 1 && this.formObject.domPersonalID.val().trim() != '') {
                tagval = this.formObject.domPersonalID.val().trim();
                tagValues.push('personalID_' + tagval);
            }

            if (this.formObject.chk_profiling.prop('checked') === true) {
                tagValues.push('accept_profiling_yes');
            }

            // Tag per Antavo
            if (SlamJam.strings.dropInstance == false) {
                if (this.formObject.chk_antavo.prop('checked') === true) {
                    tagValues.push('loyalty_member');
                }
            }

            var currentDate = new Date();
            var date_created = 'created-at_' + this.getNow();

            tagValues.push(date_created);
            if ($('#ferrara-form').length) {
                tagValues.push("from-store_ferrara");
            }

            if ($('#milan-form').length) {
                tagValues.push("from-store_milano");
            }

            this.formObject.customer_tag.val(tagValues.join(','));
        }
    }, {
        key: 'getNow',
        value: function getNow() {
            var currentDate = new Date();
            var dateformatted = '';

            if (currentDate.getDate() < 10) {
                dateformatted = dateformatted + '0';
            }

            dateformatted = dateformatted + currentDate.getDate() + '/';

            if (currentDate.getMonth() < 10) {
                dateformatted = dateformatted + '0';
            }

            dateformatted = dateformatted + (currentDate.getMonth() + 1) + '/' + currentDate.getFullYear();

            return dateformatted;
        }
    }]);

    return FormCreateUser;
}();

/**
 * Gestione form Login User
 */


var FormLoginUser = function () {

    /**
     *
     * @param {object} _dom  Contenitore
     * @param {boolean} initOnCreate == TRUE init with default settings
     */
    function FormLoginUser(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, FormLoginUser);

        this.dom = _dom;
        this.form = null;
        this.cretateAccountCta = null;
        this.formObject = {
            email: null,
            password: null
        };
        this.showPassword = $('.show-password');
        this.cssInputClassError = 'input--error';
        this.cssHideClass = 'hide';

        if (initOnCreate === true) {
            this.init();
        }
    }

    /**
    * Init del componente
    * @param {*} _settings Override dafault settings
    */


    _createClass(FormLoginUser, [{
        key: 'init',
        value: function init() {
            var _settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.settings = $.extend(this.getDefaultSettings(), _settings);
            this.form = this.dom.find('form');
            this.loginCta = $(this.settings.domLoginCta);

            if (this.isFormExists()) {
                this.formObject.email = this.form.find(this.settings.domEmail);
                this.formObject.password = this.form.find(this.settings.domPassword);
            }

            this.addEventHandler();
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.dom.length == 1;
        }
    }, {
        key: 'isFormExists',
        value: function isFormExists() {
            return this.form.length == 1;
        }
    }, {
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                handleLoading: 'generic-loading',
                domLoginCta: '#LoginCta',
                domEmail: 'input[name="customer[email]"]',
                domPassword: 'input[name="customer[password]"]'
            };
        }

        /**
        * checkForm Fields before submit
        */

    }, {
        key: 'checkFormFields',
        value: function checkFormFields() {
            var checkOk = true;

            if (!this.validateEmail()) {
                checkOk = false;
            }

            if (!this.validateStringRequired(this.formObject.password)) {
                checkOk = false;
            }

            return checkOk;
        }
    }, {
        key: 'validateStringRequired',
        value: function validateStringRequired(objString) {
            var strMessage = objString.val();
            strMessage = strMessage.trim();

            if (strMessage !== "") {
                this.errorHide(objString);
                return true;
            }

            this.errorShow(objString);

            return false;
        }

        //#region Validate Email(s)

    }, {
        key: 'validateEmail',
        value: function validateEmail() {
            var errors = false;

            var email = this.formObject.email.val();

            if (email.trim() === '') {
                this.errorShow(this.formObject.email, SlamJam.strings.customer.login.label.compile_field);
                errors = true;
            } else if (!SlamJam.validateEmail(email)) {
                this.errorShow(this.formObject.email, SlamJam.strings.customer.login.label.email_error);
                errors = true;
            } else {
                this.errorHide(this.formObject.email);
            }

            return !errors;
        }

        /**
         * Aggiunge la classe errore all'oggetto obj
         * @param {*} obj
         */

    }, {
        key: 'errorShow',
        value: function errorShow(obj) {
            var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            obj.addClass(this.cssInputClassError);

            if (text) {
                obj.parent().find('.form-fld-error').html(text);
            }

            obj.parent().find('.form-fld-error').removeClass(this.cssHideClass);
        }

        /**
         * Nasconde l'errore
         */

    }, {
        key: 'errorHide',
        value: function errorHide(obj) {
            obj.removeClass(this.cssInputClassError);
            obj.parent().find('.form-fld-error').addClass(this.cssHideClass);
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            if (this.isFormExists()) {
                var _self6 = this;
                var shop_url = $('body').attr('data-shop-url');

                // Valdiate field on change value
                this.formObject.email.on('change', function () {
                    _self6.validateEmail();
                });
                this.formObject.password.on('change', function () {
                    _self6.validateStringRequired($(this));
                });

                // Gestione submit del form
                this.form.off('submit');

                this.form.on('submit', function (e) {
                    $('body').trigger('show-loading', { handle: _self6.settings.handleLoading });
                    if (_self6.checkFormFields()) {
                        $('body').trigger('hide-loading', { handle: _self6.settings.handleLoading });
                        return true;
                    }
                    $('body').trigger('hide-loading', { handle: _self6.settings.handleLoading });
                    return false;
                });

                // Permette di visualizzare il contenuto del field password
                this.showPassword.on('click', function () {
                    var inputPassword = $('#CustomerPassword');
                    var type = inputPassword.attr('type') === 'password' ? 'text' : 'password';
                    inputPassword.attr('type', type);
                });
            }
        }
    }]);

    return FormLoginUser;
}();

var Shogun = function () {
    function Shogun() {
        _classCallCheck(this, Shogun);

        this.isocodes = '.country-class__isocodes';
        this.elementsToCheck = ['.sj-fullwidth-slider', '.sj-two-column-slider, .shogun-sj-products-block, .shogun-draggable-block, .sj-three-columns, .shogun-image-container, .student-beans-container'];
        this.countrySj = Shopify.country;

        this.columnTitles = '.shogun-draggable-block__product';
        this.dots = '.shogun-draggable-block__hotspot';
        this.rightDots = '.shogun-draggable-block__right .shogun-draggable-block__hotspot';

        this.fullWidthSlider = '.sj-fullwidth-slider .shg-sld-item'; /* slide dello slider fullwidth */
        this.activeClassSlide = 'shg-sld-active'; /* classe che ha la slide quando diventa attiva */
        this.colorWhiteClass = '.slider-image--white'; /* classe custom che determina quale slide avrà le frecce bianche */
        this.sliderWrapper = '.shg-sld-content'; /* con questa classe determino lo slider corrente */
        this.currentActiveSliderWrapper = 'current-slider'; /* becco lo slider corrente ondevitare di coinvolgere altri slider con le modifiche presenti in pagina */

        this.imageTwoColumnsSlider = '.sj-two-column-slider .shogun-image-container';
        this.realSliderDimension = '.sj-two-column-slider .shg-sld-item.shg-sld-active .shogun-image.shogun-lazyloaded';
        this.twoColumnSliderArrows = '.sj-two-column-slider .shg-sld-nav-button';
        this.twoColumnsSlider = '.sj-two-column-slider .shg-sld-item.shg-sld-active .shogun-image.shogun-lazyloaded';
        this.shogunGeolocalitationBlocks(); // questa funzione va a nascondere in blocchi in base ai valori della geolocalizzazione
        this.manageSliderFullWidth();
        this.checkProducts(); // questa funzione va ad inserire i prodotti all'interno del blocco "SJ PRODUCTS BLOCK"

        if (SlamJam.strings.dropInstance == false) {
            this.antavo();
        }
        if (document.getElementById('insertTable') != null) {
            // verifico se esiste il div insertTable, altrimenti non inizializzo la funzione della pagina drop per la creazione della tabella
            this.shogunTableInput = document.querySelector('.upcoming-drops__table').textContent.split('#'); // valori che inserisce l'utente da shogun ripuliti da qualsiasi carattere html
            this.tableRows = []; //array che conterrà tutte le righe splittate con il carattere "#"
            this.upcomingDropTable(); // inserisce la tabella nella pagina upcoming prendendo in input valori da un blocco in shogun nella relativa pagina
        }

        this.shogunBlogSnippet = '.blog-shogun__template';
        //this.blogUrl                    = $(shogunBlogSnippet).data('url');
        //this.blogArticlesNumber         = $(shogunBlogSnippet).data('number-articles');

        if (template == 'index') {
            this.printArticlesInShogun();
        }

        this.arrowsInMobile();
    }

    _createClass(Shogun, [{
        key: 'arrowsInMobile',
        value: function arrowsInMobile() {
            var self = this;

            function alignArrowsSliderInCenter() {
                var checkExist = setInterval(function () {
                    /* vado ad inserire un listener che parte ogni 100 nanosecondi che va a controllare tutte le slide */
                    var height = 0;

                    $(self.realSliderDimension).each(function (index) {
                        height = $(this).height();
                        $(self.twoColumnSliderArrows).height(height);
                    });

                    $(self.imageTwoColumnsSlider).each(function (index) {
                        $(this).css("min-height", height + "px");
                    });

                    clearInterval(alignArrowsSliderInCenter); //finito tutto esco dal listener per non appesantire la pagina!
                }, 100);
            }

            alignArrowsSliderInCenter();
        }
    }, {
        key: 'printArticlesInShogun',
        value: function printArticlesInShogun() {
            var self = this;
            var completeAjaxUrlToCall = "";
            var allArticles = [];
            var articlesToPrint = '';

            function getTheArticlesCall(parent) {
                completeAjaxUrlToCall = parent.querySelector(self.shogunBlogSnippet).dataset.url;

                return new Promise(function (resolve, reject) {
                    $.ajax({
                        url: completeAjaxUrlToCall,
                        type: 'GET',
                        success: function success(data) {
                            resolve(data);
                            allArticles = [];
                            allArticles.push($(data).find('.blog__container .blog__image-container'));
                        },
                        error: function error(_error) {
                            reject(_error);
                        }
                    });
                });
            }

            var _loop = function _loop(i) {

                getTheArticlesCall(document.querySelectorAll('.blog-shogun')[i]).then(function (data) {
                    appendArticlesToShogunBlock(data, document.querySelectorAll('.blog-shogun')[i]);
                }).catch(function (error) {
                    console.log(error);
                });
            };

            for (var i = 0; i < document.querySelectorAll('.blog-shogun').length; i++) {
                _loop(i);
            }

            function appendArticlesToShogunBlock(article, parent) {

                for (var i = 0; i < allArticles[0].length; i++) {
                    if (i <= parseInt(parent.querySelector(self.shogunBlogSnippet).dataset.numberarticles - 1)) {
                        articlesToPrint += '<div class="blog__image-container">' + allArticles[0][i].innerHTML + '</div>';
                    }
                }

                parent.querySelector('.blog__container').innerHTML = articlesToPrint;
                articlesToPrint = '';
            }
        }
    }, {
        key: 'shogunGeolocalitationBlocks',
        value: function shogunGeolocalitationBlocks() {
            var self = this;

            self.elementsToCheck.filter(checkElements);

            function checkElements(classElement) {
                var currentBLock = classElement;

                $(currentBLock).each(function () {
                    /*
                    if($("div[class*='excluded_']").length) {
                        if($(this).find("div[class*='excluded_']")) {
                            let excludedCountry = $(this).find("div[class*='excluded_']").attr('class');
                             let slideIndex = $(this).index();
                             if(excludedCountry != undefined) {
                                let clearStringClass = excludedCountry.split('excluded_').pop();
                                 clearStringClass.split(',').map((isocode, index) => {
                                    if(isocode.replace(/\s/g, '').toUpperCase() == self.countrySj) {
                                        $(this).find("div[class*='excluded_']").closest('.shg-sld-item').remove();
                                        $(this).find('.shg-sld-dots').first().find('.shg-sld-dot').eq(slideIndex).remove();
                                    }
                                });
                            }
                        }
                    }
                    */

                    if (!$('body').hasClass('customer-logged-in')) {
                        $('.only-customer-log').each(function () {
                            $(this).closest('.shg-box-content').hide();
                            $(this).closest('.shg-box').hide();

                            if ($('.enrol-click').length) {
                                $('.enrol-click').each(function () {
                                    $(this).hide();
                                });
                            }
                        });
                    }
                });

                $(self.isocodes).each(function () {
                    var _this3 = this;

                    var currentBlockIsoCode = $(this).data('isocodes'); //testo dentro country excluded block

                    if (currentBlockIsoCode) {
                        currentBlockIsoCode.split(',').map(function (isocode, index) {
                            if (isocode.toUpperCase() == self.countrySj.toUpperCase()) {
                                $(_this3).closest(currentBLock).hide();
                            }
                        });
                    }
                });
            }

            $('.shogun-page, .shogun-root').addClass('visible');
        }
    }, {
        key: 'manageSliderFullWidth',
        value: function manageSliderFullWidth() {
            var self = this;

            function manageSlider() {
                var checkExist = setInterval(function () {
                    /* vado ad inserire un listener che parte ogni 100 nanosecondi che va a controllare tutte le slide */

                    $(self.fullWidthSlider).each(function (index) {
                        if ($(this).hasClass(self.activeClassSlide)) {
                            // vedo se la slide contiene la classe attiva
                            if ($(this).find(self.colorWhiteClass).length !== 0) {
                                // e se background image ha la classe delle frecce bianche
                                $(this).closest(self.sliderWrapper).addClass(self.currentActiveSliderWrapper); // se si vado ad inserire al wrapper la classe che determina lo slider corrente
                            } else {
                                $(this).closest(self.sliderWrapper).removeClass(self.currentActiveSliderWrapper);
                            }
                        }
                    });
                }, 100);

                clearInterval(manageSlider); //finito tutto esco dal listener per non appesantire la pagina!
            }

            manageSlider();
        }
    }, {
        key: 'checkProducts',
        value: function checkProducts() {
            var self = this; // target selector
            var selector = '.shogun-root'; // max time to wait (in seconds)
            var maxSeconds = 10; // time spend (in seconds)
            var timer = 1; // refresh every second

            var refreshId = setInterval(function () {
                // check if dom exists
                if (document.querySelector(selector)) {
                    // call observer
                    observer();

                    // clear interval
                    clearInterval(refreshId);
                }
                // check if timeout
                if (timer++ >= maxSeconds) {
                    clearInterval(refreshId);
                }
            }, 500);

            function observer() {
                /* observer app shogun aspettando che renderizza i vari componenti */
                /* questa funzione si occupa di gestire l'over sopra il titolo del prodotto ed evidenziare il corrispondente dot */
                var hotspotBlock = function hotspotBlock() {
                    $(self.columnTitles).hover(function () {
                        // faccio over sopra i titoli delle colonne a sx
                        var current_index = $(this).attr("data-index"); //catturo l'attuale index

                        $('.shogun-draggable-block__product p').removeClass('active--dot'); // rimuovo tutti i dot con classe attiva
                        $(this).find('p').addClass('active--dot'); //aggiungo classe attiva al dot attuale

                        $(self.rightDots).each(function () {
                            // cerco tutti i dots a dx

                            if (current_index === $(this).attr('data-index')) {
                                // controllo se quello attuale è uguale a quello con cui ho fatto over nella colonna di SX.
                                $(self.rightDots).removeClass('active--dot'); //rimuovo classe attiva a tutti i dots
                                $(this).addClass('active--dot'); // metto classe a quello attuale.
                            }
                        });
                    });

                    /* questa funzione va a togliere la classe attiva a tutti gli elementi in quanto se non sono più posizionato devo resettare tutto */
                    $(self.columnTitles).mouseleave(function () {
                        $(self.columnTitles).find('p').removeClass('active--dot');
                        $(self.rightDots).removeClass('active--dot');
                    });

                    //vado a fare hover sopra DOT colonna DX ed è la logica è la stessa dell'over sopra.
                    $(self.dots).hover(function () {
                        var current_index = $(this).attr("data-index");
                        $(self.columnTitles).removeClass("active--dot");
                        $(this).addClass("active--dot");

                        $('.shogun-draggable-block__product').each(function () {
                            if (current_index === $(this).attr("data-index")) {
                                $('.shogun-draggable-block__product p').removeClass("active--dot");
                                $(this).find('p').addClass("active--dot");
                            }
                        });
                    }, function () {
                        $('.shogun-draggable-block__product p').removeClass("active--dot");
                        $(self.rightDots).removeClass("active--dot");
                    });
                };

                var sjBlockProducts = function sjBlockProducts() {
                    $('.shogun-sj-products-block').each(function (_index) {
                        var $currentProductBlock = $(this).find('.shogun-sj-products').length; // identifico blocco attuale
                        var currentDiv = $(this);
                        if ($currentProductBlock) {
                            var productHandles = [$(this).find('[data-product-1]').attr('data-product-1') ? $(this).find('[data-product-1]').attr('data-product-1') : null, $(this).find('[data-product-2]').attr('data-product-2') ? $(this).find('[data-product-2]').attr('data-product-2') : null, $(this).find('[data-product-3]').attr('data-product-3') ? $(this).find('[data-product-3]').attr('data-product-3') : null, $(this).find('[data-product-4]').attr('data-product-4') ? $(this).find('[data-product-4]').attr('data-product-4') : null].filter(function (productHandle) {
                                return productHandle;
                            });
                            var promises = [];

                            var ajaxCall = function ajaxCall(url, index, currentDiv) {
                                return new Promise(function (resolve) {
                                    $.get(url).done(function (data) {
                                        //verifico se il prodotto sia active su shopify oppure no
                                        if (!data.includes('doctype')) {
                                            currentDiv.find('[data-product-' + index + '-placeholder]').replaceWith(data);
                                            resolve(data);
                                        }
                                    }).fail(function (data) {
                                        resolve(data);
                                    });
                                });
                            };

                            for (var i = 0; i < productHandles.length; i++) {
                                var url = '/products/' + productHandles[i] + '?view=ajax-shogun';
                                promises.push(ajaxCall(url, i + 1, currentDiv));
                            };
                        } else {
                            var _$currentProductBlock = $(this).find('.shogun-sj-product-collections');
                            var collectionHandle = _$currentProductBlock.attr('data-collection-handle');
                            var limiter = parseInt(_$currentProductBlock.attr('data-limiter'));

                            /* vado a fare una chiamata usando l'url della collection con l'eventuale handle */
                            $.ajax({
                                url: '/collections/' + collectionHandle + '?view=ajax-template' + '&lim=' + limiter,
                                success: function success(result) {
                                    _$currentProductBlock.html(result); // copio il contenuto all'interno del div
                                }
                            });
                        }
                    });
                };

                hotspotBlock();
                sjBlockProducts();
            }
        }
    }, {
        key: 'antavo',
        value: function antavo() {
            if (!$('body').hasClass('customer-logged-in')) {
                $('.login-register-block').show();
                $('.enrol-click').hide();
            } else {
                $('.login-register-block').hide();
                $('.enrol-click').show();
            }
        }
    }, {
        key: 'upcomingDropTable',
        value: function upcomingDropTable() {
            var self = this;

            for (var i = 0; i < self.shogunTableInput.length; i++) {
                //inserisco valori splittati in un array
                self.tableRows.push(self.shogunTableInput[i]);
            }

            var count = 0,
                table = document.createElement("table"),
                row = table.insertRow();

            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = self.tableRows[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var singleRow = _step2.value;
                    // mi scorro tutte le righe all'interno dell'array
                    var cells = singleRow.split(","); // splitto tutte le celle all'interno delle rows

                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = cells[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var singleCell = _step3.value;
                            // per ogni cella nelle celle vado a creare l'html
                            var cell = row.insertCell();

                            cell.innerHTML = singleCell;
                            count++;

                            if (count % cells.length == 0) {
                                //quando sono arrivato al numero di celle per riga spezzo tutto in una nuova riga
                                row = table.insertRow();
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            document.getElementById("insertTable").appendChild(table);
        }
    }]);

    return Shogun;
}();

var JsSelect = function () {

    /**
     *
     * @param {jqeryObj} _dom  Inviare l'oggetto jequery dell'elemento univico
     * @param {*} initOnCreate
     */
    function JsSelect(_dom) {
        var initOnCreate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        _classCallCheck(this, JsSelect);

        this.dom = _dom;
        this.uniqueID = SlamJam.generateString();

        if (this.dom.length !== 1) {
            console.warn('JsSelect object error, support only one object, passed ' + this.dom.length + ' ojejct(s)', this.dom);
            return false;
        }

        if (initOnCreate === true) {
            this.init();
        }
    }

    _createClass(JsSelect, [{
        key: 'getDefaultSettings',
        value: function getDefaultSettings() {
            return {
                dropdownTitle: '.drop-down_title',
                dropDownContent: '.drop-down_content',
                backInStock: null,
                onlyItemsNoTitle: false // Title not visible, visible only items value opened
            };
        }

        /**
         * Init del componente
         * @param {*} _settings Override dafault settings
         */

    }, {
        key: 'init',
        value: function init() {
            var _settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.settings = $.extend(this.getDefaultSettings(), _settings);

            // Create HTML Content, and hide original select
            var html = this.getHtml();
            $(html).insertAfter(this.dom);

            this.moveOriginalSelect();

            // Set DOM Objects
            this.$dropDownContainer = $('.dropdown-selector', '#' + this.uniqueID);
            this.$dropdownTitle = this.$dropDownContainer.find(this.settings.dropdownTitle);
            this.$dropDownItemOpenClose_title = this.$dropdownTitle.find('span');

            this.$dropDownContent = this.$dropDownContainer.find(this.settings.dropDownContent);;
            this.$dropDownItems = this.$dropDownContent.find('.dropdownselectvalue');

            this.heightDropdownContainer = this.$dropDownContainer.height();

            //Elemento corrente selezionato nella dropDown
            this.currentDropdownItemSelected = null;

            this.placeholder = this.$dropDownItemOpenClose_title.html();

            // Pannello Select aperto
            this.isOpened = false;

            this.addEventHandler();

            if (this.$dropDownContent.find('.dropdownselectvalue.active').length == 1) {
                this.$dropDownContent.find('.dropdownselectvalue.active').click();
            } else {
                $(this.$dropDownItems[0]).click();
            }
        }
    }, {
        key: 'moveOriginalSelect',
        value: function moveOriginalSelect() {
            this.dom.css('position', 'absolute');
            this.dom.css('left', '-2000px');
        }
    }, {
        key: 'addEventHandler',
        value: function addEventHandler() {
            this.addEventHandlerTitleClick();
            this.addEventHandlerItemClick();
        }

        // Click on title selct

    }, {
        key: 'addEventHandlerTitleClick',
        value: function addEventHandlerTitleClick() {
            var self = this;
            this.$dropdownTitle.on('click', function (evt) {
                if (self.isOpened) {
                    if (self.currentDropdownItemSelected.length > 0) {
                        self.currentDropdownItemSelected.click();
                    } else {
                        self.closedropDown();
                    }
                } else {
                    self.openDropdown(self.isMobile);
                }
            });
        }

        // Click on dropdown option(s)

    }, {
        key: 'addEventHandlerItemClick',
        value: function addEventHandlerItemClick() {

            var self = this;
            this.$dropDownItems.on('click', function () {
                // Set current value clicked
                self.currentDropdownItemSelected = $(this);

                // Manage Class fort all option(s)
                $(this).siblings().removeClass('active');
                $(this).addClass('active');

                // Set default object value
                self.dom.val($(this).data('value'));

                // Set text into title of select
                self.$dropDownItemOpenClose_title.html($(this).html());
                self.$dropDownItemOpenClose_title.addClass('selectedValue');

                //
                self.closedropDown();
            });
        }

        // Open DropDown

    }, {
        key: 'openDropdown',
        value: function openDropdown() {
            if (!this.isOpened) {
                //
                $(this).trigger("select-openDropdown-before", [this]);

                //Change Text to placeholder and change class
                this.$dropDownItemOpenClose_title.html(this.placeholder);
                this.$dropDownItemOpenClose_title.removeClass('selectedValue');

                //
                this.isOpened = true;

                this.$dropdownTitle.addClass('opened');
                this.$dropDownContent.removeClass('hide');
            }
        }
    }, {
        key: 'closedropDown',
        value: function closedropDown() {
            if (this.isOpened) {
                this.isOpened = false;
                this.$dropdownTitle.removeClass('opened');
                this.$dropDownContent.addClass('hide');
            }
        }
    }, {
        key: 'getHtml',


        // Get html for personalized select
        value: function getHtml() {
            //var html ='<div class="js-select-wrapper" id="' + this.uniqueID + '"><input type="hidden" name="' + this.dom.attr('name') + '" value="">';
            var html = '<div class="js-select-wrapper" id="' + this.uniqueID + '">';
            html = html + '<div class="dropdown-selector" data-select-value-label="' + this.dom.data("default-text") + '">';
            html = html + '<div class="drop-down_title">';
            html = html + '<button type="button" class="text">';
            html = html + '<span class="flex-grow-1" data-variant-id="" data-text-open="Select size" data-text-close="' + this.dom.data("default-text") + '">' + this.dom.data("default-text") + '</span>';
            html = html + '<div class="icon"></div>';
            html = html + '</button>';
            html = html + '</div>';
            html = html + '<div class="drop-down_content wrapper-flex hide">';
            html = html + '<ul class="no-bullets">';
            this.dom.find('option').each(function (index, element) {
                if ($(this).attr("selected") == "selected") {
                    html = html + '<li class="dropdownselectvalue active" data-value="' + this.value + '">' + this.text + '</li>';
                } else {
                    html = html + '<li class="dropdownselectvalue" data-value="' + this.value + '">' + this.text + '</li>';
                }
            });
            html = html + '</ul>';
            html = html + '</div>';
            html = html + '</div>';
            html = html + '</div>';
            return html;
        }
    }, {
        key: 'isExists',
        value: function isExists() {
            return this.dom.length == 1;
        }
    }]);

    return JsSelect;
}();

var Blog = function () {
    function Blog() {
        _classCallCheck(this, Blog);

        this.allBlogs = '.blog-pagination .blog__image-container';
        this.showMore = '.btn.js-show-more';
        this.fakePagination();
    }

    _createClass(Blog, [{
        key: 'fakePagination',
        value: function fakePagination() {
            var numberOfElementsPagination = parseInt($('.blog-pagination .blog__container').attr('data-limiter'));

            $(this.allBlogs).each(function (i) {
                if ($(this).closest('.blog__container').children().length > 0) {
                    if ($('.blog-pagination .blog__image-container').children().length > 4) {
                        if (i + 1 <= numberOfElementsPagination) {
                            $('.btn.js-show-more').show();
                            $(this).addClass('visible');
                        }
                    } else {
                        $(this).addClass('visible');
                        $('.btn.js-show-more').hide();
                    }
                }
            });

            $(this.showMore).click(function () {
                $('.blog-pagination .blog__image-container').not('.visible').each(function (i) {
                    if ($('.blog-pagination .blog__image-container').not('.visible').length < 2) {
                        $('.btn.js-show-more').hide();
                        if ($('#next-blog-page').attr("data-url") != 'undefined') {
                            $('#next-blog-page').show();
                        }
                    }

                    if (i + 1 <= numberOfElementsPagination) {
                        $(this).addClass('visible');
                    }
                });
            });

            $('#next-blog-page').click(function () {
                window.location.replace($(this).attr("data-url"));
            });
        }
    }]);

    return Blog;
}();

var Collection = function () {
    function Collection() {
        _classCallCheck(this, Collection);

        this.viewLayoutCollection = localStorage.getItem('one-column');
        this.changeLayoutGridCollection = $('.layout__toggle');
        this.productGrid = $('#shop-products');
        /**
         * Sort selectors
         */
        this.openSortDesktopSelector = '.sorting--desktop .sorting__title'; // va ad aprire le voci sort by nel desktop
        this.openSortMobileSelector = '.sorting--mobile .sorting__title'; // voce che va ad aprire i valori sorting da mobile
        this.sortOptionListSelector = '.sorting--desktop .sorting__container .sorting__list';
        this.sortOptionListSelectorMobile = '.sorting--mobile .sorting__container .sorting__list';
        this.sortOptionSelector = '.sorting__list li a';
        this.sortBySelect = '.sort-by';
        /**
         * Filter selectors
         */
        this.filterSearch = '.filter-search'; // search nel contenitore dei filtri
        this.filterTypeSelector = '.filter-type';
        this.filterTypeContainerSelector = '.filter-type__container';
        this.filterOption = '.filter-type__list li'; // voce dei filtri all'interno del contenitore
        this.mobileFilter = '.filter-mobile__title'; //titolo "filtri" mobile
        this.mobileCloseFilter = '.close-filters'; //titolo "filtri" mobile
        this.viewColumnToggle = '.sorting--mobile .layout__toggle'; // tasto per cambiare visualizzazione griglia
        this.filterHierarchical = '.filter-type__list.hierarchical li';
        this.filterHierarchicalCategory = '.filter-type__list.hierarchical .category';
        this.init();
    }

    _createClass(Collection, [{
        key: 'init',
        value: function init() {
            this.checkLayoutColumn(); // al document ready controlla se lasciare layout a due colonne invece che 1 nella collection
            this.setCurrentSorting();
            this.filterManagement();
        }

        /* qui quando carico la pagina vado a controllare se sia presente il local item relativo al layout della griglia nella collection */

    }, {
        key: 'checkLayoutColumn',
        value: function checkLayoutColumn() {
            if (this.viewLayoutCollection) {
                // se è presente setto una classe alla griglia e quindi diventa 1 prodotto per riga
                this.changeLayoutGridCollection.addClass('one-column');
                this.changeLayoutGridCollection.removeClass('two-columns');
                this.productGrid.removeClass('two-columns');
            } else {
                // altrimenti torno alla visualizzazione normale a due prodotti per riga
                this.changeLayoutGridCollection.addClass('two-columns');
                this.changeLayoutGridCollection.removeClass('one-column');
                this.productGrid.removeClass('one-column');
            }

            $('body').on('click', this.viewColumnToggle, function () {
                // al click controllo se esiste il localitem che controlla il layotu della classe della griglia prodotti
                if ($(this).hasClass('two-columns')) {
                    $(this).removeClass('two-columns');
                    $(this).addClass('one-column');
                    $('#shop-products').removeClass('two-columns');
                    localStorage.setItem('one-column', true);
                } else {
                    $(this).addClass('two-columns');
                    $(this).removeClass('one-column');
                    $('#shop-products').addClass('two-columns');
                    localStorage.removeItem('one-column');
                }
            });
        }
    }, {
        key: 'setCurrentSorting',
        value: function setCurrentSorting() {
            var self = this;

            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);

            if (window.location.pathname == '/collections/all') {
                if (!urlParams.get('custom-sort-by')) {
                    // $(this.openSortDesktopSelector).addClass('active').text('Date: New to Old');
                    $(this.sortOptionListSelector).find('li a[data-value=' + 'created-descending' + ']').addClass('active');
                    // window.history.replaceState(null, null, "?custom-sort-by=created-descending");
                    var url = new URL(window.location.href);
                    url.searchParams.set('custom-sort-by', 'created-descending');
                    window.history.replaceState(null, null, url); // or pushState
                }
            }

            if (urlParams.get('custom-sort-by') && urlParams.get('custom-sort-by') != 'trending') {
                var value = urlParams.get('custom-sort-by');
                var label = $(this.sortOptionListSelector).find('li a[data-value=' + value + ']').first().text();

                $(this.sortOptionListSelector).find('li a[data-value=trending]').removeClass('active');

                $(this.openSortDesktopSelector).addClass('active').text(label);
                $(this.sortOptionListSelector).find('li a[data-value=' + value + ']').addClass('active');
                $(this.sortBySelect).val(value).change();

                $($(self.sortOptionSelector)).each(function (index) {
                    // vado a mettere classe attiva al sort in mobile
                    var currentSortTitle = $(this).attr('data-value');

                    if (currentSortTitle === value) {
                        $(this).addClass('active');
                    }
                });
            }

            $(this.openSortDesktopSelector).addClass('checked');
        }
    }, {
        key: 'filterManagement',
        value: function filterManagement() {
            var self = this;

            /* una volta cliccata la voce sort-by da desktop faccio partire l'animazione */
            $('body').on('click', this.openSortDesktopSelector, function () {
                $(this).hide();
                $(this).siblings(self.sortOptionListSelector).first().addClass('visible');
            });

            $('body').on('click', this.sortOptionSelector, function () {
                var value = $(this).data('value');
                $(self.sortOptionSelector).removeClass('active');

                $(this).addClass('active');
                $(self.sortBySelect).val(value).change();

                var evt = document.createEvent('Events');
                evt.initEvent('change', true, false);
                $(self.sortBySelect)[0].dispatchEvent(evt);

                $(this).closest('.sort__container').find('.sort__list ul').addClass('visible');

                // da mobile chiudo il div
                if (SlamJam.isMobile(SlamJam.costants.grid_medium, false)) {
                    $(self.sortOptionListSelectorMobile).toggle();
                }
            });

            /* faccio il toggle da mobile quando clicco sulla voce sort */
            $('body').on('click', this.openSortMobileSelector, function () {
                $(self.sortOptionListSelectorMobile).toggle();
            });

            /* vado a gestire l'apertura a togglestile quando clicco sul titolo filtri da mobile */
            $('body').on('click', this.mobileFilter, function () {
                $(this).closest('.sorting--mobile').find('.filter-mobile__container').toggle();

                if ($(this).hasClass('active')) {
                    $('.filter-mobile__title--button span').text("filter");
                    $(this).removeClass('active');
                    scrollLock.enablePageScroll(document.querySelector('.filter-mobile__container'));
                } else {
                    $(this).addClass('active');
                    scrollLock.disablePageScroll(document.querySelector('.filter-mobile__container'));
                }
            });

            $('body').on('click', this.mobileCloseFilter, function () {
                $(self.mobileFilter).removeClass('active');
                $(self.mobileFilter).closest('.sorting--mobile').find('.filter-mobile__container').toggle();
                scrollLock.enablePageScroll(document.querySelector('.filter-mobile__container'));
                $('.filter-mobile__title--button span').text("filter");
            });

            $('body').on('click', this.filterHierarchical, function () {
                var currentHierarchical = $(this).find('.category');
                var currentHierarchicalFilterVoice = $(this).find('.category').find('span').attr('data-type');

                if (currentHierarchical.hasClass('active')) {
                    $(self.filterHierarchicalCategory).removeClass('active');
                    currentHierarchical.removeClass('active');
                    localStorage.setItem('filterFirstCategory', currentHierarchicalFilterVoice);
                } else {
                    localStorage.setItem('filterFirstCategory', currentHierarchicalFilterVoice);
                    $(self.filterHierarchicalCategory).removeClass('active');
                    currentHierarchical.addClass('active');
                }
            });
        }
    }]);

    return Collection;
}();

var StoreFrontApi = function () {
    /* in questa classe si andrà a gestire in futuro tutte le chiamate
    che si faranno con graphQL*/
    function StoreFrontApi() {
        _classCallCheck(this, StoreFrontApi);

        this.storefrontAccessToken = SlamJam.strings.token_GRAPHQL;
        this.graphQlUrl = window.origin + '/api/2022-01/graphql.json';
        this.productId = $('#currentProductId').attr('data-current-id');
        this.productVariants = $('#currentProductId').attr('number-variants');
        this.shopifyVariants = "";
        /* in base a quale view sono seleziono varianti
        perchè se sono in desk il selettore è diverso e viceversa */
        if ($(window).width() < SlamJam.costants.grid_large) {
            this.shopifyVariants = document.querySelectorAll(".sticky .product-select-variant__content li");
        } else {
            this.shopifyVariants = document.querySelectorAll(".product-select-variant__content li");
        }

        this.allProductVariants = "";
        this.allRequestVariantsPrice = [];
        this.init();
    }

    _createClass(StoreFrontApi, [{
        key: 'init',
        value: function init() {
            var self = this;

            var getProductVariantInformations = function getProductVariantInformations() {
                $('.loading-wrapper').css("display", "flex");

                var productQuery = function productQuery() {
                    return '\n                query {\n                    product(id: "gid://shopify/Product/' + self.productId + '") {\n                        variants(first: ' + self.productVariants + ') {\n                          edges {\n                                node {\n                                    price\n                                }\n                            }\n                        }\n                    }\n                }\n            ';
                };

                var GRAPHQL_BODY = function GRAPHQL_BODY() {
                    return {
                        'async': true,
                        'crossDomain': true,
                        'method': 'POST',
                        'headers': {
                            'X-Shopify-Storefront-Access-Token': self.storefrontAccessToken,
                            'Content-Type': 'application/graphql'
                        },
                        'body': productQuery()
                    };
                };

                fetch(self.graphQlUrl, GRAPHQL_BODY()).then(function (res) {
                    return res.json();
                }).then(function (product) {

                    $('.loading-wrapper').css("display", "none");
                    self.allProductVariants = product.data.product.variants.edges;
                    //  console.log(self.allProductVariants);

                    for (var i = 0; i < self.allProductVariants.length; i++) {
                        self.allRequestVariantsPrice.push(self.allProductVariants[i].node.price);
                    }

                    for (var _i = 0; _i < self.shopifyVariants.length; _i++) {
                        var arrayWithOriginalVariantsPrice = self.allRequestVariantsPrice[_i].split('.');
                        var div = document.createElement('div');
                        div.innerHTML = "€" + arrayWithOriginalVariantsPrice[0] + " EUR";
                        div.className = 'store-price';
                        self.shopifyVariants[_i].appendChild(div);
                    }
                });
            };

            /* controllo se prodotto è giftcard specifica come richiesto da Giacomo
            se cosi controllo anche currency perchè se sono in EUR non ho problemi */

            if ($('#currentProductId').length) {
                if ($('body').attr("currency") != 'EUR') {
                    getProductVariantInformations();
                }
            }
        }
    }]);

    return StoreFrontApi;
}();

var Newsletter = function () {
    function Newsletter() {
        _classCallCheck(this, Newsletter);

        this.newsletterFormSelector = '.newsletter #contact_form';
        this.newsletterEmailSelector = '.newsletter #contact_form #newsletterEmail';
        this.newsletterPrivacySelector = '.newsletter #contact_form #checkNewsletterPrivacy';

        this.init();
    }

    _createClass(Newsletter, [{
        key: 'init',
        value: function init() {
            this.newsletterForm();
        }
    }, {
        key: 'newsletterForm',
        value: function newsletterForm() {
            var self = this;

            $(this.newsletterFormSelector).on('submit', function () {
                $(self.newsletterFormSelector).find('.form-fld-error').addClass('hide');

                if (!$(self.newsletterPrivacySelector).is(':checked') || !SlamJam.validateEmail($(self.newsletterEmailSelector).val())) {
                    if (!$(self.newsletterPrivacySelector).is(':checked')) {
                        $(self.newsletterFormSelector).find('.form-row.checkbox-privacy .form-fld-error').removeClass('hide');
                    }

                    if (!SlamJam.validateEmail($(self.newsletterEmailSelector).val())) {
                        $(self.newsletterFormSelector).find('.form-row.email .form-fld-error').removeClass('hide');
                    }

                    return false;
                }

                return true;
            });
        }
    }]);

    return Newsletter;
}();

var ReturnPageManagement = function () {
    function ReturnPageManagement() {
        _classCallCheck(this, ReturnPageManagement);

        this.returnPage = '/apps/return-and-exchanges';
        this.init();
    }

    _createClass(ReturnPageManagement, [{
        key: 'init',
        value: function init() {
            var self = this;

            if (window.location.href.indexOf(self.returnPage) != -1) {
                //  console.log("contains");
                this.returnPageManagement();
            }
        }
    }, {
        key: 'returnPageManagement',
        value: function returnPageManagement() {
            var self = this;

            function waitForAddedNode(params) {
                new MutationObserver(function (mutations) {
                    var el = document.getElementById(params.id);
                    if (el) {
                        document.querySelector('.no-returns').style.display = "none";
                        this.disconnect();
                        params.done(el);
                    }
                }).observe(params.parent || document, {
                    subtree: !!params.recursive || !params.parent,
                    childList: true
                });
            }

            waitForAddedNode({
                id: 'return-history',
                parent: document.querySelector('#return-history'),
                recursive: false,
                done: function done(el) {
                    console.log(el);
                }
            });
        }
    }]);

    return ReturnPageManagement;
}();

var Antavo = function () {
    function Antavo() {
        _classCallCheck(this, Antavo);

        this.checkCustomerLog = 'customer-logged-in';
        this.antavoBtnLogin = '.antavo-btn-login';
        this.antavoBtnRegister = '.antavo-btn-register';
        this.antavoBtnEnrol = '.enrol-click a';
        this.antavoDivEnrol = '.enrol-click';
        this.checkAntavoCustomer = '#customer-of-antavo';
        this.enrolModal = '#antavo-enrol';
        this.goToRewardProgram = '.antavo-reward-program';
        this.loginFormInSpecialRedirectFunction = '#customer_login, #create_customer';
        this.init();
    }

    _createClass(Antavo, [{
        key: 'init',
        value: function init() {
            var _this4 = this;

            this.renderAntavoComponents();

            if (localStorage.getItem("reward") != null) {
                if (window.location.href.indexOf("?submitted=true") > -1) {
                    window.location.href = "/pages/how-it-works";
                    localStorage.removeItem('reward');
                }
            }
            window.addEventListener('load', function (event) {
                if (window.location.href.indexOf("?return_to=/pages/how-it-works") > -1) {
                    _this4.specialRedirectInRewardPage();
                }
            });

            if (window.location.href.indexOf("account?view=antavo") > -1) {
                this.detectLoadingIframeMicrosite();
            }
        }
    }, {
        key: 'specialRedirectInRewardPage',
        value: function specialRedirectInRewardPage() {
            var self = this;
            $(self.loginFormInSpecialRedirectFunction).submit(function (e) {
                var data;
                $.ajax({
                    url: '/account/login',
                    data: data,
                    processData: false,
                    type: 'POST',
                    success: function success(data) {
                        localStorage.setItem('reward', 'true');
                    }
                });
            });
        }
    }, {
        key: 'detectLoadingIframeMicrosite',
        value: function detectLoadingIframeMicrosite() {

            $('.loading-wrapper').css("display", "flex");
            document.getElementById('loyalty-center-frame').onload = function () {
                $('.loading-wrapper').css("display", "none");
            };
        }
    }, {
        key: 'renderAntavoComponents',
        value: function renderAntavoComponents() {
            var self = this;

            if ($('body').hasClass(self.checkCustomerLog)) {

                $(self.antavoBtnLogin).each(function (index) {
                    $(this).hide();
                });

                $(self.antavoBtnRegister).each(function (index) {
                    $(this).hide();
                });

                $(self.antavoDivEnrol).each(function (index) {
                    $(this).show();
                });

                //  $(self.antavoBtnLogin).hide();
                //  $(self.antavoBtnRegister).hide();
                //  $(self.antavoDivEnrol).show();
            } else {
                //  $(self.antavoDivEnrol).remove();
                $(self.antavoDivEnrol).each(function (index) {
                    $(this).remove();
                });
            }

            if ($(self.checkAntavoCustomer).length > 0) {

                $(self.antavoDivEnrol).each(function (index) {
                    $(this).hide();
                });

                $(self.goToRewardProgram).each(function (index) {
                    $(this).show();
                });

                //  $(self.antavoDivEnrol).hide();
                //  $(self.goToRewardProgram).show();
            } else {

                $(self.antavoDivEnrol).each(function (index) {
                    $(this).show();
                });

                $(self.goToRewardProgram).each(function (index) {
                    $(this).hide();
                });

                // $(self.antavoDivEnrol).show();
                // $(self.goToRewardProgram).hide();
            }
        }
    }]);

    return Antavo;
}();

/*
questa classe serve per iniettare una pagina custom a quella di shopify per l'optin
una volta che l'utente submitta form di newsletter
*/


var customOptinNewsletterPage = function () {
    function customOptinNewsletterPage() {
        _classCallCheck(this, customOptinNewsletterPage);

        this.optinMainDivPage = '.shopify-email-marketing-confirmation__container';
        this.landingPageNW = SlamJam.settings.shop_url + '/pages/landing-page-newsletter';
        this.parentPageSelector = '#PageContainer .main-content';
        this.init();
    }

    _createClass(customOptinNewsletterPage, [{
        key: 'init',
        value: function init() {
            var self = this;
            if ($(self.optinMainDivPage).length) {
                this.injectNewsletterPage();
            }
        }
    }, {
        key: 'injectNewsletterPage',
        value: function injectNewsletterPage() {
            var self = this;
            $.ajax({
                'url': self.landingPageNW,
                'method': 'GET',
                'success': function success(response) {
                    $(self.parentPageSelector).append($(response).html());
                },
                'error': function error() {
                    alert("an error occured, please reload page!");
                }
            });
        }
    }]);

    return customOptinNewsletterPage;
}();

var ShopByLook = function () {
    function ShopByLook() {
        _classCallCheck(this, ShopByLook);

        this.btnShopByLookCta = '#shop-by-look';
        this.btnShopByLookClose = '.shop-by-look-products__dx';
        this.shopByLookDiv = '.shop-by-look-products';
        this.shopByLookListing = '.shop-by-look-products__content';
        this.selectSizeValue = '.shop-by-look__cta .product-select-variant__value';
        this.btnShopByLookAddToCart = '.shop-by-look__add-to-cart';
        this.checkOutBtn = '.shop-by-look__buttons #checkout-url';
        this.minicartSelector = '.minicart';
        this.selectVariant = '';
        this.init();
    }

    _createClass(ShopByLook, [{
        key: 'init',
        value: function init() {
            var self = this;
            $(self.btnShopByLookCta).click(function (e) {
                e.preventDefault();
                //se è già aperto e clicco sul bottone non faccio nulla
                if (!$(self.shopByLookDiv).hasClass("visible")) {
                    //gestione di stile
                    $(self.minicartSelector).removeClass("visible");
                    $(self.shopByLookDiv).addClass("visible");
                    self.activateBtnCheckout();
                    /*la faccio parte solo da mobile perchè da desktop
                    non ho questa problematica */
                    if ($(window).width() < SlamJam.costants.grid_large) {
                        self.calcRealDeviceHeight();
                    }
                    scrollLock.disablePageScroll(document.querySelector(self.shopByLookDiv));
                    // ottengo i vari handle
                    $(self.shopByLookListing).html("");
                    var allShopByLookProductsHandle = $(this).data('products').split(',');
                    var handles = [];
                    for (var i = 0; i < allShopByLookProductsHandle.length; i++) {
                        handles.push(allShopByLookProductsHandle[i].trim());
                    }
                    /*triggero evento di loader passandogli la classe
                    del loader specifico */
                    $('body').trigger('show-loading', {
                        handle: 'shop-by-look-loading'
                    });
                    self.getProducts(handles);
                }
            });
            //quando chiudo il popup con i prodotti shopbylook
            $(self.btnShopByLookClose).click(function (e) {
                e.preventDefault();
                $(self.shopByLookDiv).removeClass("visible");
                scrollLock.enablePageScroll(document.querySelector(self.shopByLookDiv));
            });
            //aggiuta al carrello
            $('body').on('click', self.btnShopByLookAddToCart, function () {
                var productID = $(this).attr('data-product-id');
                var variantID = $(this).attr('variant-id');
                var limiter = $(this).attr('data-limiter');
                var BtnActive = $(this);
                var productToAdd = { id: variantID };
                var onepairperCustomer = $(this).data('one-pair-per-customer');

                SlamJam.Cart.addItem(productID, self.variantToAdd, 1, limiter, productToAdd, onepairperCustomer, function () {
                    BtnActive.addClass('item-added');
                    SlamJam.minicart.refreshMinicart();
                    setTimeout(function () {
                        BtnActive.removeClass('item-added');
                    }, 1000);
                    self.activateBtnCheckout();
                }, function (XMLHttpRequest) {
                    SlamJam.showPopUpErrorFromAjaxRequest(XMLHttpRequest);
                });
            });
        }
    }, {
        key: 'getProducts',
        value: function getProducts(handles) {
            //questa funzione in pararello andra a gestire tutte le richieste di prodotti dei vari handle
            var self = this;
            var promises = [];
            //mi ciclo ogni handle e vado a salvarmi ogni risultato di chiamata all'interno di un array
            for (var i = 0; i < handles.length; i++) {
                var request = $.ajax({
                    url: '/products/' + handles[i] + '?view=shop-by-look',
                    async: true
                });
                promises.push(request);
            }
            //quando finisco di processare tutti gli handle
            $.when.apply(null, promises).done(function () {
                for (var i = 0; i < promises.length; i++) {
                    /*per ogni risposta di handle la vado ad appendere all'interno del div
                    degli shop by look */
                    $(self.shopByLookListing).append(promises[i].responseText);
                }
                //stacco il loader
                $('body').trigger('hide-loading', {
                    handle: 'shop-by-look-loading'
                });
                self.initSelect();
            });
        }
        //vado ad inizializzare selectTWo delle response

    }, {
        key: 'initSelect',
        value: function initSelect() {
            var self = this;
            $('.shop-by-look__content').each(function (index) {
                SlamJam.ProductTemplateShopByLook = new ProductTemplateShopByLook($(this));
            });
        }
    }, {
        key: 'activateBtnCheckout',
        value: function activateBtnCheckout() {
            var self = this;
            var cartContents = fetch(window.Shopify.routes.root + 'cart.js').then(function (response) {
                return response.json();
            }).then(function (cart) {
                if (cart.item_count > 0) {
                    $(self.checkOutBtn).removeClass("btn--disabled");
                } else {
                    $(self.checkOutBtn).addClass("btn--disabled");
                }
            });
        }
        //mi vado a calcolare la dimensione reale del dispositivo

    }, {
        key: 'calcRealDeviceHeight',
        value: function calcRealDeviceHeight() {
            var self = this;
            var realHeight = window.innerHeight;
            document.querySelector(self.shopByLookDiv).style.maxHeight = "calc(" + realHeight + "px" + " - " + "120px)";
        }
    }]);

    return ShopByLook;
}();

var CartCheckShipLocation = function () {
    function CartCheckShipLocation() {
        _classCallCheck(this, CartCheckShipLocation);

        this.init();
    }

    _createClass(CartCheckShipLocation, [{
        key: 'init',
        value: function init() {
            var self = this;
            var snattProducts = [];
            var ferraraProducts = [];
            function getLocations(locations, variant, snattProducts, ferraraProducts, numberOfItems) {
                var locationWithoutSpace = locations.trim();
                var onlyFerrara = false;
                var onlyMilano = false;
                // console.log(locationWithoutSpace);
                if (locationWithoutSpace.includes("SNATT")) {
                    snattProducts.push(variant);
                }
                if (locationWithoutSpace.includes("Ferrara")) {
                    onlyFerrara = true;
                    ferraraProducts.push(variant);
                }
                if (locationWithoutSpace.includes("Milano")) {
                    onlyMilano = true;
                }
                // console.log(snattProducts.length);
                // console.log(numberOfItems);
                /* Tutti i prodotti hanno disponibilità in SNATT
                non stampo popup */
                if (snattProducts.length == numberOfItems) {
                    document.querySelector('.modal-multi-locations').classList.remove("active");
                } else {
                    if (snattProducts.length > 0) {
                        document.querySelector('.modal-multi-locations').classList.add("active");
                    } else {
                        /*Nessun Prodotto ha disponibili in SNATT */
                        if (snattProducts.length == 0) {
                            /*Tutti i prodotti hanno disponibilità a Ferrara */
                            if (ferraraProducts.length == numberOfItems) {
                                document.querySelector('.modal-multi-locations').classList.remove("active");
                            } else {
                                document.querySelector('.modal-multi-locations').classList.add("active");
                            }
                        } else {
                            /*Almeno un PDT ha disponibilità in Milano
                            e almeno un prodotto non ha disponibilità in Ferrara */
                            if (onlyMilano == true && onlyFerrara == false) {
                                document.querySelector('.modal-multi-locations').classList.add("active");
                            } else {
                                document.querySelector('.modal-multi-locations').classList.remove("active");
                            }
                        }
                    }
                }
            }
            function checkAllProductVariatnsInCart(variants, snattProducts, ferraraProducts, numberOfItems) {
                var promises = [];
                //mi ciclo ogni handle e vado a salvarmi ogni risultato di chiamata all'interno di un array
                for (var i = 0; i < variants.length; i++) {
                    var request = $.ajax({
                        url: '/variants/' + variants[i].id + '/?section_id=store-availability-check-cart',
                        async: true
                    });
                    promises.push(request);
                }
                //quando finisco di processare tutti gli handle
                $.when.apply(null, promises).done(function () {
                    for (var i = 0; i < promises.length; i++) {
                        //console.log(promises[i])
                        var pickupAvailabilityHTML = new DOMParser().parseFromString(promises[i].responseText, 'text/html').querySelector('.shopify-section').innerHTML;
                        getLocations(pickupAvailabilityHTML, variants[i].id, snattProducts, ferraraProducts, numberOfItems);
                    }
                });
            }
            var cartContents = fetch(window.Shopify.routes.root + 'cart.js').then(function (response) {
                return response.json();
            }).then(function (data) {
                if (data.items.length > 1) {
                    checkAllProductVariatnsInCart(data.items, snattProducts, ferraraProducts, data.items.length);
                }
            });
        }
    }]);

    return CartCheckShipLocation;
}();

var ShippingMessagePDP = function () {
    function ShippingMessagePDP() {
        _classCallCheck(this, ShippingMessagePDP);

        this.selectCountry = '#shipping-card__countries';
        this.shippingZoneValues = '#shipping-card__countries option';
        this.init();
    }

    _createClass(ShippingMessagePDP, [{
        key: 'init',
        value: function init() {
            var self = this;
            this.getShippingZones(self.shippingZoneValues);
            this.initializeSelectCountry();
            this.selectIsoCoode();
            this.injectCountryShipMessage();
        }
    }, {
        key: 'getShippingZones',
        value: function getShippingZones(shippingZoneValues) {
            $(shippingZoneValues).each(function () {
                if (Shopify.country == $(this).val()) {
                    $(this).attr('selected', 'selected');
                }
            });
        }
    }, {
        key: 'initializeSelectCountry',
        value: function initializeSelectCountry() {
            function orderCountryBySettings() {
                var allSelectors = document.querySelectorAll("#shipping-card__countries");

                function allCountrySwitcherConfigurations(currentSelector) {
                    var items = Array.from(currentSelector.querySelectorAll('option'));
                    var itemsLength = items.length;
                    var orderBy = Array(itemsLength).fill().map(function (x, i) {
                        return i + 1;
                    });

                    orderBy.forEach(function (i) {
                        if (items.find(function (x) {
                            return x.getAttribute("data-position") != undefined;
                        })) {
                            var item = items.find(function (x) {
                                return x.getAttribute("data-position") === '' + i;
                            });
                            if (item != undefined) {
                                item.parentElement.prepend(item);
                            }
                        }
                    });
                }

                allSelectors.forEach(function (element) {
                    allCountrySwitcherConfigurations(element);
                });
            }

            orderCountryBySettings();
            //inizializzo la select con select2
            this.countrySelect = $('#shipping-card__countries').select2({
                closeOnSelect: true,
                width: '100%',

                // aggiungo una classe css all'ultimo elemento della lista degli isocode principali
                templateResult: function templateResult(data, container) {
                    if (data.element && data.element.dataset.last == 'true') {
                        $(container).addClass('last');
                    }

                    return data.text;
                },

                // sort delle option a seconda di data-position
                sorter: function sorter(data) {
                    return data.sort(function (a, b) {
                        a = a.element.dataset.position || 0;
                        b = b.element.dataset.position || 0;
                        a = '' + a;
                        b = '' + b;

                        if (a < b) {
                            return 1;
                        } else if (a > b) {
                            return -1;
                        }

                        return 0;
                    });
                }
            });
        }
    }, {
        key: 'selectIsoCoode',
        value: function selectIsoCoode() {

            function calcMaxHeightAccordion() {
                var maxHeigthAccordion = parseInt($('.panel.shipping').css("max-height"));
                var plusHeight = parseInt($('.shipping-message__text').css("height"));
                var newMaxHeight = maxHeigthAccordion + plusHeight;
                $('.panel.shipping').css("max-height", newMaxHeight + "px");
            }

            function manageLinksInMessage() {
                var allLinksinMessages = document.querySelectorAll(".shipping-message__text a");
                allLinksinMessages.forEach(function (el, index, array) {
                    el.setAttribute('target', '_blank');
                });
            }

            $('body').on('change', '#shipping-card__countries', function () {
                var toCheck = $('#shipping-card__countries option:selected').attr('value');
                $('.shipping-message__text').empty();

                $('.shipping-country__text').each(function () {
                    if (toCheck == $(this).attr('isocode')) {
                        $.ajax({
                            url: window.location.href + '/?section_id=product-shipping-message',
                            type: 'GET',
                            success: function success(response) {
                                var shippingMessage = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                                $(shippingMessage).each(function () {
                                    if ($(this).attr("isocode") == toCheck) {
                                        $('.shipping-message__text').append($(this).html());
                                        calcMaxHeightAccordion();
                                        manageLinksInMessage();
                                    }
                                });
                            }
                        });
                    }
                });
            });
        }
    }, {
        key: 'injectCountryShipMessage',
        value: function injectCountryShipMessage() {

            function manageLinksInMessage() {
                var allLinksinMessages = document.querySelectorAll(".shipping-message__text a");
                allLinksinMessages.forEach(function (el, index, array) {
                    el.setAttribute('target', '_blank');
                });
            }

            $.ajax({
                url: window.location.href + '/?section_id=product-shipping-message',
                type: 'GET',
                success: function success(response) {
                    var shippingMessage = new DOMParser().parseFromString(response, 'text/html').querySelector('.shopify-section').innerHTML;
                    $(shippingMessage).each(function () {
                        if ($(this).attr("isocode") == Shopify.country) {
                            $('.shipping-message__text').append($(this).html());
                            manageLinksInMessage();
                        }
                    });
                }
            });
        }
    }]);

    return ShippingMessagePDP;
}();

var Af1PageBlack = function () {
    function Af1PageBlack() {
        _classCallCheck(this, Af1PageBlack);

        this.countDownDiv = '.product-template__af, .af1-countdown';
        this.countDownDateAttr = '.raffle-countdown';
        this.raffleCTAMobileParent = '.raffle-pdp';
        this.raffleCTAMobile = '.product-template__af1 .btn--add-to-cart';
        this.selectSize = '.product-template__af1 .product-select-variant__title';
        this.closeGiftBlock = '#draggable-div .close-btn';
        this.multiRaffleSelector = '.product-template__af1.multi-raffle .pdp-actions__wrapper .panel__container .right, .product-template__af1.multi-raffle .pdp-actions__wrapper .panel__container .left';

        this.init();
    }

    _createClass(Af1PageBlack, [{
        key: 'init',
        value: function init() {
            var self = this;
            if (template == "product.af1-black") {
                this.countdown();
                this.injectCountDown();
                this.stylingSelect();
                this.goToGallery();
                this.closeGifBlock();
                this.multiRaffleCTA();
                this.raffleFormFix();

                if ($(window).width() < SlamJam.costants.grid_large) {
                    this.showCTARaffle();
                    this.StickySeeGallery();
                }
            }
        }
    }, {
        key: 'raffleFormFix',
        value: function raffleFormFix() {
            if ($(window).width() > SlamJam.costants.grid_large) {
                $('#add-to-cart-sticky-wrapper > form').remove();
            } else {
                //$('.product-details__dx .add-to-cart-wrapper form').remove();
            }
        }
    }, {
        key: 'multiRaffleCTA',
        value: function multiRaffleCTA() {
            var self = this;
            $(document).on('click', self.multiRaffleSelector, function (e) {
                console.log($(this).data("cta"));
                $('.pdp-action .pdp-action--wrapper .product-details').removeClass("hidden");
                $('.pdp-action .pdp-action--wrapper .product-details').addClass("visible");

                if ($(window).width() < SlamJam.costants.grid_large) {
                    $('.pdp-actions__wrapper .raffle').removeClass("show-block");
                }

                if ($(this).data("cta") == 'raffle-open-milan') {
                    $('.product-details.af-1 .add-to-cart-wrapper').addClass("raffle-milano-style");
                } else if ($(this).data("cta") == 'raffle-open') {
                    $('.product-details.af-1 .add-to-cart-wrapper').addClass("raffle-web-style");
                }
            });
        }
    }, {
        key: 'closeGifBlock',
        value: function closeGifBlock() {
            var self = this;
            $(document).on('click', self.closeGiftBlock, function (e) {
                $(this).closest("#draggable-div").fadeOut();
            });
        }
    }, {
        key: 'goToGallery',
        value: function goToGallery() {
            // handle links with @href started with '#' only
            $(document).on('click', '.see-gallery--cta a', function (e) {
                // target element id
                var id = $(this).attr('href');
                // target element
                var $id = $(id);
                if ($id.length === 0) {
                    return;
                }
                var yOffset = 0; // corrisponde all'header
                if (window.innerWidth <= SlamJam.costants.grid_large) {
                    yOffset = 122;
                } else {
                    yOffset = 150;
                }
                // prevent standard hash navigation (avoid blinking in IE)
                e.preventDefault();
                // top position relative to the document
                var pos = $id.offset().top - yOffset;
                // animated top scrolling

                $('body, html').animate({ scrollTop: pos }, 3500);
            });
        }
    }, {
        key: 'StickySeeGallery',
        value: function StickySeeGallery() {
            // console.log("deploy");
            var el = document.querySelector('#gallery');
            var ctaSeeGallery = document.querySelector('.see-galley');
            var observer = new window.IntersectionObserver(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 1),
                    entry = _ref2[0];

                if (entry.isIntersecting) {
                    document.querySelector('.gallery-cta').innerHTML = "";
                    document.querySelector('.gallery-cta').appendChild(ctaSeeGallery);
                    return;
                } else {
                    document.querySelector('.gallery-cta').innerHTML = "";
                    document.querySelector('.gallery-sticky').appendChild(ctaSeeGallery);
                }
            }, {
                root: null,
                threshold: 0 // set offset 0.1 means trigger if atleast 10% of element in viewport
            });

            observer.observe(el);
        }
    }, {
        key: 'stylingSelect',
        value: function stylingSelect() {
            var self = this;
            $(self.selectSize).hover(function () {
                $(this).addClass("hover-effects");
            }, function () {
                $(this).removeClass("hover-effects");
            });
        }
    }, {
        key: 'countdown',
        value: function countdown() {
            var self = this;
            $(self.countDownDateAttr).each(function () {

                var raffleWeb = $(this).data('raffle-web');
                var raffleWebStatus = $(this).data('raffle-status');
                var raffleMilanoStatus = $(this).data('milano-raffle-status');

                var raffleMilano = $(this).data('raffle-milano');
                var raffleStart = $(this).data('raffle-start');
                var raffleEnd = $(this).data('raffle-end');
                var raffleStartMilano = $(this).data('milano-raffle-start');
                var raffleEndMilano = $(this).data('raffle-milano-end');
                var enableCountdown = true;
                var closeWithoutStock = false;
                var closeWithStock = false;

                if (Shopify.country == 'IT') {
                    if (raffleWeb == false && raffleMilano == false) {
                        if (raffleWebStatus == "end" && raffleMilanoStatus == "end") {
                            enableCountdown = false;
                            $('.product-template__af1').addClass("multi-raffle");
                            closeWithoutStock = true;
                        } else {
                            if (raffleWebStatus == "close" && raffleMilanoStatus == "close") {
                                enableCountdown = false;
                                closeWithStock = true;
                            }
                        }
                    }
                } else {

                    if (raffleWeb == false) {
                        enableCountdown = false;

                        if (raffleWebStatus == "close") {
                            closeWithStock = true;
                        }

                        if (raffleWebStatus == "end") {
                            closeWithoutStock = true;
                        }
                    }
                }

                if (enableCountdown == false) {
                    var specificDivToInjected = $('.af1-countdown');
                    var raffleEndMessage = "<div class='end-raffle'>WEB DRAW LAUNCHED ON: " + raffleStart + "<br>" + "MILANO DRAW LAUNCHED ON: " + raffleStartMilano + "</div>";
                    var raffleEndMessageExtraIT = "<div class='end-raffle'>WEB DRAW LAUNCHED ON: " + raffleStart + "</div>";

                    $(specificDivToInjected).each(function (i) {

                        if (SlamJam.strings.dropInstance == true) {
                            if (closeWithStock == true) {

                                var currentRedirectProdParent = $(this).closest('.product-template__af1');
                                var currentRedirectProdElement = currentRedirectProdParent.find('.pdp-actions');
                                $(this).html(currentRedirectProdElement);
                                $('.product-template__af1').addClass("drop-closed-with-stock");
                            }
                        }

                        if (closeWithoutStock == true) {
                            if (Shopify.country == 'IT') {
                                $(this).html(raffleEndMessage);
                            } else {
                                $(this).html(raffleEndMessageExtraIT);
                            }
                        }
                    });
                }

                function countDownActions(raffleStart, raffleEnd, raffleStartMilano, raffleEndMilano) {

                    if (raffleWeb) {
                        var raffleStart = new Date(raffleStart);
                        raffleStart = Date.parse(raffleStart) / 1000;
                        var raffleEnd = new Date(raffleEnd);
                        raffleEnd = Date.parse(raffleEnd) / 1000;
                        var now = new Date();
                        var offsetHour = now.getUTCHours();
                        var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), offsetHour, now.getUTCMinutes(), now.getUTCSeconds());
                        now = Date.parse(nowUtc) / 1000;
                        /* sopra date now preso in UTC */
                    }

                    if (raffleMilano) {
                        var raffleStartMilano = new Date(raffleStartMilano);
                        raffleStartMilano = Date.parse(raffleStartMilano) / 1000;
                        var raffleEndMilano = new Date(raffleEndMilano);
                        raffleEndMilano = Date.parse(raffleEndMilano) / 1000;
                        var nowMilano = new Date();
                        var offsetHourMilano = nowMilano.getUTCHours();
                        var nowUtcMilano = new Date(nowMilano.getUTCFullYear(), nowMilano.getUTCMonth(), nowMilano.getUTCDate(), offsetHourMilano, nowMilano.getUTCMinutes(), nowMilano.getUTCSeconds());
                        nowMilano = Date.parse(nowUtcMilano) / 1000;
                        /* sopra date now preso in UTC */
                    }

                    var timeStartRaffle = []; //data partenza raffle (sia milano che web)
                    var messageCurrentRaffle = [];

                    if (raffleMilano && raffleWeb && Shopify.country == 'IT') {
                        $('.product-template__af1').addClass("multi-raffle");
                        $('.web-milano-wrapper').addClass("visible");
                    } else if (raffleWeb) {
                        $('.product-template__af1').addClass("single-raffle");
                        $('.product-details.af-1').removeClass("hidden");
                    }

                    if (Shopify.country == 'IT') {
                        if (raffleMilano) {
                            if (raffleStartMilano > nowMilano) {
                                /* inserire classe al padre raffle "web-pending" */
                                $('.product-template__af1').addClass("milano-pending");
                                timeStartRaffle[1] = raffleStart - now;
                                // var timeLeft = raffleStart - now;
                                messageCurrentRaffle[1] = ["MILANO DRAW OPENS IN: "];
                            } else if (raffleEndMilano > nowMilano) {

                                timeStartRaffle[1] = raffleEndMilano - nowMilano;
                                /* inserire classe al padre raffle "web-open" */
                                $('.product-template__af1').addClass("milano-open");

                                messageCurrentRaffle[1] = ["MILANO DRAW ENDS IN: "];
                            }
                        }
                    }

                    if (raffleWeb) {
                        if (raffleStart > now) {
                            /* inserire classe al padre raffle "web-pending" */
                            $('.product-template__af1').addClass("web-pending");
                            timeStartRaffle[0] = raffleStart - now;
                            messageCurrentRaffle[0] = ["WEB DRAW OPENS IN: "];
                        } else if (raffleEnd > now) {
                            //   var timeLeft = raffleEnd - now;
                            timeStartRaffle[0] = raffleEnd - now;
                            messageCurrentRaffle[0] = ["WEB DRAW ENDS IN: "];
                            $('.product-template__af1').addClass("web-open");
                            /* inserire classe al padre raffle "web-open" */
                            $('.raffle-pdp__container #AddToCart-product-template').removeClass("btn--disabled");
                        }
                    }

                    createCountdownRaffle(timeStartRaffle, messageCurrentRaffle);
                }

                function createCountdownRaffle(timeStartRaffle, messageCurrentRaffle) {

                    var daysElaborate;
                    var hoursElaborate;
                    var minutesElaborate;
                    var secondsElaborate;

                    var specificDivToInjected = $('.raffle-message');

                    $(specificDivToInjected).each(function (i) {

                        if ($(this).attr("class") == 'raffle-message web') {
                            i = 0;
                        } else if ($(this).attr("class") == 'raffle-message milano') {
                            i = 1;
                        }

                        var days = Math.floor(timeStartRaffle[i] / 86400);
                        var hours = Math.floor((timeStartRaffle[i] - days * 86400) / 3600);
                        var minutes = Math.floor((timeStartRaffle[i] - days * 86400 - hours * 3600) / 60);
                        var seconds = Math.floor(timeStartRaffle[i] - days * 86400 - hours * 3600 - minutes * 60);

                        daysElaborate = days;
                        hoursElaborate = hours;
                        minutesElaborate = minutes;
                        secondsElaborate = seconds;

                        if (daysElaborate < "10") {
                            daysElaborate = "0" + daysElaborate;
                        }
                        if (hoursElaborate < "10") {
                            hoursElaborate = "0" + hoursElaborate;
                        }
                        if (minutesElaborate < "10") {
                            minutesElaborate = "0" + minutesElaborate;
                        }
                        if (secondsElaborate < "10") {
                            secondsElaborate = "0" + secondsElaborate;
                        }

                        // se nel mentre il timer finisce ricarico la pagina
                        if (daysElaborate == 0 && hoursElaborate == 0 && minutesElaborate == 0 && secondsElaborate == 0) {
                            location.reload();
                        }

                        if (daysElaborate < "10") {
                            var days = "0" + days;
                        }
                        if (hours < "10") {
                            var hours = "0" + hours;
                        }
                        if (minutes < "10") {
                            var minutes = "0" + minutes;
                        }
                        if (seconds < "10") {
                            var seconds = "0" + seconds;
                        }

                        $(this).find('.raffle-status').html(messageCurrentRaffle[i]);
                        if (days != "00") {
                            $(this).find('.days').html(days + ":");
                        } else {
                            $(this).find('.days').html("00:");
                        }
                        if (hours != "00") {
                            $(this).find('.hours').html(hours + ":");
                        } else {
                            $(this).find('.minutes').html("00:");
                        }
                        if (minutes != "00") {
                            $(this).find('.minutes').html(minutes + ":");
                        } else {
                            $(this).find('.minutes').html("00:");
                        }
                        if (seconds != 0) {
                            $(this).find('.seconds').html(seconds);
                        }
                    });
                }

                if (enableCountdown == true) {
                    setInterval(function () {
                        countDownActions(raffleStart, raffleEnd, raffleStartMilano, raffleEndMilano);
                    }, 1000);
                }
            });
        }
    }, {
        key: 'injectCountDown',
        value: function injectCountDown() {
            var self = this;
            var allCountdown = document.querySelectorAll('.raffle-countdown');
            var allDivToInsert = document.querySelectorAll('.af1-countdown');
            for (var i = 0; i < allCountdown.length; i++) {

                for (var _i2 = 0; _i2 < allDivToInsert.length; _i2++) {
                    allDivToInsert[_i2].appendChild(allCountdown[_i2]);
                }
            }
        }
    }, {
        key: 'showCTARaffle',
        value: function showCTARaffle() {
            var self = this;
            $(self.raffleCTAMobileParent).addClass("active");
        }
    }]);

    return Af1PageBlack;
}();

var Af1Page = function () {
    function Af1Page() {
        _classCallCheck(this, Af1Page);

        this.countDownDiv = '.product-template__af, .af1-countdown';
        this.countDownDateAttr = '.raffle-countdown';
        this.raffleCTAMobileParent = '.raffle-pdp';
        this.raffleCTAMobile = '.product-template__af1 .btn--add-to-cart';
        this.selectSize = '.product-template__af1 .product-select-variant__title';
        this.init();
    }

    _createClass(Af1Page, [{
        key: 'init',
        value: function init() {
            var self = this;
            if ($('.product-template__af1').length) {
                this.countdown();
                this.injectCountDown();
                this.stylingSelect();
                this.goToGallery();
                if ($(window).width() < SlamJam.costants.grid_large) {
                    this.showCTARaffle();
                    this.StickySeeGallery();
                } else {
                    this.removeLastBlockFromMain();
                }
            }
        }
    }, {
        key: 'goToGallery',
        value: function goToGallery() {
            // handle links with @href started with '#' only
            $(document).on('click', '.see-gallery--cta a', function (e) {
                // target element id
                var id = $(this).attr('href');
                // target element
                var $id = $(id);
                if ($id.length === 0) {
                    return;
                }
                var yOffset = 0; // corrisponde all'header
                if (window.innerWidth <= SlamJam.costants.grid_large) {
                    yOffset = 122;
                } else {
                    yOffset = 150;
                }
                // prevent standard hash navigation (avoid blinking in IE)
                e.preventDefault();
                // top position relative to the document
                var pos = $id.offset().top - yOffset;
                // animated top scrolling

                $('body, html').animate({ scrollTop: pos }, 3500);
            });
        }
    }, {
        key: 'StickySeeGallery',
        value: function StickySeeGallery() {
            var el = document.querySelector('#gallery');
            var ctaSeeGallery = document.querySelector('.see-galley');
            var observer = new window.IntersectionObserver(function (_ref3) {
                var _ref4 = _slicedToArray(_ref3, 1),
                    entry = _ref4[0];

                if (entry.isIntersecting) {
                    document.querySelector('.gallery-cta').innerHTML = "";
                    document.querySelector('.gallery-cta').appendChild(ctaSeeGallery);
                    return;
                } else {
                    document.querySelector('.gallery-cta').innerHTML = "";
                    document.querySelector('.gallery-sticky').appendChild(ctaSeeGallery);
                }
            }, {
                root: null,
                threshold: 0 // set offset 0.1 means trigger if atleast 10% of element in viewport
            });

            observer.observe(el);
        }
    }, {
        key: 'removeLastBlockFromMain',
        value: function removeLastBlockFromMain() {
            $("#shopify-section-template--15678595170509__e197dc25-ff78-4e4b-bc9a-65506f61ba8a").insertAfter(".main-content ");
        }
    }, {
        key: 'stylingSelect',
        value: function stylingSelect() {
            var self = this;
            $(self.selectSize).hover(function () {
                $(this).addClass("hover-effects");
            }, function () {
                $(this).removeClass("hover-effects");
            });
        }
    }, {
        key: 'countdown',
        value: function countdown() {
            var self = this;
            $(self.countDownDateAttr).each(function () {
                var reservationStart = $(this).data('reservation-start');
                var reservationEnd = $(this).data('reservation-end');
                var raffleStart = $(this).data('raffle-start');
                var raffleEnd = $(this).data('raffle-end');
                var productAvailable = $(this).data('product-available');
                var productUrl = $(this).data('prod-url');
                var raffleEndStatus = $(this).data('raffle-status');
                var currentDiv = $(".clockdiv");
                var reservationStartsText = $(this).data('reservation-start-text');
                var reservationEndsText = $(this).data('reservation-end-text');

                function countDownActions(reservationStart, reservationEnd, raffleStart, raffleEnd, currentDiv, productAvailable, productUrl, raffleEndStatus, reservationStartsText, reservationEndsText) {
                    /*ottengo data inizio reservation */
                    var startTime = new Date(reservationStart);
                    startTime = Date.parse(startTime) / 1000;
                    /*fine dichiarazione di data inizio reservation */
                    /*ottengo data fine reservation */
                    var endTime = new Date(reservationEnd);
                    endTime = Date.parse(endTime) / 1000;
                    /*fine dichiarazione di data fine reservation */
                    var raffleStart = new Date(raffleStart);
                    raffleStart = Date.parse(raffleStart) / 1000;
                    var raffleEndOriginalFormat = raffleEnd;
                    var raffleEnd = new Date(raffleEnd);
                    raffleEnd = Date.parse(raffleEnd) / 1000;
                    var now = new Date();
                    var offsetHour = now.getUTCHours();
                    var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), offsetHour, now.getUTCMinutes(), now.getUTCSeconds());
                    now = Date.parse(nowUtc) / 1000;
                    /* sopra date now preso in UTC */
                    var message = false;
                    var goToCTARaffle = false;
                    var checkCountDown = false;
                    var timeLeft = false;
                    var inReservation = false;
                    var raffleEndTime = false;
                    var raffleStatusFinish = false;
                    var pending = false;
                    var open = false;
                    if (raffleEndStatus == "raffle-end" || raffleEndStatus == "raffle-redirect") {
                        if (!SlamJam.strings.af1Instance) {
                            raffleStatusFinish = true;
                        }
                    }
                    if (startTime > now || endTime > now) {
                        checkCountDown = true;
                    } else {
                        if (raffleStart > now || raffleEnd > now) {
                            checkCountDown = true;
                            if (SlamJam.strings.dropInstance == false) {
                                pending = true;
                            }
                        } else {
                            if (now > raffleEnd) {
                                raffleEndTime = true;
                                if (SlamJam.strings.dropInstance == false) {
                                    open = true;
                                }
                            }
                        }
                    }
                    $($(currentDiv)).each(function () {
                        if (SlamJam.strings.dropInstance == false) {
                            if (pending) {
                                if (!$('.product-template__af1').hasClass("af1-store")) {
                                    $('.product-template__af1').addClass("pending");
                                }
                                // $('.redirect-store').show();
                            } else {
                                if (raffleEndTime || raffleStatusFinish) {
                                    if (productAvailable) {
                                        // se è lo store af1 (dedicato alla raffle) non deve mai terminare
                                        $('.product-template__af1.pending .product-details').show();
                                    } else {
                                        $('.product-template__af1').addClass("raffe-end-prod");
                                        message = "Launched on: " + raffleEndOriginalFormat;
                                    }
                                }
                            }
                        }
                        if (raffleEndTime || raffleStatusFinish) {
                            $('.product-template__af1').addClass("raffe-end");
                            if (productAvailable) {
                                if (SlamJam.strings.dropInstance == true) {
                                    message = '<a href="' + productUrl + '" class="go-prod"> Shop at Slamjam.com</a>';
                                    $(this).find('.raffle-status').html(message);
                                } else {
                                    // $(self.raffleCTAMobile).removeClass("btn--disabled");
                                }
                            } else {
                                message = "Launched on: " + raffleEndOriginalFormat;
                                $(this).find('.raffle-status').html(message);
                            }
                        } else {
                            if (checkCountDown) {
                                if (startTime > now) {
                                    timeLeft = startTime - now;
                                    message = reservationStartsText;
                                    inReservation = true;
                                } else {
                                    if (endTime > now) {
                                        timeLeft = endTime - now;
                                        message = reservationEndsText;
                                        goToCTARaffle = true;
                                        inReservation = true;
                                    } else {
                                        if (raffleStart > now) {
                                            timeLeft = raffleStart - now;
                                            message = "WEB DRAW OPENS IN: ";
                                            goToCTARaffle = true;
                                            inReservation = false;
                                            if (!$('.product-template__af1').hasClass("af1-store")) {
                                                $(self.raffleCTAMobile).addClass("btn--disabled");
                                            }
                                        } else {
                                            if (raffleEnd > now) {
                                                timeLeft = raffleEnd - now;
                                                message = "WEB DRAW ENDS IN: ";
                                                inReservation = false;
                                                $(self.raffleCTAMobile).removeClass("btn--disabled");
                                                $('.product-template__af1 .btn--add-to-cart').removeClass("btn--disabled");
                                            }
                                        }
                                    }
                                }
                                var days = Math.floor(timeLeft / 86400);
                                var hours = Math.floor((timeLeft - days * 86400) / 3600);
                                var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
                                var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);
                                var hotReload = false;
                                if (days == 0 && hours == 0 && minutes == 0 && seconds == 1) {
                                    hotReload = true;
                                }
                                if (days < "10") {
                                    var days = "0" + days;
                                }
                                if (hours < "10") {
                                    var hours = "0" + hours;
                                }
                                if (minutes < "10") {
                                    var minutes = "0" + minutes;
                                }
                                if (seconds < "10") {
                                    var seconds = "0" + seconds;
                                }

                                // se nel mentre il timer finisce ricarico la pagina
                                if (hotReload) {
                                    location.reload();
                                } else {
                                    if (inReservation) {
                                        $('.redirect-store').hide();
                                        if ($('.af1-countdown').hasClass("in-reservation")) {
                                            if (!$('.product-template__af1').hasClass("af1-store")) {
                                                $('.product-template__af1').addClass("in-reservation");
                                                $('.raffle-pdp').removeClass("active");
                                            }
                                        }
                                        if (!$('.product-template__af1').hasClass("af1-store")) {
                                            $(self.countDownDiv).each(function () {
                                                $(this).addClass("in-reservation");
                                            });
                                        }
                                    } else {
                                        $(".product-template__af1 .sticky").each(function () {
                                            $(this).removeClass("in-reservation");
                                        });
                                    }
                                    $(this).find('.raffle-status').html(message);
                                    if (days != "00") {
                                        $(this).find('.days').html(days + ":");
                                    } else {
                                        $(this).find('.days').html("00:");
                                    }
                                    if (hours != "00") {
                                        $(this).find('.hours').html(hours + ":");
                                    } else {
                                        $(this).find('.minutes').html("00:");
                                    }
                                    if (minutes != "00") {
                                        $(this).find('.minutes').html(minutes + ":");
                                    } else {
                                        $(this).find('.minutes').html("00:");
                                    }
                                    if (seconds != 0) {
                                        $(this).find('.seconds').html(seconds);
                                    }
                                }
                            }
                        }
                    });
                }
                setInterval(function () {
                    countDownActions(reservationStart, reservationEnd, raffleStart, raffleEnd, currentDiv, productAvailable, productUrl, raffleEndStatus, reservationStartsText, reservationEndsText);
                }, 1000);
            });
        }
    }, {
        key: 'injectCountDown',
        value: function injectCountDown() {
            var self = this;
            $('.raffle-countdown').css("display", "flex");
            var allCountdown = document.querySelectorAll('.raffle-countdown');
            var allDivToInsert = document.querySelectorAll('.af1-countdown');
            for (var i = 0; i < allCountdown.length; i++) {
                for (var _i3 = 0; _i3 < allDivToInsert.length; _i3++) {
                    allDivToInsert[_i3].appendChild(allCountdown[_i3]);
                }
            }
        }
    }, {
        key: 'showCTARaffle',
        value: function showCTARaffle() {
            var self = this;
            $(self.raffleCTAMobileParent).addClass("active");
        }
    }]);

    return Af1Page;
}();

var comingSoon = function () {
    function comingSoon() {
        _classCallCheck(this, comingSoon);

        this.comingSoonHtml = '.coming-soon__item, .coming-soon__wrapper';
        this.addToCartForm = '.product-details__dx .add-to-cart-wrapper';
        this.addToCartFormMobile = '#add-to-cart-sticky-wrapper';
        this.alertBlockComingSoon = '.product-alerts__item.coming-soon__item';
        this.alertBlockComingSoonMobile = '.coming-soon.mobile-settings';

        this.init();
    }

    _createClass(comingSoon, [{
        key: 'init',
        value: function init() {
            var self = this;

            function initCollection() {
                var target = document.querySelector('#shop-products');

                var observer = new MutationObserver(function (mutations) {
                    mutations.forEach(function (mutation) {

                        if (mutation.type == 'childList') {

                            var comingSoonDiv = document.querySelectorAll(self.comingSoonHtml);

                            for (var i = 0; i < comingSoonDiv.length; i++) {
                                self.makeTimer(comingSoonDiv[i]);
                            }
                        }
                    });
                });

                // configuration of the observer
                var config = { childList: true };

                observer.observe(target, config);
            }

            function initProduct() {
                var comingSoonDiv = document.querySelectorAll(self.comingSoonHtml);

                for (var i = 0; i < comingSoonDiv.length; i++) {
                    self.makeTimer(comingSoonDiv[i]);
                }
            }

            if (template == 'collection' || template == 'search') {
                initCollection();
            }

            if (template == 'product') {
                initProduct();
            }
        }
    }, {
        key: 'makeTimer',
        value: function makeTimer(currentComingSoonDiv) {

            var interval = setInterval(function () {
                var endTime = new Date(currentComingSoonDiv.querySelector(".coming-soon--countdown").getAttribute("data-coming-date"));
                var now = new Date();
                var offsetHour = now.getUTCHours();
                var nowUtc = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), offsetHour, now.getUTCMinutes(), now.getUTCSeconds());
                endTime = Date.parse(endTime) / 1000;
                now = Date.parse(nowUtc) / 1000;

                if (endTime > now) {

                    if (template == "collection" || template == "search") {
                        currentComingSoonDiv.classList.add("visible");
                        currentComingSoonDiv.parentNode.closest('.product-card').querySelector(".product-card__label--quick-shop").style.display = "none";
                    }

                    if (template == "product") {
                        if (document.querySelector('.product-details__dx .add-to-cart-wrapper').classList.contains("coming-soon")) {

                            if (window.innerWidth <= SlamJam.costants.grid_large) {
                                document.querySelector('.coming-soon.mobile-settings').classList.add("visible");
                            } else {
                                document.querySelector('.product-alerts__item.coming-soon__item').classList.add("visible");
                            }
                        }
                    }

                    var timeLeft = endTime - now;
                    var days = Math.floor(timeLeft / 86400);
                    var hours = Math.floor((timeLeft - days * 86400) / 3600);
                    var minutes = Math.floor((timeLeft - days * 86400 - hours * 3600) / 60);
                    var seconds = Math.floor(timeLeft - days * 86400 - hours * 3600 - minutes * 60);

                    if (days == 0 && hours == 0 && minutes == 0 && seconds == 1) {
                        location.reload();
                    }

                    if (hours < "10") {
                        hours = "0" + hours;
                    }
                    if (minutes < "10") {
                        minutes = "0" + minutes;
                    }
                    if (seconds < "10") {
                        seconds = "0" + seconds;
                    }

                    if (days != 0) {
                        currentComingSoonDiv.querySelector(".days").innerHTML = days + " <span>Days and</span>";
                    }

                    currentComingSoonDiv.querySelector(".hours").innerHTML = hours + "<span>:</span>";
                    currentComingSoonDiv.querySelector(".minutes").innerHTML = minutes + "<span>:</span>";
                    currentComingSoonDiv.querySelector(".seconds").innerHTML = seconds;
                } else {

                    currentComingSoonDiv.classList.add("hidden");

                    if (template == "product") {
                        if (window.innerWidth <= SlamJam.costants.grid_large) {
                            document.querySelector('.coming-soon.mobile-settings').classList.remove("visible");
                            document.querySelector('#add-to-cart-sticky-wrapper').classList.add("sellable");
                        } else {
                            document.querySelector('.product-details__dx .add-to-cart-wrapper').classList.remove("coming-soon");
                        }
                    }
                    clearInterval(interval);
                }
            }, 1000);
        }
    }]);

    return comingSoon;
}();

var PostNewsletterSubmit = function () {
    function PostNewsletterSubmit() {
        _classCallCheck(this, PostNewsletterSubmit);

        this.postSuccessfullMessage = '.newsletter-successfully';
        this.elementToScroll = document.querySelector(this.postSuccessfullMessage);
        this.init();
    }

    _createClass(PostNewsletterSubmit, [{
        key: 'init',
        value: function init() {
            var self = this;

            document.onreadystatechange = function () {
                if (document.readyState === 'complete') {
                    var waitFor = function waitFor(variable, callback) {
                        var interval = setInterval(function () {
                            if (window[variable]) {
                                clearInterval(interval);
                                callback();
                            }
                        }, 1000);
                    };

                    waitFor('SearchaniseIncluded', function () {
                        /*fa lo scroll in fondo alla pagina quando la submit della form newsletter è
                        avvenuta */
                        self.elementToScroll.scrollIntoView();
                    });
                }
            };
        }
    }]);

    return PostNewsletterSubmit;
}();

$(document).ready(function () {
    lazySizes.init();
    SlamJam.init();
});

window.addEventListener('load', function (event) {

    if (template != 'product.af1-black') {
        var detectRaffleStatus = function detectRaffleStatus() {
            var raffleMilan = $('.raffle__container .panel__container .left').hasClass("pending");
            var raffleWeb = $('.raffle__container .panel__container .right').hasClass("pending");

            if ($('.add-to-cart-wrapper').hasClass("multi-raffle")) {
                if (raffleMilan) {
                    $('.raffle-pdp').addClass("active");
                    $('.raffle-pdp__container .add-to-cart-btn-wrapper:last-of-type').removeClass("show-cta").hide();
                    $('.raffle__container .panel__container .left').append($('#shopify-section-product-template-raffle .product-alerts .milan-countdown-start'));
                }

                if (raffleWeb) {
                    $('.raffle-pdp').addClass("active");
                    $('.raffle-pdp__container .add-to-cart-btn-wrapper:first-of-type').removeClass("show-cta").hide();
                    $('.raffle__container .panel__container .right').append($('#shopify-section-product-template-raffle .product-alerts .countdown-start'));
                }

                if (!raffleMilan && !raffleWeb) {
                    $('.raffle__container .panel__container').addClass("cta-center");
                    $('#AddToCart-product-template, #AddToCart-product-template-milan').addClass("full-width");
                }

                $('#AddToCart-product-template, #AddToCart-product-template-milan').click(function () {
                    if (raffleMilan || raffleWeb) {
                        $('.raffle').removeClass("show-block");
                        $('#add-to-cart-sticky-wrapper').addClass("multiraffle-mobile");
                        $(this).addClass("full-width");
                    }
                });

                if (!raffleMilan || !raffleWeb) {
                    if (!$('.raffle.show-block .panel .left').hasClass("disabled")) {
                        $('.raffle-pdp.multi .raffle-pdp__container .add-to-cart-btn-wrapper:last-of-type').addClass("show-cta");
                    }

                    if (!$('.raffle.show-block .panel .right').hasClass("disabled")) {
                        $('.raffle-pdp.multi .raffle-pdp__container .add-to-cart-btn-wrapper:first-of-type').addClass("show-cta");
                    }
                }
            } else {

                if ($('#add-to-cart-sticky-wrapper').hasClass("single-web-pending")) {
                    $('#add-to-cart-sticky-wrapper').append($('.product-details__raffle-block .countdown-start'));
                }

                if ($('#add-to-cart-sticky-wrapper').hasClass("single-milan-pending")) {
                    $('#add-to-cart-sticky-wrapper').append($('.product-details__raffle-block .milan-countdown-start'));
                }
            }
        };

        var appendLogin = function appendLogin() {
            $('#add-to-cart-sticky-wrapper').append($('.raffle.show-block'));
        };
    }

    if (SlamJam.strings.dropInstance == true) {
        if ($('body').hasClass("template-product")) {
            if ($(window).width() < SlamJam.costants.grid_large) {
                $('.raffle').addClass("show-block");
                if ($('body').hasClass("customer-logged-in")) {
                    if (template != 'product.af1-black') {
                        detectRaffleStatus();
                    }
                } else {
                    appendLogin();
                }
            }
        }
    } else {
        if ($('body').hasClass("template-product")) {
            if ($(window).width() < SlamJam.costants.grid_large) {
                $('.raffle').addClass("show-block");

                if (!$('body').hasClass("customer-logged-in")) {
                    if ($('.add-to-cart-wrapper').hasClass("product-raffle")) {
                        $('#add-to-cart-sticky-wrapper').append($('.raffle.show-block'));
                    }
                }
            }
        }
    }
});

$(document).on('click', '.raffle__container .panel__container div', function (e) {

    if (SlamJam.isMobile(SlamJam.costants.grid_large, false)) {
        var selectedCTA = $(this).attr('data-cta');
        if (!$(this).hasClass("disabled")) {
            $('.raffle-pdp').addClass("active");

            if (selectedCTA == 'raffle-open-milan') {
                $('.personal-id').show();
                $('.raffle.show-block .panel .left, .raffle.show-block .panel .right').removeClass("disabled");
                $('body').addClass("add-to-cart-disabled");
                $('.raffle-pdp__container .add-to-cart-btn-wrapper:last-of-type').addClass("show-cta").show();
                $('.raffle-pdp__container .add-to-cart-btn-wrapper:first-of-type').removeClass("show-cta").hide();
            }

            if (selectedCTA == 'raffle-open') {
                if (template != "product.af1-black" || template != "product.af1") {
                    $('.personal-id').hide(); //nascondo blocco personalID
                }
                $('.raffle.show-block .panel .left, .raffle.show-block .panel .left').removeClass("disabled");
                $('.raffle-pdp__container .add-to-cart-btn-wrapper:last-of-type').removeClass("show-cta").hide();
                $('.raffle-pdp__container .add-to-cart-btn-wrapper:first-of-type').addClass("show-cta").show();
            }
        }
    }
});